<span id="openModal" data-bs-target="#importmodalopen" data-bs-toggle="modal"></span>
<div class="modal fade modalbackgrod" id="importmodalopen" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-fullscreen px-5" role="document">
        <div class="modal-content">
            <div class="modal-header" style="display: block !important;">
                <div class="row">
                    <div class="col-lg-7 col-md-6 col-sm-12">
                        <h5 class="modal-title font-header" id="exampleModalLabel">Service Delivery Plan</h5>
              
                    </div>
                    <div class="col-lg-1 col-md-2 col-sm-3 m-1 ">
                        <button class="btn blue-btn btn-sm mr-1" type="button" *ngIf="serviceplanImportBO.id =='00000000-0000-0000-0000-000000000000'"
                        [disabled]="logintype =='onboardLogin'"     
                        (click)="ClearServicePlanform()">
                       Clear Form
                    </button>                    
                    <button class="btn blue-btn btn-sm mr-1  " type="button"   *ngIf="serviceplanImportBO.id !='00000000-0000-0000-0000-000000000000'"
                     (click)="Download()">
                        Download</button>
                    </div>
                    <!-- <div class="col-lg-1">
                        <button class="btn blue-btn btn-sm mr-1" type="button" 
                                               
                        (click)="RecalculateBudgetAmt()">
                       Recalculate
                    </button>
                    </div> -->
                    <div class="col-lg-1 col-md-2 col-sm-3 m-1  " *ngIf="servicePlan.copy!=true">
                        <button class="btn blue-btn btn-sm mr-1" type="button"  
                                   
                        (click)="checkdate()">
                        <span *ngIf="serviceplanImportBO.id =='00000000-0000-0000-0000-000000000000'">
                            Save
                        </span><span
                            *ngIf="serviceplanImportBO.id !='00000000-0000-0000-0000-000000000000'">
                            Update</span>
                    </button>
                    </div>

                    <div class="col-lg-1 col-md-2 col-sm-3 m-1  "  *ngIf="servicePlan.copy==true">
                        <button class="btn blue-btn btn-sm mr-1" type="button" 
                                   
                        (click)="checkdate()">
                       Copy & Close
                    </button>
                    </div>

                    <div class="col-lg-1 col-md-2 col-sm-3 m-1  "   *ngIf="serviceplanImportBO.id !='00000000-0000-0000-0000-000000000000' && logintype !='onboardLogin'">
                       
                        <button *ngIf="!isevent" class="btn blue-btn btn-sm mr-1" type="button" [disabled]="eventdisable"
                        (click)="checkvalidation()" data-bs-toggle="modal" data-bs-target="#createevent">
                        Create Events</button>
                        <button *ngIf="isevent" class="btn blue-btn btn-sm mr-1" type="button" 
                         (click)="sendEventdata();viewevent=true;">
                        Manage Events</button>
                    </div>
                    
                    <div class="col-lg-1 col-md-2 col-sm-3 m-1  ">
                       
                        <button class="btn blue-btn btn-sm mr-1" type="button"
                         (click)=SDPvaluechange()>
                        Close</button>
                    </div>
                    
                </div>
              
                 <!-- [disabled]="( !budgetform.valid || budgetPlan.isDisable)"   *ngIf="this.global.LoginUserType != 'Onboard'"-->
               

            
                
            </div>
        

                <div class="modal-body">
                    <div class="row mb-2">
    
                        <div class="col-lg-12">
                            <div class="card">
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div class="card-body">
                                            <div class="row">
                                                <img src="./assets/img/SDP0226New.jpg" width="90%" />
                                            </div>
    
                                            <div class="row" style="margin-top: 16px;">
                                                <p class="f">People using Community First Services and Supports (CFSS) must
                                                    write a service plan and can use this template to
                                                    ensure they include all required elements.
                                                    <br> <br>
                                                    You can ask your consultation services provider for help if you want.
                                                    When you complete this plan, submit it to your
                                                    consultation services provider for approval. Your consultation services
                                                    provider will instruct you on how their
                                                    business receives plans.
                                                </p>
                                            </div>
    
                                            <div class="row">
                                                <div class="col-lg-3 col-md-3 col-sm-3 no-gutters">
                                                    <label class="label text-center">
                                                        Plan Date <sup class="super-script">&nbsp;*&nbsp;</sup></label>
                                                    <my-date-picker [options]="myDatePickerOptions"
                                                        [selDate]="serviceplanImportBO.plandate" placeholder="mm/dd/yyyy"
                                                        (inputFieldChanged)="newdates($event,'inputchage','plandate');"
                                                        (dateChanged)="newdates($event,'datechagned','plandate')" [disabled]="logintype =='onboardLogin'"   >
    
                                                    </my-date-picker>
                                                </div>
                                                <div class="col-lg-4 col-md-4 col-sm-4 no-gutters">
                                                    <label class="label text-center"><b>VERSION:</b> Is this version a new
                                                        plan or a revised plan? <sup class="super-script">&nbsp;*&nbsp;</sup></label>
                                                    <div class="b4 mt-1">
                                                        <input type="radio" class="ml-2" name="statusversion" [value]="'New'"
                                                            [(ngModel)]="serviceplanImportBO.version"  (ngModelChange)="EventButtonDisable()" [disabled]="logintype =='onboardLogin'"(change)="changefunction()" /> New &nbsp;
                                                        <input type="radio" class="ml-2" name="statusversion" [value]="'Revised'"
                                                            [(ngModel)]="serviceplanImportBO.version"  (ngModelChange)="EventButtonDisable()" [disabled]="logintype =='onboardLogin'"(change)="changefunction()" />Revised &nbsp;
                                                    </div>
    
                                                </div>
                                                <div class="col-lg-5 col-md-5 col-sm-5 ">
                                                    <label class="label text-center">
                                                        This plan cover the time period from <sup
                                                            class="super-script">&nbsp;*&nbsp;</sup></label>
                                                    <my-date-picker [options]="myDatePickerOptions"
                                                        [selDate]="serviceplanImportBO.startdate" placeholder="mm/dd/yyyy"
                                                        (inputFieldChanged)="newdates($event,'inputchage','startdate')"
                                                        (dateChanged)="newdates($event,'datechagned','startdate')" [disabled]="logintype =='onboardLogin'">
    
                                                    </my-date-picker> &nbsp; to &nbsp;
                                                    <my-date-picker [options]="myDatePickerOptions"
                                                        [selDate]="serviceplanImportBO.enddate" placeholder="mm/dd/yyyy"
                                                        (inputFieldChanged)="newdates($event,'inputchage','enddate')"
                                                        (dateChanged)="newdates($event,'datechagned','enddate')" [disabled]="logintype =='onboardLogin'">
    
                                                    </my-date-picker>
                                                </div>
                                                <!-- REVISIONS SECTION -->
<div class="row mt-3"
[hidden]="serviceplanImportBO?.version !== 'Revised'">
    <div class="col-lg-12">

        <h4 class="font-header"><b>Revisions</b></h4>

        <!-- Revision Date -->
        <div class="row align-items-center mt-2">
            <div class="col-lg-2">
                <label class="label mb-0">
                  <strong>Revision date:</strong>  
                </label>
            </div>
            <div class="col-lg-3">
                <my-date-picker
                    [options]="myDatePickerOptions"
                    [selDate]="serviceplanImportBO?.revisionDate"
                    placeholder="mm/dd/yyyy"
                    (inputFieldChanged)="newdates($event,'inputchage','revisionDate')"
                    (dateChanged)="newdates($event,'datechagned','revisionDate')"
                    [disabled]="logintype === 'onboardLogin'">
                </my-date-picker>
            </div>
        </div>

        <!-- Revision Type -->
        <div class="row mt-3">
            <div class="col-lg-12">
                <label class="label font-weight-bold"><strong>Revision type:</strong> </label>
            </div>

            <div class="col-lg-6 mt-2">
                <div class="form-check">
                    <input type="checkbox"  id="participantRepresentativeId"
                        [(ngModel)]="serviceplanImportBO.revisionTypes.participantRepresentative"
                        (change)="changefunction()"
                        [disabled]="logintype === 'onboardLogin'">
                    <label class="form-check-label">
                        Changing participant's representative
                    </label>
                </div>

                <div class="form-check mt-2">
                    <input type="checkbox" id="goodsAndServicesId"
                        [(ngModel)]="serviceplanImportBO.revisionTypes.goodsAndServices"
                        (change)="changefunction()"
                        [disabled]="logintype === 'onboardLogin'">
                    <label class="form-check-label">
                        Goods and services
                    </label>
                </div>
            </div>

            <div class="col-lg-6 mt-2">
                <div class="form-check">
                    <input type="checkbox"  id="perseId"
                        [(ngModel)]="serviceplanImportBO.revisionTypes.pers"
                        (change)="changefunction()"
                        [disabled]="logintype === 'onboardLogin'">
                    <label class="form-check-label">
                        Personal emergency response systems (PERS)
                    </label>
                </div>

                <div class="form-check mt-2">
                    <input type="checkbox"  id="workerTrainingId"
                        [(ngModel)]="serviceplanImportBO.revisionTypes.workerTraining"
                        (change)="changefunction()"
                        [disabled]="logintype === 'onboardLogin'">
                    <label class="form-check-label">
                        Worker training and development classes (budget model only)
                    </label>
                </div>

                <div class="form-check mt-2">
                    <input type="checkbox"   id="changingProvidersId"
                        [(ngModel)]="serviceplanImportBO.revisionTypes.changingProviders"
                        (change)="changefunction()"
                        [disabled]="logintype === 'onboardLogin'">
                    <label class="form-check-label">
                        Changing provider(s)
                    </label>
                </div>
            </div>
        </div>

        <!-- Provider Change Type -->
        <div class="row mt-4"
             *ngIf="serviceplanImportBO?.revisionTypes.changingProviders">
            <div class="col-lg-12">
                <label class="label font-weight-bold"> <strong> PROVIDER CHANGE TYPE :</strong> </label>
            </div>

            <div class="col-lg-6 mt-2">
                <div class="form-check">
                    <input type="checkbox"  id="consultationServicesProviderId"
                        [(ngModel)]="serviceplanImportBO.providerChangeTypes.consultationServicesProvider"
                        (change)="changefunction()"
                        [disabled]="logintype === 'onboardLogin'">
                    <label class="form-check-label">
                        Consultation services provider
                    </label>
                </div>

                <div class="form-check mt-2">
                    <input type="checkbox"   id="cfssProviderAgencyId"
                        [(ngModel)]="serviceplanImportBO.providerChangeTypes.cfssProviderAgency"
                        (change)="changefunction()"
                        [disabled]="logintype === 'onboardLogin'">
                    <label class="form-check-label">
                        CFSS provider agency
                    </label>
                </div>
            </div>

            <div class="col-lg-6 mt-2">
                <div class="form-check">
                    <input type="checkbox"   id="persProviderId"
                        [(ngModel)]="serviceplanImportBO.providerChangeTypes.persProvider"
                        (change)="changefunction()"
                        [disabled]="logintype === 'onboardLogin'">
                    <label class="form-check-label">
                        PERS provider
                    </label>
                </div>

                <div class="form-check mt-2">
                    <input type="checkbox"   id="fmsProviderId"
                        [(ngModel)]="serviceplanImportBO.providerChangeTypes.fmsProvider"
                        (change)="changefunction()"
                        [disabled]="logintype === 'onboardLogin'">
                    <label class="form-check-label">
                        Financial management services (FMS) provider
                    </label>
                </div>
            </div>
        </div>

        <!-- Summary of Changes -->
        <div class="row mt-4">
            <div class="col-lg-12">
                <label class="label font-weight-bold">SUMMARY OF CHANGES:</label>
                <textarea class="form-control mt-2"
                          rows="8"
                          [(ngModel)]="serviceplanImportBO.summaryOfChanges"
                          (change)="changefunction()"
                          [disabled]="logintype === 'onboardLogin'">
                </textarea>
            </div>
        </div>

    </div>
</div>

                                            <div class="row">
                                                <h3 class=" font-header" id="exampleModalLabel"><b>Your Information</b></h3>
                                            </div>
                                            <div class="card mt-3">
                                                <div class="card-body">
    
                                                    <div class="row">
                                                        <div class="col">
                                                            <h4>Contact Information</h4>
                                                        </div>
    
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-lg-3">
                                                            <label class="label">First Name</label>
                                                            <input class="form-control" type="text" 
                                                                [(ngModel)]="serviceplanImportBO.clientInfoFirstName" [disabled]="logintype =='onboardLogin'" (change)="changefunction()">
                                                        </div>
                                                        <div class="col-lg-1">
                                                            <label class="label">MI</label>
                                                            <input class="form-control" type="text" 
                                                                [(ngModel)]="serviceplanImportBO.clientInfoMiName" [disabled]="logintype =='onboardLogin'" (change)="changefunction()">
                                                        </div>
                                                        <div class="col-lg-2">
                                                            <label class="label">LastName</label>
                                                            <input class="form-control" type="text" 
                                                                [(ngModel)]="serviceplanImportBO.clientInfoLastName" [disabled]="logintype =='onboardLogin'" (change)="changefunction()">
                                                        </div>
                                                        <div class="col-lg-2">
                                                            <label class="label">PMI</label>
                                                            <input class="form-control" type="text" 
                                                                [(ngModel)]="serviceplanImportBO.clientInfoPmi" [disabled]="logintype =='onboardLogin'" (change)="changefunction()">
                                                        </div>
                                                        <div class="col-lg-3">
                                                            <label class="label">Date of Birth</label>
                                                            <div></div>
                                                            <my-date-picker class="w-100" 
                                                                [options]="myDatePickerOptions"
                                                                [selDate]="serviceplanImportBO.clientInfoDob" placeholder="mm/dd/yyyy"
                                                                (inputFieldChanged)="newdates($event,'inputchage','dob')"
                                                                (dateChanged)="newdates($event,'datechagned','dob')" [disabled]="logintype =='onboardLogin'">
                                                            </my-date-picker>
                                                            <!-- <span class="req" *ngIf="validform1.controls['persondate'].invalid && serviceplanImportBO.dob!=null && serviceplanImportBO.dob!=undefined && serviceplanImportBO.dob!=''">
    
                                                    Please enter valid date and time
                                   
                                                </span> -->
                                                        </div>
                                                        <div class="col-lg-1">
                                                            <label class="label">Age (years)</label>
                                                            <input class="form-control" type="text" 
                                                                [(ngModel)]="serviceplanImportBO.clientInfoAge" [disabled]="logintype =='onboardLogin'" (change)="changefunction()">
                                                        </div>
    
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-lg-4">
                                                            <label class="label">Street Address</label>
                                                            <textarea class="form-control" type="text" (change)="changefunction()"
                                                                [(ngModel)]="serviceplanImportBO.clientInfoStreet" [disabled]="logintype =='onboardLogin'"></textarea>
                                                        </div>
                                                        <div class="col-lg-3">
                                                            <label class="label">City</label>
                                                            <input class="form-control" type="text" 
                                                                [(ngModel)]="serviceplanImportBO.clientInfoCity" [disabled]="logintype =='onboardLogin'" (change)="changefunction()">
                                                        </div>
                                                        <div class="col-lg-1">
                                                            <label class="label">State</label>
                                                            <input class="form-control" type="text" 
                                                                [(ngModel)]="serviceplanImportBO.clientInfoState" [disabled]="logintype =='onboardLogin'" (change)="changefunction()">
    
    
                                                        </div>
                                                        <div class="col-lg-2">
                                                            <label class="label">Zip</label>
                                                            <input class="form-control" type="text" 
                                                                [(ngModel)]="serviceplanImportBO.clientInfoZip"
                                                                (keypress)="keyPress($event)" maxlength="11" minlength="5" [disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                               >
                                                            <!-- <span class="req"
                                                        *ngIf="validform.controls['Personzip'].invalid">
                                                        <p>*Enter Valid zip, Enter 5 to 10 digits</p>
                                                    </span> -->
                                                        </div>
                                                        <div class="col-lg-2">
                                                            <label class="label">County</label>
                                                            <input class="form-control" type="text" 
                                                                [(ngModel)]="serviceplanImportBO.clientInfoCounty" [disabled]="logintype =='onboardLogin'" (change)="changefunction()">
    
    
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-lg-8">
                                                            <label class="label">Email Address</label>
                                                            <input class="form-control" type="text" 
                                                                [(ngModel)]="serviceplanImportBO.clientInfoEmail" [disabled]="logintype =='onboardLogin'" (change)="changefunction()">
    
                                                        </div>
                                                        <div class="col-lg-4" [formGroup]="validform">
                                                            <label class="label">Preferred Phone Number</label>
                                                            <input class="form-control" type="text" [disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                                [(ngModel)]="serviceplanImportBO.clientInfoPhone"
                                                                (ngModelChange)="DemographicPhoneFormat('phone')"
                                                                [attr.disabled]="logintype === 'onboardLogin' ? true : null"
                                                                (keypress)="keyPress($event)" maxlength="14" minlength="14"
                                                                formControlName="Personphn" 
                                                                formControlName="clientphn">
                                                            <span class="req"
                                                        *ngIf="validform.controls['clientphn'].invalid">
                                                        <p>*Enter Valid phone, Enter 10 digit</p>
                                                    </span>
                                                        </div>
    
                                                    </div>
    
    
                                                </div>
    
    
                                            </div>
    
                                            <div class="row mt-1">
                                                <h4 class=" font-header" id="exampleModalLabel"><b>Participant's
                                                        representative
                                                    </b></h4>
                                                <p class="f">Some people cannot direct their own care. They may need
                                                    another person to direct their care. During your
                                                    assessment, your assessor determined if you can direct your own care.
                                                    Answer according to that (if you are unsure,
                                                    ask your consultation services provider).</p>
                                            </div>
    
                                            <div class="row mt-1">
                                                <label class="label  col-lg-3">
                                                    Do you direct your own care? </label>
                                                <div class="col-lg-4 mt-1 ">
                                                    <input type="radio" class="ml-2" name="owncare" [value]="true"
                                                        [(ngModel)]="serviceplanImportBO.directOwnCare"  [disabled]="logintype =='onboardLogin'" (change)="changefunction()"/> Yes &nbsp;
                                                    <input type="radio" class="ml-2" name="owncare" [value]="false"
                                                        [(ngModel)]="serviceplanImportBO.directOwnCare" [disabled]="logintype =='onboardLogin'" (change)="changefunction()"  />No &nbsp;
                                                </div>
    
                                            </div>
    
    
                                            <div class="card mt-3" *ngIf="serviceplanImportBO.directOwnCare == false">
                                                <div class="row">
                                                    <div class="col">
                                                        <h4>Participant's representative</h4>
                                                    </div>
    
                                                </div>
                                                <div id="goalaccordion" class="col-lg-12"
                                                    *ngFor="let item of serviceplanImportBO.participantRepresentative;let goal1=index">
    
                                                    <div class="card-body">
                                                        <div class="row mt-1">
                                                            <div class="col-lg-8">
    
                                                            </div>
    
                                                            <div class="col-lg-4 text-right">
    
                                                                <i (click)="logintype !== 'onboardLogin' &&Createparent(goal1)" style="font-size:25px"
                                                                    *ngIf="!item.isadd"  [disabled]="logintype =='onboardLogin'"
                                                                    class="fa fa-plus-circle text-primary"></i>&nbsp;&nbsp;
    
    
                                                                <i *ngIf="goal1 != 0" (click)="logintype !== 'onboardLogin' &&removeparent(goal1,item);"
                                                                    style="font-size:22px" [disabled]="logintype =='onboardLogin'"
                                                                    class="fa fa-trash text-danger"></i>
                                                            </div>
    
                                                        </div>
    
                                                        <div class="row">
                                                            <div class="col-lg-3">
                                                                <label class="label">First Name</label>
                                                                <input class="form-control" type="text" 
                                                                    [(ngModel)]="item.firstName" [disabled]="logintype =='onboardLogin'" (change)="changefunction()">
                                                            </div>
    
                                                            <div class="col-lg-3">
                                                                <label class="label">LastName</label>
                                                                <input class="form-control" type="text" 
                                                                    [(ngModel)]="item.lastName" [disabled]="logintype =='onboardLogin'" (change)="changefunction()">
                                                            </div>
                                                            <div class="col-lg-6">
                                                                <label class="label">Email</label>
                                                                <input class="form-control" type="text" 
                                                                    [(ngModel)]="item.email" [disabled]="logintype =='onboardLogin'" (change)="changefunction()">
                                                            </div>
    
    
    
                                                        </div>
                                                        <div class="row">
                                                            <div class="col-lg-3">
                                                                <label class="label">Street Address</label>
                                                                <textarea class="form-control" type="text" 
                                                                    [(ngModel)]="item.address" [disabled]="logintype =='onboardLogin'" (change)="changefunction()"></textarea>
                                                            </div>
                                                            <div class="col-lg-2">
                                                                <label class="label">City</label>
                                                                <input class="form-control" type="text" 
                                                                    [(ngModel)]="item.city" [disabled]="logintype =='onboardLogin'" (change)="changefunction()">
                                                            </div>
                                                            <div class="col-lg-2">
                                                                <label class="label">State</label>
                                                                
                                                                    <ng-select [items]="stateList" id="state" class="w-100 "
                                                                    [searchable]="true" 
                                                                    [(ngModel)]="item.state" [clearable]="true"
                                                                    bindLabel="name" bindValue="abbreviation" [disabled]="logintype =='onboardLogin'" (change)="changefunction()">
                                                                </ng-select>
    
    
                                                            </div>
                                                            <div class="col-lg-2">
                                                                <label class="label">Zip</label>
                                                                <input class="form-control" type="text" 
                                                                    [(ngModel)]="item.zipCode" (keypress)="keyPress($event)"
                                                                    maxlength="11" minlength="5" (ngModelChange)="validchangeParticipantZip(goal1,item)" [disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                                  >
                                                                <!-- <span class="req"
                                                                                        *ngIf="validform.controls['Personzip'].invalid">
                                                                                        <p>*Enter Valid zip, Enter 5 to 10 digits</p>
                                                                                    </span> -->
                                                            </div>
    
                                                            <div class="col-lg-4" >
                                                                <label class="label">Preferred Phone Number</label>
                                                                <input class="form-control" type="text" 
                                                                    [(ngModel)]="item.phoneNumber" (change)="changefunction()"
                                                                    (ngModelChange)="DemographicPhoneFormatParticipant(item,goal1);validchange_ParicipantPhn(goal1,item)"
                                                                    (keypress)="keyPress($event)" maxlength="14"
                                                                    minlength="14"  [disabled]="logintype =='onboardLogin'">
                                                                    <span class="req"
                                                                    *ngIf="errphone1">{{ParticipantPhnerr[goal1]}}</span>
                                                            </div>
    
    
                                                        </div>
    
    
                                                    </div>
    
    
                                                </div>
                                            </div>
    
                                            <div class="row mt-3">
                                                <h4 class=" font-header" id="exampleModalLabel"><b>Interpreter
                                                    </b></h4>
                                            </div>
                                            <div class="row">
                                                <div class="col-lg-4">
                                                    <label class="label"> What is your preferred language(s)?</label>
                                                </div>
                                                <div class=" col-lg-5">
                                                    <textarea class="form-control" type="text"
                                                        [(ngModel)]="serviceplanImportBO.preferrdLanguages" [disabled]="logintype =='onboardLogin'" (change)="changefunction()">
                                                        </textarea>
                                                </div>
                                            </div>
    
    
                                            <div class="row">
                                                <div class="col-lg-3">
                                                    <label class="label">Do you need/use an interpreter?</label>
                                                </div>
                                                <div class="col-lg-4 mt-1 ">
                                                    <input type="radio" class="ml-2" name="interpreter" [value]="true"
                                                        [(ngModel)]="serviceplanImportBO.needsInterpreter"  [disabled]="logintype =='onboardLogin'" (change)="changefunction()"/> Yes &nbsp;
                                                    <input type="radio" class="ml-2" name="interpreter" [value]="false"
                                                        [(ngModel)]="serviceplanImportBO.needsInterpreter" [disabled]="logintype =='onboardLogin'" (change)="changefunction()" />No &nbsp;
                                                </div>
                                            </div>
    
                                            <div class="row"  *ngIf="serviceplanImportBO.needsInterpreter ==true">
                                                <label class="label"> Whom do you usually use to interpret for you?</label>
                                            </div>
    
                                            <div class="card mt-3" *ngIf="serviceplanImportBO.needsInterpreter ==true">
                                                <div class="row">
                                                    <div class="col">
                                                        <h4>Interpreter </h4>
                                                    </div>
    
                                                </div>
                                                <div id="goalaccordion" class="col-lg-12"
                                                    *ngFor="let item of serviceplanImportBO.interpreters;let goal1=index">
    
                                                    <div class="card-body">
                                                        <div class="row mt-1">
                                                            <div class="col-lg-8">
    
                                                            </div>
    
                                                            <div class="col-lg-4 text-right">
    
                                                                <i (click)="logintype !== 'onboardLogin' &&Createinterpreter(goal1)" style="font-size:25px"
                                                                    *ngIf="!item.isadd"
                                                                    class="fa fa-plus-circle text-primary" [disabled]="logintype =='onboardLogin'"></i>&nbsp;&nbsp;
    
    
                                                                <i *ngIf="goal1 != 0"
                                                                    (click)="logintype !== 'onboardLogin' &&removeinterpreter(goal1,item);"
                                                                    style="font-size:22px"
                                                                    class="fa fa-trash text-danger" [disabled]="logintype =='onboardLogin'"></i>
                                                            </div>
    
                                                        </div>
    
                                                        <div class="row">
                                                            <div class="col-lg-5">
                                                                <label class="label">Name</label>
                                                                <input class="form-control" type="text" 
                                                                    [(ngModel)]="item.name" [disabled]="logintype =='onboardLogin'" (change)="changefunction()">
                                                            </div>
    
                                                            <div class="col-lg-4">
                                                                <label class="label">Relationship to you</label>
                                                                <input class="form-control" type="text" 
                                                                    [(ngModel)]="item.relationShip" [disabled]="logintype =='onboardLogin'" (change)="changefunction()">
                                                            </div>
                                                            <div class="col-lg-3">
                                                                <label class="label">Preferred Phone Number</label>
                                                                <input class="form-control" type="text" 
                                                                    [(ngModel)]="item.phonenumer"
                                                                    (ngModelChange)="DemographicPhoneFormatInterpreter(item,goal1);validchange_InterpreterPhn(goal1,item)"
                                                                    (keypress)="keyPress($event)" maxlength="14" (change)="changefunction()"
                                                                    minlength="14"  [disabled]="logintype =='onboardLogin'">
                                                                    <span class="req"
                                                                    *ngIf="errphone1">{{InterpreterPhnerr[goal1]}}</span>
                                                            </div>
    
    
    
    
                                                        </div>
    
    
                                                    </div>
    
    
                                                </div>
                                            </div>
                                            <div class="row mt-3">
                                                <h4 class=" font-header" id="exampleModalLabel"><b>About You
                                                    </b></h4>
                                            </div>
                                            <div class="row">
                                                <label class="label">Your assessment results might already have answers to
                                                    these question. You can use those answers if you'd like.</label>
                                            </div>
                                            <div class="card mt-3">
    
                                                <div class="card-body">
                                                    <div class="row">
                                                        <label class="label">What are your strengths and
                                                            preferences?</label>
                                                        <textarea rows="7" class="form-control" cols="190"
                                                            [(ngModel)]="serviceplanImportBO.aboutyou" [disabled]="logintype =='onboardLogin'" (change)="changefunction()"></textarea>
                                                    </div>
                                                    <div class="row">
                                                        <label class="label">What are your goals and preferred
                                                            outcomes?</label>
                                                        <textarea rows="7" class="form-control" cols="190"
                                                            [(ngModel)]="serviceplanImportBO.prefferd_Outcomes" [disabled]="logintype =='onboardLogin'" (change)="changefunction()"></textarea>
                                                    </div>
                                                    <div class="row">
                                                        <label class="label">Is there anything you'd like your providers
                                                            and/or workers to know about you?
    
                                                        </label>
                                                        <textarea rows="7" class="form-control" cols="190"
                                                            [(ngModel)]="serviceplanImportBO.additionalInformation" [disabled]="logintype =='onboardLogin'" (change)="changefunction()"></textarea>
                                                    </div>
                                                </div>
                                            </div>
    
                                            <div class="row mt-3">
                                                <h4 class=" font-header" id="exampleModalLabel"><b> Your Plan
                                                    </b></h4>
                                            </div>
                                            <div class="row">
                                                <div class="col-lg-5"> <label class="label"> Is your service plan for a full
                                                        year?</label></div>
                                                <div class="col-lg-4 mt-1 ">
                                                    <input type="radio" class="ml-2" name="plan" [value]="true"
                                                        [(ngModel)]="serviceplanImportBO.isFullYearPlan"  [disabled]="logintype =='onboardLogin'" (change)="changefunction()"/> Yes &nbsp;
                                                    <input type="radio" class="ml-2" name="plan" [value]="false"
                                                        [(ngModel)]="serviceplanImportBO.isFullYearPlan" [disabled]="logintype =='onboardLogin'" (change)="changefunction()" />No &nbsp;
                                                </div>
                                            </div>
                                             <div class="row mt-3">
                                                <h4 class=" font-header" id="exampleModalLabel"><b>CFSS Units
                                                    </b></h4>
                                            </div>
                                            <div class="row">
                                                <div class="col-lg-5"> <label class="label">How many total estimated CFSS units are
                                                        you eligible for in this service plan?<sup class="super-script">&nbsp;*&nbsp;</sup></label></div>
    
                                                <div class=" col-lg-3">
                                                    <input class="form-control" type="text"
                                                        [(ngModel)]="serviceplanImportBO.totalCFSSUnitsEligible" (ngModelChange)="calculateBudgetAmt()" [disabled]="logintype =='onboardLogin'" (keypress)="keyPress($event)" (change)="changefunction()" >
                                                </div>
                                            </div>

                                            <div class="row mt-3">
                                                <p><b>Note: </b>Your lead agency might need to adjust this amount based on the dates of your final service agreement.</p>
                                            </div>
    
                                            <div class="row mt-3">
                                                <h4 class=" font-header" id="exampleModalLabel"><b> Enhanced rate
                                                    </b></h4>
                                            </div>
                                            <div class="row">
                                                <div class="col-lg-5"> <label class="label">Are you eligible for an enhanced
                                                        rate?</label></div>
                                                <div class="col-lg-4 mt-1 ">
                                                    <input type="radio" class="ml-2" name="enhancerate" [value]="true" [disabled]="logintype =='onboardLogin'"
                                                        [(ngModel)]="serviceplanImportBO.isEnhancedrate"  (ngModelChange)="calculateBudgetAmt()" (change)="changefunction()"/> Yes &nbsp;
                                                    <input type="radio" class="ml-2" name="enhancerate" [value]="false" [disabled]="logintype =='onboardLogin'"
                                                        [(ngModel)]="serviceplanImportBO.isEnhancedrate" (ngModelChange)="calculateBudgetAmt()" (change)="changefunction()" />No &nbsp;
                                                </div>
                                            </div>
    
                                            <div class="row mt-2">
                                                <p><b>Note: </b> Your assessment results states if you are eligible for the
                                                    enhanced rate. If you are unsure, your consultation services provider
                                                    can help you
                                                    find this information.</p>
                                            </div>
    
                                            <div class="row mt-3">
                                                <h4 class=" font-header" id="exampleModalLabel"><b> Consultation Service
                                                        provider
                                                    </b></h4>
                                            </div>
    
                                            <div class="card mt-3">
                                                <div class="card-body">
    
                                                    <div class="row">
                                                        <div class="col">
                                                            <h4>Contact Information</h4>
                                                        </div>
    
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-lg-5">
                                                            <label class="label">Name</label>
                                                            <input class="form-control" type="text"  [disabled]="logintype =='onboardLogin'"
                                                                [(ngModel)]="serviceplanImportBO.consultantInfoName" (change)="changefunction()">
                                                        </div>
                                                        <!-- <div class="col-lg-3">
                                                            <label class="label">NPI</label>
                                                            <input class="form-control" type="text"  [disabled]="logintype =='onboardLogin'"
                                                            [attr.disabled]="logintype === 'onboardLogin' ? true : null"
                                                                [(ngModel)]="serviceplanImportBO.consultantInfoPmi">
                                                        </div> -->
                                                        <div class="col-lg-4" [formGroup]="validform">
                                                            <label class="label">Phone Number</label>
                                                            <input class="form-control" type="text"  [disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                                [(ngModel)]="serviceplanImportBO.consultantInfoPhone"
                                                                (ngModelChange)="DemographicPhoneFormat('agencyphone')"
                                                                [attr.disabled]="logintype === 'onboardLogin' ? true : null"
                                                                (keypress)="keyPress($event)" maxlength="14" minlength="14"
                                                                formControlName="Agencyphn">
                                                                <span class="req"
                                                                *ngIf="validform.controls['Agencyphn'].invalid">
                                                                <p>*Enter Valid phone, Enter 10 digit</p>
                                                            </span>
                                                        </div>
    
    
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-lg-4">
                                                            <label class="label">Street Address</label>
                                                            <textarea class="form-control" type="text"  [disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                                [(ngModel)]="serviceplanImportBO.consultantInfoStreet"></textarea>
                                                        </div>
                                                        <div class="col-lg-3">
                                                            <label class="label">City</label>
                                                            <input class="form-control" type="text"  [disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                                [(ngModel)]="serviceplanImportBO.consultantInfoCity">
                                                        </div>
                                                        <div class="col-lg-2">
                                                            <label class="label">State</label>
                                                            <input class="form-control" type="text"  [disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                                [(ngModel)]="serviceplanImportBO.consultantInfoState">
    
    
                                                        </div>
                                                        <div class="col-lg-3" [formGroup]="validform">
                                                            <label class="label">Zip</label>
                                                            <input class="form-control" type="text" [disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                                [(ngModel)]="serviceplanImportBO.consultantInfoZip"
                                                                [attr.disabled]="logintype === 'onboardLogin' ? true : null"
                                                                (keypress)="keyPress($event)" maxlength="11" minlength="5"
                                                                formControlName="Agencyzip">
                                                            <span class="req"
                                                                                *ngIf="validform.controls['Agencyzip'].invalid">
                                                                                <p>*Enter Valid zip, Enter 5 to 10 digits</p>
                                                                            </span>
                                                        </div>
    
    
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-lg-3">
                                                            <label class="label">Contact Name</label>
                                                            <input class="form-control" type="text" [disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                                [(ngModel)]="serviceplanImportBO.consultantInfoContactName">
    
    
                                                        </div>
                                                        <div class="col-lg-6">
                                                            <label class="label">Email Address</label>
                                                            <input class="form-control" type="text" [disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                                [(ngModel)]="serviceplanImportBO.consultantInfoEmail">
    
                                                        </div>
                                                        <div class="col-lg-3" [formGroup]="validform">
                                                            <label class="label">Fax Number</label>
                                                            <input class="form-control" type="text" [disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                                [(ngModel)]="serviceplanImportBO.consultantInfoFax"
                                                                (ngModelChange)="DemographicPhoneFormat('agencyfax')"
                                                                [attr.disabled]="logintype === 'onboardLogin' ? true : null"
                                                                (keypress)="keyPress($event)" maxlength="14" minlength="14"
                                                                formControlName="Agencyfax">
                                                            <span class="req"
                                                                                *ngIf="validform.controls['Agencyfax'].invalid">
                                                                                <p>*Enter Valid phone, Enter 10 digit</p>
                                                                            </span>
                                                        </div>
    
                                                    </div>
    
    
                                                </div>
    
    
                                            </div>
    
                                            <div class="row mt-3">
                                                <h4 class=" font-header" id="exampleModalLabel"><b>Program Information
                                                    </b></h4>
                                            </div>
    
                                            <div class="row">
                                                <div class="col-lg-4"> <label class="label">Are you 65 years old or
                                                        older?</label></div>
                                                <div class="col-lg-4 mt-1 ">
                                                    <input type="radio" class="ml-2" name="years" [value]="true"[disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                        [(ngModel)]="serviceplanImportBO.is65OrOlder" /> Yes &nbsp;
                                                    <input type="radio" class="ml-2" name="years" [value]="false"[disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                        [(ngModel)]="serviceplanImportBO.is65OrOlder" />No &nbsp;
                                                </div>
                                            </div>
                                             <div class="row mt-3">
                                                <h4 class=" font-header" id="exampleModalLabel"><b>Waivers
                                                    </b></h4>
                                            </div>
                                            <div class="row mt-1">
                                                <div class="col-lg-4"> <label class="label">Do you use one of the following
                                                        waivers or programs?</label></div>
                                                <div class="col-lg-4 mt-1 ">
                                                    <input type="radio" class="ml-2" name="waivers" [value]="true"[disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                        [(ngModel)]="serviceplanImportBO.usesWaiverOrProgram" (ngModelChange)="serviceplanImportBO.typeOfWaiverOrProgram = null" /> Yes &nbsp;
                                                    <input type="radio" class="ml-2" name="waivers" [value]="false"[disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                        [(ngModel)]="serviceplanImportBO.usesWaiverOrProgram" (ngModelChange)="serviceplanImportBO.typeOfWaiverOrProgram = null" />No &nbsp;
                                                </div>
                                            </div>
                                            <div class="row mt-1">
                                                <ul style="margin-left:30px">   
                                                    <li>Alternative Care (AC) program</li>
                                                    <li>
                                                        Brain Injury (BI) Waiver
    
                                                    </li>
                                                    <li>Community Alternative Care (CAC) Waiver</li>
                                                    <li>Community Access for Disability Inclusion (CADI) Waiver</li>
                                                    <li>Developmental Disabilities (DD) Waiver</li>
                                                    <li>Elderly Waiver (EW)</li>
                                                </ul>
                                            </div>
                                            <div *ngIf=" serviceplanImportBO.usesWaiverOrProgram ==true">
                                                <label class="label">Which waiver/program?</label>
                                                <div class="row mt-1">
                                                    <div class="col-lg-6 mt-1 ">
                                                        <input type="radio" class="me-1" name="typeOfWaiverOrProgram" value="AC" [(ngModel)]="serviceplanImportBO.typeOfWaiverOrProgram" [disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                           /> AC &nbsp;
                                                        <input type="radio" class="me-1" name="typeOfWaiverOrProgram" value="BI" [(ngModel)]="serviceplanImportBO.typeOfWaiverOrProgram" [disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                             />BI &nbsp;
                                                        <input type="radio" class="me-1" name="typeOfWaiverOrProgram" value="CAC" [(ngModel)]="serviceplanImportBO.typeOfWaiverOrProgram" [disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                             />CAC &nbsp;
                                                        <input type="radio" class="me-1" name="typeOfWaiverOrProgram" value="CADI" [(ngModel)]="serviceplanImportBO.typeOfWaiverOrProgram" [disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                             />CADI &nbsp;
                                                        <input type="radio" class="me-1" name="typeOfWaiverOrProgram" value="DD" [(ngModel)]="serviceplanImportBO.typeOfWaiverOrProgram" [disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                             />DD &nbsp;
                                                        <input type="radio" class="me-1" name="typeOfWaiverOrProgram" value="EW" [(ngModel)]="serviceplanImportBO.typeOfWaiverOrProgram" [disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                             />EW &nbsp;
                                                    </div>
                                                </div>
                                            </div>
    
                                            <div class="card mt-3" *ngIf="serviceplanImportBO.is65OrOlder == true || serviceplanImportBO.usesWaiverOrProgram ==true ">
                                                <div class="row">
                                                    <div class="col">
                                                        <h4>Case Manager/Care Coordinator</h4>
                                                    </div>
    
                                                </div>
                                                <div id="goalaccordion" class="col-lg-12"
                                                    *ngFor="let item of serviceplanImportBO.careCoordinator;let goal1=index">
    
                                                    <div class="card-body">
                                                        <div class="row mt-1">
                                                            <div class="col-lg-8">
    
                                                            </div>
    
                                                            <div class="col-lg-4 text-right">
    
                                                                <i (click)="logintype !== 'onboardLogin' &&Createcarecoordinator(goal1)"[disabled]="logintype =='onboardLogin'"
                                                                    style="font-size:25px" *ngIf="!item.isadd"
                                                                    class="fa fa-plus-circle text-primary"></i>&nbsp;&nbsp;
    
    
                                                                <i *ngIf="goal1 != 0"[disabled]="logintype =='onboardLogin'"
                                                                    (click)="logintype !== 'onboardLogin' &&removecarecoordinatoe(goal1,item);"
                                                                    style="font-size:22px"
                                                                    class="fa fa-trash text-danger"></i>
                                                            </div>
    
                                                        </div>
    
                                                        <div class="row">
                                                            <div class="col-lg-8">
                                                                <label class="label">Name</label>
                                                                <input class="form-control" type="text" [disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                                    [(ngModel)]="item.coordinator_Name">
                                                            </div>
    
                                                            <div class="col-lg-4">
                                                                <label class="label">Phone Number</label>
                                                                <input class="form-control" type="text" 
                                                                    [(ngModel)]="item.phoneNumber" 
                                                                    (ngModelChange)="DemographicPhoneFormatcasemanager(item,goal1,'phone') ;validchange_CasePhn(goal1,item)"
                                                                    (keypress)="keyPress($event)" maxlength="14"[disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                                    minlength="14">
                                                                    <span class="req"
                                                                    *ngIf="errphone1">{{CasePhnerr[goal1]}}</span>
                                                            </div>
    
    
    
    
                                                        </div>
                                                        <div class="row">
                                                            <div class="col-lg-3">
                                                                <label class="label">Street Address</label>
                                                                <textarea class="form-control" type="text" [disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                                    [(ngModel)]="item.street"></textarea>
                                                            </div>
                                                            <div class="col-lg-2">
                                                                <label class="label">City</label>
                                                                <input class="form-control" type="text" [disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                                    [(ngModel)]="item.city">
                                                            </div>
                                                            <div class="col-lg-1">
                                                                <label class="label">State</label>
                                                                  <ng-select [items]="stateList" id="state" class="w-100 "
                                                                    [searchable]="true" [disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                                    [(ngModel)]="item.state" [clearable]="true"
                                                                    bindLabel="name" bindValue="abbreviation">
                                                                </ng-select>
    
    
                                                            </div>
                                                            <div class="col-lg-2">
                                                                <label class="label">Zip</label>
                                                                <input class="form-control" type="text" [disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                                    [(ngModel)]="item.zipCode" (keypress)="keyPress($event)"
                                                                    [attr.disabled]="logintype === 'onboardLogin' ? true : null"
                                                                    maxlength="11" minlength="5" (ngModelChange)="validchangeCaseZip(goal1,item)">
                                                                <!-- <span class="req"
                                                                                    *ngIf="validform.controls['Personzip'].invalid">
                                                                                    <p>*Enter Valid zip, Enter 5 to 10 digits</p>
                                                                                </span> -->
                                                            </div>
    
                                                            <div class="row">
                                                                <div class="col-lg-8">
                                                                    <label class="label">Email Address</label>
                                                                    <input class="form-control" type="text" [disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                                        [(ngModel)]="item.email">
                                                                </div>
    
                                                                <div class="col-lg-4">
                                                                    <label class="label">Fax Number</label>
                                                                    <input class="form-control" type="text" 
                                                                        [(ngModel)]="item.fax"[disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                                        (ngModelChange)="DemographicPhoneFormatcasemanager(item,goal1,'fax');validchange_Casefax(goal1,item)"
                                                                        (keypress)="keyPress($event)" maxlength="14"
                                                                        minlength="14" >
                                                                </div>
                                                            </div>
    
                                                        </div>
    
    
                                                    </div>
    
    
                                                </div>
                                            </div>
                                            <div class="row mt-3">
                                                <h4 class=" font-header" id="exampleModalLabel"><b>CFSS model
                                                    </b></h4>
                                            </div>
                                            <div class="row">
                                                <h6>Which model are you using?</h6>
                                            </div>
                                            <div class="row">
                                                <p><b>Note: </b>Your consultation services provider can help you understand
                                                    the differences between the models. If you are on the Minnesota
                                                    Restricted Recipient Program (MRRP), you must use the agency model.
                                                </p>
                                            </div>
    
                                            <div class="row mt-3">
                                                <div class="col-lg-5 mt-1 ">
                                                    <input type="radio" class="ml-2" name="model" [value]="'BUDGET'"[disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                        [(ngModel)]="serviceplanImportBO.modelTypename"  (ngModelChange)="ModelTypeChange();EventButtonDisable();" /> Budget &nbsp;
                                                    <input type="radio" class="ml-2" name="model" [value]="'AGENCY'" [disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                        [(ngModel)]="serviceplanImportBO.modelTypename" (ngModelChange)="ModelTypeChange();EventButtonDisable();" />Agency &nbsp;
                                                </div>
                                            </div>
                                            <div class="row mt-3" *ngIf="serviceplanImportBO.modelTypename == 'BUDGET'">
                                                <h4 class=" font-header" id="exampleModalLabel"><b>Budget 
                                                    </b></h4>
                                            </div>
    
                                            <div class="row mt-3" *ngIf="serviceplanImportBO.modelTypename == 'BUDGET'">
                                                <div class="col-lg-3">
                                                    <label class="label"> Your budget will be:</label>
                                                </div>
                                                <div class="col-lg-5 mt-1 ">
                                                    <input class="form-control" type="text"  disabled 
                                                        [(ngModel)]="serviceplanImportBO.fmsBudget.budgetAmount">
                                                </div>
                                            </div>
    

                                            
                                            <div class="card mt-3"
                                                *ngIf="serviceplanImportBO.modelTypename == 'BUDGET'">
                                                <div class="card-body">
    
                                                    <div class="row">
                                                        <div class="col">
                                                            <h4>Financial management service (FMS) provider
                                                            </h4>
                                                        </div>
    
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-lg-6">
                                                            <label class="label">Name</label>

                                                            <ng-select [items]="FmsAgencyList" id="FMSProvider.fMSAgencyId" class="w-100 " (change)="onAgencySelected($event)" 
                                                            [searchable]="true" [disabled]="logintype =='onboardLogin'" 
                                                            [(ngModel)]="FMSProvider.fmsAgencyId" [clearable]="true" (clear)="onClear()"
                                                            bindLabel="Value" bindValue="Key" (change)="changefunction()">
                                                        </ng-select>
                                                            <!-- <input class="form-control" type="text" 
                                                                [(ngModel)]="FMSProvider.providerName"> -->
                                                        </div>
                                                        <!-- <div class="col-lg-3">
                                                            <label class="label">NPI</label>
                                                            <input class="form-control" type="text" [disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                            [attr.disabled]="logintype === 'onboardLogin' ? true : null"
                                                                [(ngModel)]="FMSProvider.npi">
                                                        </div> -->
                                                        <div class="col-lg-3"  [formGroup]="validform">
                                                            <label class="label">Phone Number</label>
                                                            <input class="form-control" type="text" 
                                                                [(ngModel)]="FMSProvider.phoneNumber"[disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                                (ngModelChange)="DemographicPhoneFormat('fmsproviderphone')"
                                                                [attr.disabled]="logintype === 'onboardLogin' ? true : null"
                                                                (keypress)="keyPress($event)" maxlength="14" minlength="14"
                                                                formControlName="FmsPhn">
    
                                                                <span class="req"
                                                                *ngIf="validform.controls['FmsPhn'].invalid">
                                                                <p>*Enter Valid zip, Enter 5 to 10 digits</p>
                                                            </span>
    
                                                        </div>
    
    
    
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-lg-4">
                                                            <label class="label">Street Address</label>
                                                            <textarea class="form-control" type="text" [disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                                [(ngModel)]="FMSProvider.address"></textarea>
                                                        </div>
                                                        <div class="col-lg-3">
                                                            <label class="label">City</label>
                                                            <input class="form-control" type="text" [disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                                [(ngModel)]="FMSProvider.city">
                                                        </div>
                                                        <div class="col-lg-2">
                                                            <label class="label">State</label>
                                                           
                                                                <ng-select [items]="stateList" id="state" class="w-100 "
                                                                [searchable]="true" [disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                                [(ngModel)]="FMSProvider.state" [clearable]="true"
                                                                bindLabel="name" bindValue="abbreviation">
                                                            </ng-select>
    
    
                                                        </div>
                                                        <div class="col-lg-3"  [formGroup]="validform">
                                                            <label class="label">Zip</label>
                                                            <input class="form-control" type="text" 
                                                                [(ngModel)]="FMSProvider.zipCode"[disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                                (keypress)="keyPress($event)" maxlength="11" minlength="5"
                                                                [attr.disabled]="logintype === 'onboardLogin' ? true : null"
                                                                formControlName="Fmszip">
                                                            <span class="req"
                                                                                            *ngIf="validform.controls['Fmszip'].invalid">
                                                                                            <p>*Enter Valid zip, Enter 5 to 10 digits</p>
                                                                                        </span>
                                                        </div>
    
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-lg-4">
                                                            <label class="label">Contact Name</label>
                                                            <input class="form-control" type="text" [disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                                [(ngModel)]="FMSProvider.contactName">
    
                                                        </div>
                                                        <div class="col-lg-4">
                                                            <label class="label">Email Address</label>
                                                            <input class="form-control" type="text" [disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                                [(ngModel)]="FMSProvider.email">
    
                                                        </div>
                                                        <div class="col-lg-4" [formGroup]="validform">
                                                            <label class="label">Fax Number</label>
                                                            <input class="form-control" type="text" 
                                                                [(ngModel)]="FMSProvider.fax"[disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                                (ngModelChange)="DemographicPhoneFormat('fmsproviderfax')"
                                                                (keypress)="keyPress($event)" maxlength="14" minlength="14"
                                                                [attr.disabled]="logintype === 'onboardLogin' ? true : null"
                                                                formControlName="Fmsfax">
                                                            <span class="req"
                                                                                            *ngIf="validform.controls['Fmsfax'].invalid">
                                                                                            <p>*Enter Valid fax, Enter 10 digit</p>
                                                                                        </span>
                                                        </div>
    
                                                    </div>
    
    
                                                </div>
    
    
                                            </div>
    
                                            <div class="row mt-3" *ngIf="serviceplanImportBO.modelTypename == 'BUDGET'">
                                                <h4 class=" font-header" id="exampleModalLabel"><b>FMS Fee
                                                    </b></h4>
                                            </div>
                                            <div class="row mt-3" *ngIf="serviceplanImportBO.modelTypename == 'BUDGET'">
                                                <div class="col-lg-7">
                                                    <label class="label">Estimated annual FMS fee (Go to the <a
                                                            href="https://mn.gov/dhs/people-we-serve/people-with-disabilities/services/home-community/programs-and-services/fms.jsp">FMS Provier page </a>for a list of fees or ask
                                                        your FMS provider.)</label>
                                                </div>
                                                <div class="col-lg-2 ">
                                                    <input class="form-control" type="text"[disabled]="logintype =='onboardLogin'"
                                                        [(ngModel)]="serviceplanImportBO.fmsBudget.fmsFee" (ngModelChange)="CalculateFmsFee()" (change)="changefunction()">
                                                </div>
                                            </div>
    
                                            <!-- <div class="row mt-3" *ngIf="serviceplanImportBO.modelTypename == 'BUDGET'">
                                                <div class="col-lg-3">
                                                    <label class="label">How many months is your plan?</label>
                                                </div>
                                                <div class="col-lg-3">
                                                    <input class="form-control" type="text"[disabled]="logintype =='onboardLogin'"
                                                        [(ngModel)]="serviceplanImportBO.fmsBudget.planMonths" (ngModelChange)="CalculateFmsFee()">
                                                </div>
                                            </div> -->
                                            <div class="row mt-3" *ngIf="serviceplanImportBO.modelTypename == 'AGENCY'">
                                                <h4 class=" font-header" id="exampleModalLabel"><b>Provider agency
                                                    </b></h4>
                                            </div>
                                            <div *ngIf="serviceplanImportBO.modelTypename == 'AGENCY'">
    
                                                <div id="goalaccordion" class="col-lg-12"
                                                    *ngFor="let item of serviceplanImportBO.agencyModels.agencyDetails;let goal1=index">
    
                                                    <div class="card-body">
                                                        <div class="row mt-1">
                                                            <div class="col-lg-8">
    
                                                            </div>
    
                                                            <div class="col-lg-4 text-right">
    
                                                                <i (click)="logintype !== 'onboardLogin' &&Createagencymodel(goal1)" style="font-size:25px"
                                                                    *ngIf="!item.isadd"[disabled]="logintype =='onboardLogin'"
                                                                    class="fa fa-plus-circle text-primary"></i>&nbsp;&nbsp;
    
    
                                                                <i *ngIf="goal1 != 0"[disabled]="logintype =='onboardLogin'"
                                                                    (click)="logintype !== 'onboardLogin' &&removeagencymodel(goal1,item);"
                                                                    style="font-size:22px"
                                                                    class="fa fa-trash text-danger"></i>
                                                            </div>
    
                                                        </div>
    
                                                        <div class="row">
                                                            <div class="col-lg-6">
                                                                <label class="label">Agency Name</label>
                                                                <input class="form-control" type="text" [disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                                    [(ngModel)]="item.agencyName">
                                                            </div>
                                                            <!-- <div class="col-lg-3">
                                                                <label class="label">NPI</label>
                                                                <input class="form-control" type="text" [disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                                    [(ngModel)]="item.npi">
                                                            </div> -->
    
                                                            <div class="col-lg-3">
                                                                <label class="label">Phone Number</label>
                                                                <input class="form-control" type="text" 
                                                                    [(ngModel)]="item.phoneNumber"[disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                                    [attr.disabled]="logintype === 'onboardLogin' ? true : null"
                                                                    (ngModelChange)="DemographicPhoneFormatagencymodel(item,goal1,'phone');validchange_agencyModel(goal1,item)"
                                                                    (keypress)="keyPress($event)" maxlength="14"
                                                                    minlength="14" >
                                                                
                                                                    <span class="req"
                                                                        *ngIf="errphone1">{{phonerr1[goal1]}}</span>
                                                            </div>
    
    
    
    
                                                        </div>
                                                        <div class="row">
                                                            <div class="col-lg-3">
                                                                <label class="label">Street Address</label>
                                                                <textarea class="form-control" type="text" [disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                                    [(ngModel)]="item.street"></textarea>
                                                            </div>
                                                            <div class="col-lg-2">
                                                                <label class="label">City</label>
                                                                <input class="form-control" type="text" [disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                                    [(ngModel)]="item.city">
                                                            </div>
                                                            <div class="col-lg-1">
                                                                <label class="label">State</label>
                                                                <ng-select [items]="stateList" id="state" class="w-100 "
                                                                [searchable]="true" [disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                                [(ngModel)]="item.state" [clearable]="true"
                                                                bindLabel="name" bindValue="abbreviation">
                                                            </ng-select>
    
    
                                                            </div>
                                                            <div class="col-lg-2">
                                                                <label class="label">Zip</label>
                                                                <input class="form-control" type="text" 
                                                                [attr.disabled]="logintype === 'onboardLogin' ? true : null"
                                                                    [(ngModel)]="item.zipCode" (keypress)="keyPress($event)"[disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                                    maxlength="11" minlength="5"   (ngModelChange)="validchangeZip(goal1,item)"
                                                                   >
                                                                <!-- <span class="req"
                                        *ngIf="validform.controls['Personzip'].invalid">
                                        <p>*Enter Valid zip, Enter 5 to 10 digits</p>
                                    </span> -->
                                                            </div>
    
                                                            <div class="row">
    
                                                                <div class="col-lg-3">
                                                                    <label class="label">Contact Name</label>
                                                                    <input class="form-control" type="text" [disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                                        [(ngModel)]="item.contactName">
                                                                </div>
                                                                <div class="col-lg-5">
                                                                    <label class="label">Email Address</label>
                                                                    <input class="form-control" type="text" [disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                                        [(ngModel)]="item.emailAddress">
                                                                </div>
    
                                                                <div class="col-lg-4">
                                                                    <label class="label">Fax Number</label>
                                                                    <input class="form-control" type="text" 
                                                                    [attr.disabled]="logintype === 'onboardLogin' ? true : null"
                                                                        [(ngModel)]="item.faxNumber"[disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                                        (ngModelChange)="DemographicPhoneFormatagencymodel(item,goal1,'fax');validchange_fax(goal1,item)"
                                                                        (keypress)="keyPress($event)" maxlength="14"
                                                                        minlength="14" >
                                                                </div>
                                                            </div>
    
                                                        </div>
    
    
                                                    </div>
    
    
                                                </div>
                                            </div>
    
                                            <div class="row mt-3 ">
                                                <h3 class=" font-header" id="exampleModalLabel"><b>PERS, goods and services
                                                    </b></h3>
                                            </div>
                                            <div class="row mt-3" *ngIf="serviceplanImportBO.modelTypename == 'AGENCY' || serviceplanImportBO.modelTypename == 'BUDGET' ">
                                                <h4 class=" font-header" id="exampleModalLabel"><b>Personal emergency
                                                        response system (PERS)
                                                    </b></h4>
                                            </div>
                                            <div class="row mt-3"  *ngIf="serviceplanImportBO.modelTypename == 'AGENCY' || serviceplanImportBO.modelTypename == 'BUDGET' ">
                                                <label class="label"> As a part of your requirement to have a backup plan,
                                                    will you use an emergency response system provided by a
                                                    Minnesota Health Care Programs (MHCP) vendor?</label>
                                            </div>
                                            <div class="row mt-3"  *ngIf="serviceplanImportBO.modelTypename == 'AGENCY' || serviceplanImportBO.modelTypename == 'BUDGET' ">
                                                <div class="col-lg-4">
                                                    <input type="radio" class="ml-2" name="mhcp" [value]="true"[disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                        [(ngModel)]="serviceplanImportBO.willUsePERS" /> Yes &nbsp;
                                                    <input type="radio" class="ml-2" name="mhcp" [value]="false"[disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                        [(ngModel)]="serviceplanImportBO.willUsePERS" />No &nbsp;
    
                                                </div>
    
                                            </div>
                                            <div class="row mt-3" *ngIf="serviceplanImportBO.willUsePERS == true">
                                                <h4 class=" font-header" id="exampleModalLabel"><b>MHCP PERS costs
                                                    </b></h4>
                                            </div>
                                            <div class="row mt-3"  *ngIf="serviceplanImportBO.willUsePERS == true">
                                                <label class="label">Enter PERS costs per year.</label>
                                            </div>
    
                                            
                                            <div class="row mt-2"  *ngIf="serviceplanImportBO.willUsePERS == true">
                                                <div style="overflow-x:auto;">
                                                    <table class="table table-bordered">
    
                                                        <tr style="border: 1px gray;">
                                                            <th>
                                                                 <b>Type of cost</b>
                                                            </th>
    
                                                            <th><b>Name of MHCP provider</b>
                                                            </th>
                                                            <th style="width: 100px;">
                                                                <b>Cost</b>
                                                            </th>
    
    
                                                        </tr>
                                                        <tr style="border: 1px gray;">
                                                            <td>
    
                                                                <label class="label">Equipment</label>
                                                            </td>
                                                            <td>
    
                                                                <input type="text" class="form-control" [(ngModel)]="serviceplanImportBO.mhcpCost.equipment_ProviderName"[disabled]="logintype =='onboardLogin'" (change)="changefunction()">
                                                            </td>
                                                            <td>
                                                                <input type="text" class="form-control" [(ngModel)]="serviceplanImportBO.mhcpCost.equipment_Cost" (ngModelChange)="Calculatemhcpfee()"[disabled]="logintype =='onboardLogin'" (change)="changefunction()">
                                                            </td>
                                                        </tr>
                                                        <tr style="border: 1px gray;">
                                                            <td>
    
                                                                <label class="label">Installation</label>
                                                            </td>
                                                            <td>
    
                                                                <input type="text" class="form-control" [(ngModel)]="serviceplanImportBO.mhcpCost.installation_ProviderName"[disabled]="logintype =='onboardLogin'" (change)="changefunction()">
                                                            </td>
                                                            <td>
                                                                <input type="text" class="form-control" [(ngModel)]="serviceplanImportBO.mhcpCost.installation_Cost"[disabled]="logintype =='onboardLogin'" (ngModelChange)="Calculatemhcpfee()" (change)="changefunction()">
                                                            </td>
                                                        </tr>
                                                        <tr style="border: 1px gray;">
                                                            <td>
    
                                                                <label class="label">Monthly subscription</label>
                                                            </td>
                                                            <td>
    
                                                                <input type="text" class="form-control" [(ngModel)]="serviceplanImportBO.mhcpCost.subscription_ProviderName"[disabled]="logintype =='onboardLogin'" (change)="changefunction()">
                                                            </td>
                                                            <td>
                                                                <input type="text" class="form-control" [(ngModel)]="serviceplanImportBO.mhcpCost.subscription_Cost" (ngModelChange)="Calculatemhcpfee()"[disabled]="logintype =='onboardLogin'" (change)="changefunction()">
                                                            </td>
                                                        </tr>
    
    
    
    
                                                        <tr style="border: 1px gray;">
    
                                                            <td colspan="2" style="text-align: right;">
                                                                Total
                                                            </td>
    
                                                            <td> <label class="label" *ngIf="mhcptotal != 0 && mhcptotal != null"> ${{mhcptotal}}</label>
                                                                  </td>
                                                            </tr>
                                                            
    
    
    
                                                    </table>
                                                </div>
    
                                            </div>
                                            <div class="row mt-3" *ngIf="serviceplanImportBO.modelTypename == 'AGENCY'">
                                                <h4 class=" font-header" id="exampleModalLabel"><b> Goods and
                                                        services
                                                    </b></h4>
                                            </div>
    
                                            <div class="row mt-3" *ngIf="serviceplanImportBO.modelTypename == 'AGENCY'">
                                                <label for="" class="label col-lg-4">Do you plan to purchase any goods and
                                                    services?</label>
                                                <div class="col-lg-5 mt-1 ">
                                                    <input type="radio" class="ml-2" name="purchase" [value]="true"[disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                        [(ngModel)]="serviceplanImportBO.is_Goods_And_Service" />
                                                    Yes &nbsp;
                                                    <input type="radio" class="ml-2" name="purchase" [value]="false"[disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                        [(ngModel)]="serviceplanImportBO.is_Goods_And_Service" />No
                                                    &nbsp;
                                                </div>
                                            </div>
    
                                            <div class="card mt-3"
                                            *ngIf="serviceplanImportBO.modelTypename == 'AGENCY' && serviceplanImportBO.is_Goods_And_Service ==true">
                                            <div class="card-body">

                                                <div class="row">
                                                    <div class="col">
                                                        <h4>Financial management service (FMS) provider
                                                        </h4>
                                                    </div>

                                                </div>
                                                <div class="row">
                                                    <div class="col-lg-6">
                                                        <label class="label">Name</label>
                                                        <ng-select [items]="FmsAgencyList"  class="w-100 " (change)="onAgencySelected($event)" 
                                                            [searchable]="true" [disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                            bindLabel="Value" bindValue="Key" [(ngModel)]="FMSProvider.fmsAgencyId" [clearable]="true"
                                                            >
                                                        </ng-select>
                                                    </div>
                                                    <div class="col-lg-3">
                                                        <label class="label">NPI</label>
                                                        <input class="form-control" type="text" [disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                            [(ngModel)]="FMSProvider.npi">
                                                    </div>
                                                    <div class="col-lg-3"  [formGroup]="validform">
                                                        <label class="label">Phone Number</label>
                                                        <input class="form-control" type="text" 
                                                            [(ngModel)]="FMSProvider.phoneNumber"[disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                            [attr.disabled]="logintype === 'onboardLogin' ? true : null"
                                                            (ngModelChange)="DemographicPhoneFormat('fmsproviderphone')"
                                                            (keypress)="keyPress($event)" maxlength="14" minlength="14"
                                                            formControlName="FmsPhn">

                                                            <span class="req"
                                                            *ngIf="validform.controls['FmsPhn'].invalid">
                                                            <p>*Enter Valid zip, Enter 5 to 10 digits</p>
                                                        </span>

                                                    </div>



                                                </div>
                                                <div class="row">
                                                    <div class="col-lg-4">
                                                        <label class="label">Street Address</label>
                                                        <textarea class="form-control" type="text" [disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                            [(ngModel)]="FMSProvider.address"></textarea>
                                                    </div>
                                                    <div class="col-lg-3">
                                                        <label class="label">City</label>
                                                        <input class="form-control" type="text" [disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                            [(ngModel)]="FMSProvider.city">
                                                    </div>
                                                    <div class="col-lg-2">
                                                        <label class="label">State</label>
                                                       
                                                            <ng-select [items]="stateList" id="state" class="w-100 "
                                                            [searchable]="true" [disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                            [(ngModel)]="FMSProvider.state" [clearable]="true"
                                                            bindLabel="name" bindValue="abbreviation">
                                                        </ng-select>


                                                    </div>
                                                    <div class="col-lg-3"  [formGroup]="validform">
                                                        <label class="label">Zip</label>
                                                        <input class="form-control" type="text" 
                                                            [(ngModel)]="FMSProvider.zipCode"[disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                            [attr.disabled]="logintype === 'onboardLogin' ? true : null"
                                                            (keypress)="keyPress($event)" maxlength="11" minlength="5"
                                                            formControlName="Fmszip">
                                                        <span class="req"
                                                                                        *ngIf="validform.controls['Fmszip'].invalid">
                                                                                        <p>*Enter Valid zip, Enter 5 to 10 digits</p>
                                                                                    </span>
                                                    </div>

                                                </div>
                                                <div class="row">
                                                    <div class="col-lg-4">
                                                        <label class="label">Contact Name</label>
                                                        <input class="form-control" type="text" [disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                            [(ngModel)]="FMSProvider.contactName">

                                                    </div>
                                                    <div class="col-lg-4">
                                                        <label class="label">Email Address</label>
                                                        <input class="form-control" type="text" [disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                            [(ngModel)]="FMSProvider.email">

                                                    </div>
                                                    <div class="col-lg-4" [formGroup]="validform">
                                                        <label class="label">Fax Number</label>
                                                        <input class="form-control" type="text" 
                                                            [(ngModel)]="FMSProvider.fax"[disabled]="logintype =='onboardLogin'"(change)="changefunction()"
                                                            [attr.disabled]="logintype === 'onboardLogin' ? true : null"
                                                            (ngModelChange)="DemographicPhoneFormat('fmsproviderfax')"
                                                            (keypress)="keyPress($event)" maxlength="14" minlength="14"
                                                            formControlName="Fmsfax">
                                                        <span class="req"
                                                                                        *ngIf="validform.controls['Fmsfax'].invalid">
                                                                                        <p>*Enter Valid fax, Enter 10 digit</p>
                                                                                    </span>
                                                    </div>

                                                </div>


                                            </div>


                                        </div>
    
    
                                            <div class="row mt-3"
                                                *ngIf="serviceplanImportBO.modelTypename == 'BUDGET' ||serviceplanImportBO.is_Goods_And_Service ">
                                                <h4 class=" font-header" id="exampleModalLabel"><b>Goods and Services
                                                    </b></h4>
                                            </div>
                                            <div class="row mt-3" *ngIf="serviceplanImportBO.modelTypename == 'BUDGET'">
                                                <label class="label col-lg-4">Do you plan to purchase goods and
                                                    services?</label>
    
                                                <div class="col-lg-3">
                                                    <input type="radio" class="ml-2" name="goods" [value]="true"[disabled]="logintype =='onboardLogin'"
                                                        [(ngModel)]="serviceplanImportBO.is_Goods_And_Service" (change)="changefunction()" />
                                                    Yes &nbsp;
                                                    <input type="radio" class="ml-2" name="goods" [value]="false"[disabled]="logintype =='onboardLogin'"
                                                        [(ngModel)]="serviceplanImportBO.is_Goods_And_Service" (change)="changefunction()" />No
                                                    &nbsp;
                                                </div>
                                            </div>
    
                                            <div class="row mt-1" *ngIf="((serviceplanImportBO.modelTypename == 'AGENCY' && serviceplanImportBO.is_Goods_And_Service) || serviceplanImportBO.is_Goods_And_Service) ">
                                                <label class="label"> What goods and services do you intend to
                                                    purchase?</label>
    
                                            </div>
                                            <!-- <div class="row mt-1" *ngIf="serviceplanImportBO.modelTypename == 'BUDGET' && serviceplanImportBO.is_Goods_And_Service">
                                                <p><b>Note: </b>Percentage fees also are listed on the FMS service provider
                                                    page. If your FMS does not charge a percentage fee for each good,
                                                    enter a zero (0) in the FMS fee (percentage) field.
                                                </p> 
                                            </div> -->
    
                                            <div class="row"
                                                *ngIf="serviceplanImportBO.is_Goods_And_Service">
                                                <div style="overflow-x: auto;">
                                                    <table class="table  table-hover">
    
                                                        <tr style="border: 1px gray;">
                                                            <th>
                                                                <b>Good/Service </b>
                                                            </th>
                                                            <th>
                                                                <b>Assessed need it relates to </b>
                                                            </th>
                                                            <th>
                                                                <b>Human support it replaces </b>
                                                            </th>
                                                            <th><b>Cost</b>
                                                            </th>
                                                            <!-- <th *ngIf="serviceplanImportBO.modelTypename == 'BUDGET'"><b>FMS
                                                                    fee (percentage)
                                                                </b>
    
                                                            </th> -->
    
                                                        </tr>
    
                                                        <tr style="border: 1px gray;"
                                                            *ngFor="let service of goodsAndServices;let Contact=index">
                                                            <td>
    
    
                                                                <input type="text" class="form-control"[disabled]="logintype =='onboardLogin'"
                                                                    [(ngModel)]="service.goods_Or_Service" (change)="changefunction()">
                                                            </td>
                                                            <td>
                                                                <textarea type="text" class="form-control"[disabled]="logintype =='onboardLogin'"
                                                                    [(ngModel)]="service.assessed_Need" (change)="changefunction()"></textarea>
                                                            </td>
                                                            <td>
    
    
                                                                <textarea type="text" class="form-control"[disabled]="logintype =='onboardLogin'"
                                                                    [(ngModel)]="service.human_Support_It_Replaces" (change)="changefunction()"></textarea>
    
                                                            </td>
    
    
                                                            <td>
    
    
                                                                <input type="text" class="form-control"[disabled]="logintype =='onboardLogin'"
                                                                    [(ngModel)]="service.cost" (ngModelChange)="calculateGoodsandservice()" (change)="changefunction()">
                                                            </td>
    
                                                            <!-- <td *ngIf="serviceplanImportBO.modelTypename == 'BUDGET'"><input
                                                                    type="text" class="form-control"[disabled]="logintype =='onboardLogin'"
                                                                    [(ngModel)]="service.fms_Fee_Percentage" (ngModelChange)="calculateGoodsandservice()">
                                                            </td> -->
                                                            <td class="d-flex"><i class="fa fa-plus-circle text-primary"
                                                                    *ngIf="Contact==0" style="font-size:30px" [disabled]="logintype =='onboardLogin'"
                                                                    (click)="logintype !== 'onboardLogin' &&Creategoods()"></i>
    
    
                                                                <i style="font-size:27px;" *ngIf="Contact != 0" [disabled]="logintype =='onboardLogin'"
                                                                    (click)="logintype !== 'onboardLogin' &&removegoods(Contact,service)"
                                                                    class="fa fa-trash text-danger"></i>
                                                            </td>
                                                        </tr>
                                                        <!-- <tr *ngIf="serviceplanImportBO.modelTypename == 'BUDGET'">
                                                            <td colspan="3" style="text-align: right;">
                                                                Sub Total
                                                            </td>
    
                                                            <td><input type="text" class="form-control"  [disabled]="logintype =='onboardLogin'"
                                                                    [(ngModel)]="Goodssubtotalcost">
                                                            </td>
                                                            <td><input type="text" class="form-control"  [disabled]="logintype =='onboardLogin'"
                                                                    [(ngModel)]="Goodssubtotalfee">
                                                            </td>
    
                                                        </tr> -->
    
    
                                                        <tr style="border: 1px gray;"
                                                            *ngIf="serviceplanImportBO.modelTypename == 'BUDGET'">
                                                            <td colspan="3" style="text-align: right;">Grand Total
                                                            </td>
    
                                                            <td colspan="2" ><input type="text" class="form-control"  [disabled]="logintype =='onboardLogin'"
                                                                    [(ngModel)]="Goodsgrandtotal" (ngModelChange)="cfssWorkerBudget()">
                                                            </td>
    
                                                        </tr>
    
                                                        <tr *ngIf="serviceplanImportBO.modelTypename == 'AGENCY'">
                                                            <td colspan="3" style="text-align: right;">
                                                                Total
                                                            </td>
    
                                                            <td><input type="text" class="form-control"  [disabled]="logintype =='onboardLogin'"
                                                                    [(ngModel)]="Goodsgrandtotal">
                                                            </td>
    
                                                        </tr>
                                                    </table>
    
                                                </div>
    
                                            </div>
                                            <div class="row mt-2" *ngIf="serviceplanImportBO.modelTypename == 'AGENCY' && serviceplanImportBO.is_Goods_And_Service">
                                                <p><b>* NOTE: </b>You can locate your FMS’s fees at <a
                                                        href="https://mn.gov/dhs/people-we-serve/people-with-disabilities/services/home-community/programs-and-services/fms.jsp">DHS
                                                        -- financial management service provider information</a> or by
                                                    asking your FMS.</p>
                                            </div>
                                            <div class="row mt-3" *ngIf="serviceplanImportBO.modelTypename == 'AGENCY' && serviceplanImportBO.is_Goods_And_Service">
                                                <h4 class=" font-header" id="exampleModalLabel"><b>General schedule
                                                    </b></h4>
                                            </div>
                                            <div class="row mt-3 " *ngIf="serviceplanImportBO.modelTypename == 'AGENCY' && serviceplanImportBO.is_Goods_And_Service">
                                                <label class="label">You can use your units flexibly throughout the year.
                                                    You need to have a plan for how you will use your units, but
                                                    remember that you can adapt to changes in your life as needed.
                                                    </label>
                                            </div>
    
                                            <div class="row mt-2" *ngIf="serviceplanImportBO.modelTypename == 'AGENCY' && serviceplanImportBO.is_Goods_And_Service">
                                                <p><b>NOTE: </b>If you are on the Minnesota Restricted Recipient Program
                                                    (MRRP) you must use the same number of units each month, so answer
                                                    "Yes."</p>
                                            </div>
                                            <div class="row mt-3" *ngIf="serviceplanImportBO.modelTypename == 'AGENCY' && serviceplanImportBO.is_Goods_And_Service == false">
                                                <h4 class=" font-header" id="exampleModalLabel"><b>Planned monthly use of units
                                                    </b></h4>
                                            </div>
                                            <div class="row mt-3 " *ngIf="serviceplanImportBO.modelTypename == 'AGENCY' && serviceplanImportBO.is_Goods_And_Service == false">
                                                <label class="label">You can use your units flexibly throughout the year. You need to have a plan for how you will use your units, but
                                                    remember that you can adapt to changes in your life as needed.</label>
                                            </div>
    
                                            <div class="row mt-3" *ngIf="(serviceplanImportBO.modelTypename == 'AGENCY') && (serviceplanImportBO.is_Goods_And_Service ==true ||  serviceplanImportBO.is_Goods_And_Service ==false) && serviceplanImportBO.isFullYearPlan !=false ">
                                                <label class="label col-lg-5">Do you plan to use approximately the same
                                                    amount of units each month?</label>
    
                                                <div class="col-lg-3">
                                                    <input type="radio" class="ml-2" name="agentmonthplan" [value]="true" [disabled]="logintype =='onboardLogin'"
                                                        [(ngModel)]="serviceplanImportBO.agencyModels.planSameUnitsEachMonth" (ngModelChange)="CalculateAgentmonthlyAmt()" />
                                                    Yes &nbsp;
                                                    <input type="radio" class="ml-2" name="agentmonthplan" [value]="false" [disabled]="logintype =='onboardLogin'"
                                                        [(ngModel)]="serviceplanImportBO.agencyModels.planSameUnitsEachMonth" />No
                                                    &nbsp;
                                                </div>
                                            </div>

                                            <div class="row mt-3" *ngIf="serviceplanImportBO.modelTypename == 'AGENCY' &&( serviceplanImportBO.agencyModels.planSameUnitsEachMonth ==true && serviceplanImportBO.isFullYearPlan==true)" >
                                                <h5 class=" font-header" id="exampleModalLabel"><b>Monthly units
                                                    </b></h5>
                                            </div>
    
                                            <div class="row mt-3" *ngIf="serviceplanImportBO.modelTypename == 'AGENCY' && serviceplanImportBO.agencyModels.planSameUnitsEachMonth==true && serviceplanImportBO.isFullYearPlan== true">
                                                <div class="col-lg-3">
                                                    <label class="label">Planned monthly use of units:</label>
                                                </div>
                                                <div class="col-lg-5 mt-1 ">
                                                    <input class="form-control" type="text" disabled
                                                        [(ngModel)]="serviceplanImportBO.agencyModels.plannedUnits"  />
                                                </div>
                                            </div>

                                            <!-- <div class="row mt-3" *ngIf="serviceplanImportBO.modelTypename == 'AGENCY'&& (serviceplanImportBO.isFullYearPlan==false && serviceplanImportBO.agencyModels.planSameUnitsEachMonth==false)" >
                                                <h5 class=" font-header" id="exampleModalLabel"><b>General schedule
                                                    </b></h5>
                                            </div>

                                            <div class="row mt-3" *ngIf="serviceplanImportBO.modelTypename == 'AGENCY'&& (serviceplanImportBO.isFullYearPlan==false && serviceplanImportBO.agencyModels.planSameUnitsEachMonth==false)" >
                                               <label>What would you like your general worker schedule to be? This is just a general plan. You can vary from day to day as
                                                needed.</label>
                                            </div> -->
                                            <div class="row mt-3" *ngIf="serviceplanImportBO.modelTypename == 'AGENCY'&& (serviceplanImportBO.isFullYearPlan==false || serviceplanImportBO.agencyModels.planSameUnitsEachMonth==false)" >
                                                <h5 class=" font-header" id="exampleModalLabel"><b>Month-by-month general
                                                        plan
                                                    </b></h5>
                                            </div>
                                            <div class="row mt-3" *ngIf="serviceplanImportBO.modelTypename == 'AGENCY'&& (serviceplanImportBO.isFullYearPlan==false || serviceplanImportBO.agencyModels.planSameUnitsEachMonth==false)">
                                                <label class="label ">Since you won't use the same amount of units each
                                                    month, use this table to estimate how many units you expect to
                                                    use each day, depending on the month.</label>
                                            </div>
                                            <div class="row mt-3" *ngIf="serviceplanImportBO.modelTypename == 'AGENCY'&& (serviceplanImportBO.isFullYearPlan==false || serviceplanImportBO.agencyModels.planSameUnitsEachMonth==false)">
                                                <h5 class=" font-header" id="exampleModalLabel"><b>Units per month
                                                    </b></h5>
                                            </div>
                                            <div class="row mt-3" *ngIf="serviceplanImportBO.modelTypename == 'AGENCY'&& (serviceplanImportBO.isFullYearPlan==false || serviceplanImportBO.agencyModels.planSameUnitsEachMonth==false)">
                                                <label class="label ">Enter the estimated units you will use per month
                                                </label>
                                                <p>(enter numbers; total should not exceed the amount of units your are
                                                    eligible for):</p>
                                            </div>
    
    
                                            <div class="row mt-2"  *ngIf="serviceplanImportBO.modelTypename == 'AGENCY'&& (serviceplanImportBO.isFullYearPlan==false || serviceplanImportBO.agencyModels.planSameUnitsEachMonth==false)" >
                                                <div style="overflow-x: auto;">
                                                    <table class="table  table-hover">
    
                                                        <tr style="border: 1px gray;">
                                                            <th>
                                                                <b>JAN</b>
                                                            </th>
                                                            <th>
                                                                <b>FEB</b>
                                                            </th>
                                                            <th>
                                                                <b>MAR</b>
                                                            </th>
                                                            <th><b>APR</b>
                                                            </th>
                                                            <th><b>MAY
                                                                </b>
    
                                                            </th>
                                                            <th><b>JUN</b></th>
                                                            <th><b>JUL</b></th>
                                                            <th><b>AUG</b></th>
                                                            <th><b>SEP</b></th>
                                                            <th><b>OCT</b></th>
                                                            <th><b>NOV</b></th>
                                                            <th><b>DEC</b></th>
    
                                                        </tr>
    
                                                        <tr style="border: 1px gray;">
                                                            <td>
                                                                <input type="text" class="form-control" [disabled]="logintype =='onboardLogin'"
                                                                    [(ngModel)]="serviceplanImportBO.agencyModels.monthlyUnitUsage.unitsJan"
                                                                    (ngModelChange)="CalculateAgentmonthlyUnits()">
                                                            </td>
                                                            <td>
                                                                <input type="text" class="form-control" [disabled]="logintype =='onboardLogin'"
                                                                    [(ngModel)]="serviceplanImportBO.agencyModels.monthlyUnitUsage.unitsFeb"
                                                                    (ngModelChange)="CalculateAgentmonthlyUnits()">
                                                            </td>
                                                            <td>
    
    
                                                                <input type="text" class="form-control" [disabled]="logintype =='onboardLogin'"
                                                                    [(ngModel)]="serviceplanImportBO.agencyModels.monthlyUnitUsage.unitsMar"
                                                                    (ngModelChange)="CalculateAgentmonthlyUnits()">
    
                                                            </td>
    
    
                                                            <td>
    
    
                                                                <input type="text" class="form-control" [disabled]="logintype =='onboardLogin'"
                                                                    [(ngModel)]="serviceplanImportBO.agencyModels.monthlyUnitUsage.unitsApr"
                                                                    (ngModelChange)="CalculateAgentmonthlyUnits()">
                                                            </td>
                                                            <td>
    
    
                                                                <input type="text" class="form-control" [disabled]="logintype =='onboardLogin'"
                                                                    [(ngModel)]="serviceplanImportBO.agencyModels.monthlyUnitUsage.unitsMay"
                                                                    (ngModelChange)="CalculateAgentmonthlyUnits()">
                                                            </td>
                                                            <td>
    
    
                                                                <input type="text" class="form-control" [disabled]="logintype =='onboardLogin'"
                                                                    [(ngModel)]="serviceplanImportBO.agencyModels.monthlyUnitUsage.unitsJun"
                                                                    (ngModelChange)="CalculateAgentmonthlyUnits()">
                                                            </td>
                                                            <td>
    
    
                                                                <input type="text" class="form-control" [disabled]="logintype =='onboardLogin'"
                                                                    [(ngModel)]="serviceplanImportBO.agencyModels.monthlyUnitUsage.unitsJul"
                                                                    (ngModelChange)="CalculateAgentmonthlyUnits()">
                                                            </td>
                                                            <td>
    
    
                                                                <input type="text" class="form-control" [disabled]="logintype =='onboardLogin'"
                                                                    [(ngModel)]="serviceplanImportBO.agencyModels.monthlyUnitUsage.unitsAug"
                                                                    (ngModelChange)="CalculateAgentmonthlyUnits()">
                                                            </td>
                                                            <td>
    
    
                                                                <input type="text" class="form-control" [disabled]="logintype =='onboardLogin'"
                                                                    [(ngModel)]="serviceplanImportBO.agencyModels.monthlyUnitUsage.unitsSep"
                                                                    (ngModelChange)="CalculateAgentmonthlyUnits()">
                                                            </td>
                                                            <td>
    
    
                                                                <input type="text" class="form-control" [disabled]="logintype =='onboardLogin'"
                                                                    [(ngModel)]="serviceplanImportBO.agencyModels.monthlyUnitUsage.unitsOct"
                                                                    (ngModelChange)="CalculateAgentmonthlyUnits()">
                                                            </td>
                                                            <td>
    
    
                                                                <input type="text" class="form-control" [disabled]="logintype =='onboardLogin'"
                                                                    [(ngModel)]="serviceplanImportBO.agencyModels.monthlyUnitUsage.unitsNov"
                                                                    (ngModelChange)="CalculateAgentmonthlyUnits()">
                                                            </td>
                                                            <td>
    
    
                                                                <input type="text" class="form-control" [disabled]="logintype =='onboardLogin'"
                                                                    [(ngModel)]="serviceplanImportBO.agencyModels.monthlyUnitUsage.unitsDec"
                                                                    (ngModelChange)="CalculateAgentmonthlyUnits()">
                                                            </td>
    
    
    
                                                        </tr>
                                                        <tr>
                                                            <td colspan="10" style="text-align: right;">
                                                                <b>Units eligible for:</b> <p *ngIf="serviceplanImportBO.totalCFSSUnitsEligible!= null && serviceplanImportBO.totalCFSSUnitsEligible!= 0">{{serviceplanImportBO.totalCFSSUnitsEligible}} </p> 
                                                            </td>
    
                                                            <td><b>12-MONTH TOTAL</b>
                                                            </td>
    
                                                            <td> <input type="text" class="form-control"
                                                                    [(ngModel)]="serviceplanImportBO.agencyModels.monthlyUnitUsage.totalUnitsUsed">
                                                            </td>
    
                                                        </tr>
    
    
                                                    </table>
    
                                                </div>
    
                                            </div>
    
    
    
                                            <div class="row mt-3"  *ngIf="serviceplanImportBO.modelTypename == 'AGENCY' || serviceplanImportBO.modelTypename == 'BUDGET'">
                                                <h4 class=" font-header" id="exampleModalLabel"><b>Workers
                                                    </b></h4>
                                            </div>
    
                                            <div class="row mt-1" *ngIf="serviceplanImportBO.modelTypename == 'AGENCY'">
                                                <label class="label">Tell your agency what preferences you have about your
                                                    worker:</label>
                                                <textarea rows="7" class="form-control" cols="190"   [(ngModel)]="serviceplanImportBO.agencyModels.workerPreferencesDetails"  [disabled]="logintype =='onboardLogin'"></textarea>
                                            </div>
    
    
                                            <div class="row mt-1" *ngIf="serviceplanImportBO.modelTypename == 'AGENCY'">
                                                <label class="label">What is your worker training development plan? (Leave this section blank.You
                                                    and your agency should complete this together.<br/><strong>NOTE:</strong> The provider agency can choose to document these answers in another location.)</label>
                                                <textarea rows="7" class="form-control" cols="190" [(ngModel)]="serviceplanImportBO.agencyModels.trainingDevelopmentPlan"  [disabled]="logintype =='onboardLogin'"></textarea>
                                            </div>
                                            <div class="row mt-3" *ngIf="serviceplanImportBO.modelTypename == 'BUDGET'">
                                                <label class="label col-lg-4">Do you plan to use personal care
                                                    workers?</label>
    
                                                <div class="col-lg-3">
                                                    <input type="radio" class="ml-2" name="workers" [value]="true" [disabled]="logintype =='onboardLogin'"
                                                        [(ngModel)]="serviceplanImportBO.fmsBudget.is_Personal_Care_Workers" (click)="cfssWorkerBudget()" (change)="changefunction()" />
                                                    Yes &nbsp;
                                                    <input type="radio" class="ml-2" name="workers" [value]="false" [disabled]="logintype =='onboardLogin'"
                                                        [(ngModel)]="serviceplanImportBO.fmsBudget.is_Personal_Care_Workers" (change)="changefunction()" />No
                                                    &nbsp;
                                                </div>
                                            </div>
                                            <div class="row mt-3" *ngIf="serviceplanImportBO.modelTypename == 'BUDGET' 
                                            &&serviceplanImportBO.fmsBudget.is_Personal_Care_Workers">
                                                <h5 class=" font-header" id="exampleModalLabel"><b>Job description
                                                    </b></h5>
                                            </div>
                                            <div class="row mt-1" *ngIf="serviceplanImportBO.modelTypename == 'BUDGET' 
                                            &&serviceplanImportBO.fmsBudget.is_Personal_Care_Workers">
                                                <label class="label">Describe the worker(s) job duties (i.e., the tasks you
                                                    want your worker[s] to do)</label>
                                                <textarea rows="7" class="form-control" cols="190" [disabled]="logintype =='onboardLogin'"
                                                    [(ngModel)]="serviceplanImportBO.fmsBudget.jobDescription" (change)="changefunction()"></textarea>
                                            </div>
                                           <div class="row mt-3" *ngIf="serviceplanImportBO.modelTypename == 'BUDGET' 
                                            &&serviceplanImportBO.fmsBudget.is_Personal_Care_Workers">
                                                <h5 class=" font-header" id="exampleModalLabel"><b>Worker budget
                                                    </b></h5>
                                            </div>
                                            <div class="row" style="margin-top: 16px;" *ngIf="serviceplanImportBO.modelTypename == 'BUDGET' && 
                                                                                         serviceplanImportBO.fmsBudget.is_Personal_Care_Workers">
                                                
                                                    <label>Your budget for CFSS workers will be:&nbsp;
                                                    </label>
                                                    <!--  budget -->
                                                    <span>
                                                        <input type="text" class="inputtext" disabled="true" [(ngModel)]="serviceplanImportBO.cfssWorkerBudget">
                                                    </span>&nbsp;
                                            
                                                
                                            </div>                       
    
                                            <div class="row mt-3" *ngIf="serviceplanImportBO.modelTypename == 'BUDGET'
                                            &&serviceplanImportBO.fmsBudget.is_Personal_Care_Workers">
                                                <h5 class=" font-header" id="exampleModalLabel"><b>Costs
                                                    </b></h5>
                                            </div>
                                            <div class="row mt-1" *ngIf="serviceplanImportBO.modelTypename == 'BUDGET' 
                                            &&serviceplanImportBO.fmsBudget.is_Personal_Care_Workers">
                                                <!-- <p><b>Reminder: </b>If the worker is your spouse or your parent (if you are
                                                    a minor), there are limits to the number of hours they can work and they
                                                    cannot
                                                    earn more than the current CFSS rate. If you have questions, your
                                                    consultation services provider and FMS can assist you.</p> -->
                                                    <p>This section is to help you think about how you might spend your worker budget. Keep in mind:</p>
                                            </div>

                                            <div class="row mt-1" *ngIf="serviceplanImportBO.modelTypename == 'BUDGET' 
                                            &&serviceplanImportBO.fmsBudget.is_Personal_Care_Workers">
                                            <ul  style="margin-left:30px">
                                                <li>Costs will change based on your decisions about wages and hours and the FMS’ determination of required taxes and
                                                    worker’s compensation.
                                                </li>
                                                <li>
                                                    You must pay your workers at least $20.00 an hour to comply with the Service Employees International Union (SEIU)
                                                    Healthcare Minnesota and lowa collective bargaining agreement.
                                                </li>
                                                </ul>
                                            
                                            </div>
    
                                            <div class="row mt-2" *ngIf="serviceplanImportBO.modelTypename == 'BUDGET' 
                                            &&serviceplanImportBO.fmsBudget.is_Personal_Care_Workers">
                                                <div style="overflow-x: auto;">
                                                    <table class="table  table-hover">
    
                                                        <tr style="border: 1px gray;">
                                                            <th>
                                                                <b>Worker</b> (e.g., worker's name,
                                                                "Worker 1," "Worker 2,"
                                                                "paid spouse," etc.)
                                                            </th>
                                                            <th>
                                                                <b>Hourly
                                                                    wage</b>
                                                            </th>
                                                            <th>
                                                                <b>Number
                                                                    of hours
                                                                    per week</b>
                                                            </th>
                                                            <th><b>Number
                                                                    of
                                                                    weeks</b>
                                                            </th>

                                                            <th><b>*Do payroll
                                                                taxes
                                                                apply?</b></th>
                                                            <th><b>*Does
                                                                    PTO
                                                                    apply?
                                                                </b>
    
                                                            </th>
                                                           
                                                            <th><b>*Does workers'
                                                                    comp apply?</b></th>
                                                            <th><b>Total</b></th>
    
                                                        </tr>
    
                                                        <tr style="border: 1px gray;"
                                                            *ngFor="let service of  serviceplanImportBO.fmsBudget.workerBudgets;let Contact=index">
                                                            <td>
                                                                {{ Contact+1}}.
    
                                                                <input type="text" class="form-control" [disabled]="logintype =='onboardLogin'"
                                                                    [(ngModel)]="service.worker_Name" (change)="changefunction()">
                                                            </td>
                                                            <td>
                                                                <input type="text" class="form-control" [disabled]="logintype =='onboardLogin'"
                                                                    [(ngModel)]="service.hourly_Wage" (ngModelChange)="calculateWorkerbudgetAmt(Contact)" (change)="changefunction()">
                                                            </td>
                                                            <td>
    
    
                                                                <input type="text" class="form-control" [disabled]="logintype =='onboardLogin'"
                                                                    [(ngModel)]="service.no_Of_Hours_Per_Week" (ngModelChange)="calculateWorkerbudgetAmt(Contact)" (change)="changefunction()">
    
                                                            </td>
    
    
                                                            <td>
    
    
                                                                <input type="text" class="form-control" [disabled]="logintype =='onboardLogin'"
                                                                    [(ngModel)]="service.no_Of_Weeks" (ngModelChange)="calculateWorkerbudgetAmt(Contact)" (change)="changefunction()">
                                                            </td>
                                                            <td>
                                                                <input type="radio" class="ml-2" name="payroll_{{Contact}}"
                                                                    [value]="true"
                                                                    [(ngModel)]="service.is_Payroll_Applied" (ngModelChange)="calculateWorkerbudgetAmt(Contact)" [disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                                     /> Yes &nbsp;
                                                                <input type="radio" class="ml-2" name="payroll_{{Contact}}"
                                                                    [value]="false"
                                                                    [(ngModel)]="service.is_Payroll_Applied"
                                                                    (ngModelChange)="calculateWorkerbudgetAmt(Contact)" (change)="changefunction()"
                                                                    [disabled]="logintype =='onboardLogin'"/>No &nbsp;
                                                            </td>
                                                            <td>
                                                                <input type="radio" class="ml-2" name="pto_{{Contact}}" [value]="true" [disabled]="logintype =='onboardLogin'"
                                                                    [(ngModel)]="service.is_PTO_Applied" (ngModelChange)="calculateWorkerbudgetAmt(Contact)" (change)="changefunction()"/> Yes &nbsp;
                                                                <input type="radio" class="ml-2" name="pto_{{Contact}}" [value]="false" [disabled]="logintype =='onboardLogin'"
                                                                    [(ngModel)]="service.is_PTO_Applied" (ngModelChange)="calculateWorkerbudgetAmt(Contact)" (change)="changefunction()"/>No &nbsp;
                                                            </td>
                                                         
                                                            <td>
                                                                <input type="radio" class="ml-2" name="isworkercomp_{{Contact}}"
                                                                    [value]="true"
                                                                    [(ngModel)]="service.is_Worker_Comp_Applied"
                                                                    [disabled]="logintype =='onboardLogin'"   (ngModelChange)="calculateWorkerbudgetAmt(Contact)" (change)="changefunction()"/> Yes
                                                                &nbsp;
                                                                <input type="radio" class="ml-2" name="isworkercomp_{{Contact}}"
                                                                    [value]="false" [disabled]="logintype =='onboardLogin'"
                                                                    [(ngModel)]="service.is_Worker_Comp_Applied" (ngModelChange)="calculateWorkerbudgetAmt(Contact)" (change)="changefunction()" />No &nbsp;
                                                            
                                                                    <!-- <input type="text" class="form-control"  *ngIf="service.is_Worker_Comp_Applied == true" [disabled]="logintype =='onboardLogin'"
                                                                    [(ngModel)]="service.percentageRate" (ngModelChange)="calculateWorkerbudgetAmt(Contact)"> -->
                                                                </td>
                                                            <td><label class="label">{{service.totalCost}}</label></td>
                                                            <td class="d-flex"><i class="fa fa-plus-circle text-primary" [disabled]="logintype =='onboardLogin'"
                                                                    *ngIf="Contact==0" style="font-size:30px"
                                                                    (click)="logintype !== 'onboardLogin' && Createworker()"></i>
    
    
                                                                <i style="font-size:27px;" *ngIf="Contact != 0" [disabled]="logintype =='onboardLogin'"
                                                                    (click)=" logintype !== 'onboardLogin' &&removeworker(Contact,service)"
                                                                    class="fa fa-trash text-danger"></i>
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td  style="text-align: right;">
                                                                Payroll Taxes
                                                            </td>
    
                                                            <td  colspan="3" >  PERCENTAGE OF PAYROLL TAXES &nbsp;
                                                                 <input type="text" class="form-control"  [disabled]="logintype =='onboardLogin'"
                                                                    [(ngModel)]="payrolltaxpercent" (ngModelChange)="calculateWorkercompAmt()" (change)="changefunction()">
                                                            </td>

                                                            <td  colspan="3" >PAYROLL WAGES &nbsp;
                                                                <input type="text" class="form-control"  disabled
                                                                   [(ngModel)]="payrolltotal">
                                                           </td>
                                                           <td   >
                                                            <input type="text" class="form-control"  disabled
                                                               [(ngModel)]="payrollgrandtotal">
                                                       </td>
    
                                                        </tr>

                                                        <tr>
                                                            <td  style="text-align: right;">
                                                                Paid time off (PTO)
                                                            </td>
    
                                                            <td  colspan="3" > PERCENTAGE OF PTO &nbsp;
                                                                 <input type="text" class="form-control"  [disabled]="logintype =='onboardLogin'"
                                                                    [(ngModel)]="ptotaxpercent" (ngModelChange)="calculateWorkercompAmt()" (change)="changefunction()" >
                                                            </td>

                                                            <td  colspan="3" > PTO WAGES &nbsp;
                                                                <input type="text" class="form-control"  disabled
                                                                   [(ngModel)]="ptototal">
                                                           </td>
                                                           <td   >
                                                            <input type="text" class="form-control"  disabled
                                                               [(ngModel)]="ptograndtotal">
                                                           </td>
    
                                                        </tr>

                                                        <tr>
                                                            <td  style="text-align: right;">
                                                               Workers' Compensation <br>
                                                               (if<1%, enter as 0.00XX)
                                                            </td>
    
                                                            <td  colspan="3" >PERCENTAGE OF WORKERS COMP&nbsp;
                                                                 <input type="text" class="form-control"  [disabled]="logintype =='onboardLogin'"
                                                                    [(ngModel)]="workertaxpercent"  (ngModelChange)="calculateWorkercompAmt()" (change)="changefunction()">
                                                            </td>

                                                            <td  colspan="3" > WORKERS' COMP WAGES&nbsp;
                                                                <input type="text" class="form-control"  disabled
                                                                   [(ngModel)]="Workercomptotal">
                                                           </td>
                                                           <td   >
                                                            <input type="text" class="form-control"  disabled
                                                               [(ngModel)]="Workercompgrandtotal">
                                                             </td>
    
                                                        </tr>
                                                         <tr>
                                                            <td  style="text-align: right;">
                                                               Minnesota paid leave <br>
                                                            </td>
    
                                                            <td  colspan="3" >PERCENTAGE OF PAID LEAVE&nbsp;
                                                                 <input type="text" class="form-control"  [disabled]="logintype =='onboardLogin'"
                                                                    [(ngModel)]="paidleavepercent"  (ngModelChange)="calculateWorkercompAmt()" (change)="changefunction()">
                                                            </td>

                                                            <td  colspan="3" > MINNESOTA PAID LEAVE WAGES&nbsp;
                                                                <input type="text" class="form-control"  disabled
                                                                   [(ngModel)]="plwtotal">
                                                           </td>
                                                           <td   >
                                                            <input type="text" class="form-control"  disabled
                                                               [(ngModel)]="paidleavegrandtotal">
                                                             </td>
    
                                                        </tr>
                                                        <tr>
                                                            <td colspan="7" style="text-align: right;">
                                                                Grand Total
                                                            </td>
    
                                                            <td><input type="text" class="form-control"  [disabled]="logintype =='onboardLogin'"
                                                                    [(ngModel)]="Workergrandtotal" (change)="changefunction()">
                                                            </td>
    
    
                                                        </tr>
                                                        <tr *ngIf="Budgetwarning">
                                                            <td colspan="7" style="text-align: right;">
                                                               <span  style="color: red;">WARNING: </span> You are over your worker budget by:
                                                            </td>
    
                                                            <td><input type="text" class="form-control"  [disabled]="true"
                                                                    [(ngModel)]="warningAmount">
                                                            </td>
    
    
                                                        </tr>
    
    
                                                    </table>
    
                                                </div>
    
                                            </div>
                                            <div class="row mt-3" *ngIf="serviceplanImportBO.modelTypename == 'BUDGET'
                                            &&serviceplanImportBO.fmsBudget.is_Personal_Care_Workers">
                                                <h4 class=" font-header" id="exampleModalLabel"><b>Worker training and
                                                        development
                                                    </b></h4>
                                            </div>
                                            <div class="row mt-1 " *ngIf="serviceplanImportBO.modelTypename == 'BUDGET'
                                            &&serviceplanImportBO.fmsBudget.is_Personal_Care_Workers">
                                                <label class="label">As the employer of your workers, you are responsible
                                                    to:</label>
    
                                            </div>
    
                                            <div class="row mt-1" *ngIf="serviceplanImportBO.modelTypename == 'BUDGET'
                                            &&serviceplanImportBO.fmsBudget.is_Personal_Care_Workers">
                                                <ul style="margin-left:30px">
                                                    <li>Ensure your workers are competent
                                                    </li>
                                                    <li>
                                                        Train your workers
    
                                                    </li>
                                                    <li>Supervise and evaluate your workers</li>
    
                                                </ul>
                                            </div>
    
                                            <div class="row mt-3 " *ngIf="serviceplanImportBO.modelTypename == 'BUDGET'
                                            &&serviceplanImportBO.fmsBudget.is_Personal_Care_Workers">
                                                <label class="label">Your consultation services provider will help you
                                                    through these
                                                    tasks as you carry out your plan.
    
                                                </label>
    
                                            </div>
                                            <div class="row mt-2 " *ngIf="serviceplanImportBO.modelTypename == 'BUDGET'
                                            &&serviceplanImportBO.fmsBudget.is_Personal_Care_Workers">
                                                <label class="label">List the tasks your workers will do and the
                                                    qualifications or
                                                    skills they need to be able to do each one.</label>
    
                                            </div>
    
                                            <div class="row mt-2 " *ngIf="serviceplanImportBO.modelTypename == 'BUDGET'
                                            &&serviceplanImportBO.fmsBudget.is_Personal_Care_Workers">
                                                <div style="overflow-x: auto;">
                                                    <table class="table  table-hover">
    
                                                        <tr style="border: 1px gray;">
                                                            <th>
                                                                <b> Worker task </b>
                                                            </th>
                                                            <th>
                                                                <b>Qualification/skills</b>
                                                            </th>
    
    
                                                        </tr>
    
                                                        <tr style="border: 1px gray;"
                                                            *ngFor="let service of  serviceplanImportBO.fmsBudget.workerTasks;let Contact=index">
                                                            <td>
    
    
                                                                <textarea type="text" class="form-control" [disabled]="logintype =='onboardLogin'"
                                                                    [(ngModel)]="service.task" (change)="changefunction()"></textarea>
                                                            </td>
                                                            <td>
                                                                <textarea type="text" class="form-control" [disabled]="logintype =='onboardLogin'"
                                                                    [(ngModel)]="service.qualifications" (change)="changefunction()"></textarea>
                                                            </td>
    
    
                                                            <td class="d-flex"><i class="fa fa-plus-circle text-primary" [disabled]="logintype =='onboardLogin'"
                                                                    *ngIf="Contact==0" style="font-size:30px"
                                                                    (click)="logintype !== 'onboardLogin' &&Createworkertask()"></i>
    
    
                                                                <i style="font-size:27px;" *ngIf="Contact != 0" [disabled]="logintype =='onboardLogin'"
                                                                    (click)="logintype !== 'onboardLogin' &&removeworkertask(Contact,service)"
                                                                    class="fa fa-trash text-danger"></i>
                                                            </td>
                                                        </tr>
    
    
    
                                                    </table>
    
                                                </div>
    
                                            </div>
    
    
                                            <div class="row mt-3 " *ngIf="serviceplanImportBO.modelTypename == 'BUDGET'">
                                                <h5 class=" font-header col-lg-8" id="exampleModalLabel"><b>Annual budget
                                                    </b></h5>
    
                                                    <label class="label col-lg-4" *ngIf="serviceplanImportBO.fmsBudget.budgetAmount != 0 && serviceplanImportBO.fmsBudget.budgetAmount!= null">$ {{serviceplanImportBO.fmsBudget.budgetAmount}}</label>
                                            </div>
                                            <div class="row mt-2 " *ngIf="serviceplanImportBO.modelTypename == 'BUDGET'">
                                                <div style="overflow-x: auto;">
                                                    <table class="table  table-hover colr">
    
    
    
                                                        <tr style="border: 1px gray;">
                                                            <td>
                                                                <label class="label">Goods and services (if applicable)
                                                                </label>
                                                            </td>
                                                            <td>
                                                               <label class="label" *ngIf="Goodsgrandtotal !=0 && Goodsgrandtotal!= null"> $ {{Goodsgrandtotal}}</label>
                                                            </td>
    
                                                        </tr>
                                                        <tr style="border: 1px gray;">
                                                            <td>
                                                                <label class="label">Personal care workers(if applicable)</label>
                                                            </td>
                                                            <td>
                                                                <label class="label" *ngIf="Workergrandtotal !=0 && Workergrandtotal!= null"> $ {{Workergrandtotal}}</label>
                                                          
                                                            </td>
    
                                                        </tr>
                                                        <tr style="border: 1px gray;">
                                                            <td>
                                                                <label class="label">Estimated annual FMS fee</label>
                                                            </td>
                                                            <td>
                                                                <!-- <input type="text" class="form-control"> -->
                                                                <label class="label" *ngIf="Fmsfee !=0 && Fmsfee!= null">$ {{Fmsfee}}</label>
                                                          
                                                            </td>
    
                                                        </tr>
                                                        <tr style="border: 1px gray;">
                                                            <td>
                                                                <label class="label">PERS costs (if
                                                                    applicable)</label>
                                                            </td>
                                                            <td>
                                                                <label class="label" *ngIf="mhcptotal !=0 && mhcptotal!= null">$ {{mhcptotal}}</label>
                                                          
                                                             
                                                            </td>
    
                                                        </tr>
    
    
                                                        <tr>
                                                            <td colspan="1" style="text-align: right;">
                                                                Grand Total
                                                            </td>
    
                                                            <td>    <label class="label" *ngIf="AnnualTotal !=0 && AnnualTotal!= null">$ {{AnnualTotal}}</label>
                                                            </td>
    
    
                                                        </tr>
                                                        <!-- <tr>
                                                            <td colspan="1" style="text-align: right;">
                                                                Unused budget amount
                                                            </td>
    
                                                            <td>    <label class="label" *ngIf="AnnualTotal !=0 && AnnualTotal!= null">$ {{Unusedbudget}}</label>
                                                            </td>
    
    
                                                        </tr> -->
    
    
                                                    </table>
    
                                                </div>
    
                                            </div>
    
                                            <div class="row mt-3 " *ngIf="serviceplanImportBO.modelTypename == 'BUDGET'">

                                                <label class="label"><b>Note: </b>The lead agency will add all unused budget dollars to support workers in your service agreement.</label>
                                                        </div>
                                            <div class="row mt-3 " *ngIf="(serviceplanImportBO.modelTypename == 'BUDGET' && serviceplanImportBO.fmsBudget.is_Personal_Care_Workers == true) ||serviceplanImportBO.modelTypename == 'AGENCY'">
                                                <h5 class=" font-header" id="exampleModalLabel"><b>Personal care Services
                                                    </b></h5>
                                            </div>
                                            <div class="row mt-3 "  *ngIf="(serviceplanImportBO.modelTypename == 'BUDGET' && serviceplanImportBO.fmsBudget.is_Personal_Care_Workers == true) ||serviceplanImportBO.modelTypename == 'AGENCY'">
                                                <h5 class=" font-header" id="exampleModalLabel"><b>Activities of daily
                                                        living (ADLs)
                                                    </b></h5>
                                            </div>
                                                    <div class="row mt-1"
                                                        *ngIf="(serviceplanImportBO.modelTypename == 'BUDGET' && serviceplanImportBO.fmsBudget.is_Personal_Care_Workers == true) || serviceplanImportBO.modelTypename == 'AGENCY'">
                                                        <p>Enter a row:</p>
                                                        <ul style="margin-left: 22px;">
                                                            <li>All ADLs identified in your assessment results, even if you won't get help from a paid worker for that ADL.
                                                            </li>
                                                            <li>All other ADLs a paid worker will perform.</li>
                                                        </ul>
                                                    </div>
    
                                            <div class="row mt-2 "  *ngIf="(serviceplanImportBO.modelTypename == 'BUDGET' && serviceplanImportBO.fmsBudget.is_Personal_Care_Workers == true) ||serviceplanImportBO.modelTypename == 'AGENCY'">
                                                <!-- <div style="overflow-x: auto;"> -->
                                                    <table class="table  table-hover">
    
                                                        <tr style="border: 1px gray;">
                                                            <th>
                                                                <b>Assessed need</b>
                                                            </th>
                                                            <th>
                                                                <b>From whom?</b>
                                                            </th>
                                                            <th>
                                                                <b>What will the caregiver do? </b>
                                                            </th>
                                                            <th><b>How will the caregiver do it</b>
                                                            </th>
    
    
                                                        </tr>
    
                                                        <tr style="border: 1px gray;"
                                                            *ngFor="let service of aDls;let Contact=index">
                                                            <td>
                                                                <ng-select [items]="adlsAssedneed" class="width25" [disabled]="logintype =='onboardLogin'"
                                                                    [searchable]="true" [clearable]="true" bindLabel="Key"
                                                                    bindValue="Key" [(ngModel)]="service.assesedNeed" (change)="changefunction()">
                                                                </ng-select>
    
                                                            </td>
                                                            <td>
                                                                <ng-select [items]="adls_Fromwhom" class="width25" [disabled]="logintype =='onboardLogin'"
                                                                    [searchable]="true" [clearable]="true" bindLabel="Key"
                                                                    bindValue="Key" [(ngModel)]="service.fromWhom" (change)="changefunction()">
                                                                </ng-select>
                                                            </td>
                                                            <td>
    
    
                                                                <textarea type="text" class="form-control" [disabled]="logintype =='onboardLogin'"
                                                                    [(ngModel)]="service.what_will_Caregiver_do" (change)="changefunction()"></textarea>
    
                                                            </td>
    
    
                                                            <td>
    
                                                                
                                                                <textarea type="text" class="form-control" [disabled]="logintype =='onboardLogin'"
                                                                    [(ngModel)]="service.how_will_Caregiver_do" (change)="changefunction()"></textarea>
                                                            </td>
    
    
                                                            <td class="d-flex"><i class="fa fa-plus-circle text-primary"
                                                                    *ngIf="Contact==0" style="font-size:30px" [disabled]="logintype =='onboardLogin'"
                                                                    (click)="logintype !== 'onboardLogin' &&Createadls()"></i>
    
    
                                                                <i style="font-size:27px;" *ngIf="Contact != 0" [disabled]="logintype =='onboardLogin'"
                                                                    (click)="logintype !== 'onboardLogin' &&removeadls(Contact,service)"
                                                                    class="fa fa-trash text-danger"></i>
                                                            </td>
                                                        </tr>
    
                                                    </table>
    
                                                <!-- </div> -->
    
                                            </div>
                                            <div class="row mt-3 "  *ngIf="(serviceplanImportBO.modelTypename == 'BUDGET' && serviceplanImportBO.fmsBudget.is_Personal_Care_Workers == true) ||serviceplanImportBO.modelTypename == 'AGENCY'">
                                                <h5 class=" font-header" id="exampleModalLabel"><b>Instrumental activities
                                                        of daily
                                                        living (IADLs)
                                                    </b></h5>
                                            </div>
    
                                            <div class="row mt-2 "  *ngIf="(serviceplanImportBO.modelTypename == 'BUDGET' && serviceplanImportBO.fmsBudget.is_Personal_Care_Workers == true) ||serviceplanImportBO.modelTypename == 'AGENCY'">
                                                <label class="label">Enter a row for each IADL a paid worker will perform. You also can choose to include rows for IADLs an informal caregiver will perform.</label>
                                                <label class="label">Examples of IADLs include meal planning and
                                                    preparation, shopping
                                                    for essential items, laundry, paying bills,
                                                    communicating, assisting with community participation, driving.</label>
                                            </div>
                                            <div class="row mt-1 "  *ngIf="(serviceplanImportBO.modelTypename == 'BUDGET' && serviceplanImportBO.fmsBudget.is_Personal_Care_Workers == true) ||serviceplanImportBO.modelTypename == 'AGENCY'">
                                                <p><b>Note: </b>IADLs are not covered for people under 18, with some
                                                    exceptions. Ask
                                                    your consultation services provider if you're not sure</p>
                                            </div>
    
                                            <div class="row mt-2 "  *ngIf="(serviceplanImportBO.modelTypename == 'BUDGET' && serviceplanImportBO.fmsBudget.is_Personal_Care_Workers == true) ||serviceplanImportBO.modelTypename == 'AGENCY'">
                                                <!-- <div style="overflow-x: auto;"> -->
                                                    <table class="table  table-hover">
    
                                                        <tr style="border: 1px gray;">
                                                            <th>
                                                                <b>Need</b>
                                                            </th>
                                                            <th>
                                                                <b>From whom?</b>
                                                            </th>
                                                            <th>
                                                                <b>What will the caregiver do?</b>
                                                            </th>
                                                            <th>
                                                                <b>How will the caregiver do it?</b>
                                                            </th>
    
    
                                                        </tr>
    
                                                        <tr style="border: 1px gray;"
                                                            *ngFor="let service of instrumentalActivities;let Contact=index">
                                                            <td>
                                                                <ng-select [items]="Iadls_Need" class="width25" [disabled]="logintype =='onboardLogin'"
                                                                    [searchable]="true" [clearable]="true" bindLabel="Key"
                                                                    bindValue="Key"  [(ngModel)]="service.assesedNeed" (change)="changefunction()">
                                                                </ng-select>
                                                            </td>
                                                            <td>
                                                                <ng-select [items]="adls_Fromwhom" class="width25" [disabled]="logintype =='onboardLogin'"
                                                                    [searchable]="true" [clearable]="true" bindLabel="Key"
                                                                    bindValue="Key"  [(ngModel)]="service.fromwhom" (change)="changefunction()">
                                                                </ng-select>
                                                            </td>
                                                            <td>
                                                                <textarea type="text" class="form-control" [disabled]="logintype =='onboardLogin'"
                                                                    [(ngModel)]="service.what_will_Caregiver_do" (change)="changefunction()"></textarea>
                                                            </td>
                                                            <td>
    
    
                                                                <textarea type="text" class="form-control" [disabled]="logintype =='onboardLogin'"
                                                                    [(ngModel)]="service.how_will_Caregiver_do" (change)="changefunction()"></textarea>
    
                                                            </td>
    
    
    
                                                            <td class="d-flex"><i class="fa fa-plus-circle text-primary"
                                                                    *ngIf="Contact==0" style="font-size:30px" [disabled]="logintype =='onboardLogin'"
                                                                    (click)="logintype !== 'onboardLogin' &&CreateIadls()"></i>
    
    
                                                                <i style="font-size:27px;" *ngIf="Contact != 0" [disabled]="logintype =='onboardLogin'"
                                                                    (click)="logintype !== 'onboardLogin' &&removeIadls(Contact,service)"
                                                                    class="fa fa-trash text-danger"></i>
                                                            </td>
                                                        </tr>
    
                                                    </table>
    
                                                <!-- </div> -->
    
                                            </div>
    
                                            <div class="row mt-3 "  *ngIf="(serviceplanImportBO.modelTypename == 'BUDGET' && serviceplanImportBO.fmsBudget.is_Personal_Care_Workers == true) ||serviceplanImportBO.modelTypename == 'AGENCY'">
                                                <h4 class=" font-header" id="exampleModalLabel"><b>Observation and
                                                        redirection of
                                                        behaviors
                                                    </b></h4>
                                            </div>
                                            <div class="row mt-2 "  *ngIf="(serviceplanImportBO.modelTypename == 'BUDGET' && serviceplanImportBO.fmsBudget.is_Personal_Care_Workers == true) ||serviceplanImportBO.modelTypename == 'AGENCY'">
                                                <label class="label col-lg-4">Do you require observation and
                                                    redirection?</label>
                                                <div class="col-lg-3">
                                                    <input type="radio" class="ml-2" name="observation" [value]="true" [disabled]="logintype =='onboardLogin'"
                                                        [(ngModel)]="serviceplanImportBO.isRedirectionRequired" (change)="changefunction()" /> Yes
                                                    &nbsp;
                                                    <input type="radio" class="ml-2" name="observation" [value]="false" [disabled]="logintype =='onboardLogin'"
                                                        [(ngModel)]="serviceplanImportBO.isRedirectionRequired" (change)="changefunction()" />No &nbsp;
                                                </div>
                                            </div>
    
    
                                            <div class="row mt-3 " *ngIf=" serviceplanImportBO.isRedirectionRequired">
                                                <h5 class=" font-header" id="exampleModalLabel"><b>Redirection
                                                    </b></h5>
                                            </div>
                                            <div class="row mt-2 " *ngIf="serviceplanImportBO.isRedirectionRequired">
                                                <label class="label ">Complete the following to document how you want your
                                                    worker(s) to
                                                    observe/redirect behaviors.</label>
                                            </div>
                                            <div class="row mt-2 " *ngIf="serviceplanImportBO.isRedirectionRequired">
                                                <div style="overflow-x: auto;">
                                                    <table class="table  table-hover">
    
                                                        <tr style="border: 1px gray;">
                                                            <th>
                                                                <b>When I do:</b>
                                                            </th>
                                                            <th>
                                                                <b>It means:</b>
                                                            </th>
                                                            <th>
                                                                <b>The worker can help by:</b>
                                                            </th>
    
    
                                                        </tr>
    
                                                        <tr style="border: 1px gray;"
                                                            *ngFor="let service of behaviours;let Contact=index">
                                                            <td>
    
                                                                <textarea type="text" class="form-control" [disabled]="logintype =='onboardLogin'"
                                                                    [(ngModel)]="service.when_I_do" (change)="changefunction()"></textarea>
                                                            </td>
                                                            <td>
                                                                <textarea type="text" class="form-control" [disabled]="logintype =='onboardLogin'"
                                                                    [(ngModel)]="service.it_means" (change)="changefunction()"></textarea>
                                                            </td>
                                                            <td>
    
    
                                                                <textarea type="text" class="form-control" [disabled]="logintype =='onboardLogin'"
                                                                    [(ngModel)]="service.worker_can_help_by" (change)="changefunction()"></textarea>
    
                                                            </td>
    
    
    
    
                                                            <td class="d-flex"><i class="fa fa-plus-circle text-primary"
                                                                    *ngIf="Contact==0" style="font-size:30px" [disabled]="logintype =='onboardLogin'"
                                                                    (click)="logintype !== 'onboardLogin' &&Createbehaviour()"></i>
    
    
                                                                <i style="font-size:27px;" *ngIf="Contact != 0" [disabled]="logintype =='onboardLogin'"
                                                                    (click)="logintype !== 'onboardLogin' &&removebehaviour(Contact,service)"
                                                                    class="fa fa-trash text-danger"></i>
                                                            </td>
                                                        </tr>
    
                                                    </table>
    
                                                </div>
    
                                            </div>
    
                                            <div class="row mt-3 "  *ngIf="(serviceplanImportBO.modelTypename == 'BUDGET' && serviceplanImportBO.fmsBudget.is_Personal_Care_Workers == true) ||serviceplanImportBO.modelTypename == 'AGENCY'">
                                                <h4 class=" font-header" id="exampleModalLabel"><b>Health-related procedures
                                                        and tasks
                                                    </b></h4>
                                            </div>
                                            <div class="row mt-2 "  *ngIf="(serviceplanImportBO.modelTypename == 'BUDGET' && serviceplanImportBO.fmsBudget.is_Personal_Care_Workers == true) ||serviceplanImportBO.modelTypename == 'AGENCY'">
                                                <label class="label col-lg-4">Do you require support with health-related
                                                    procedures and
                                                    tasks?</label>
                                                <div class="col-lg-3">
                                                    <input type="radio" class="ml-2" name="health" [value]="true" [disabled]="logintype =='onboardLogin'"
                                                        [(ngModel)]="serviceplanImportBO.isHealthProceduresRequired" (change)="changefunction()" /> Yes
                                                    &nbsp;
                                                    <input type="radio" class="ml-2" name="health" [value]="false" [disabled]="logintype =='onboardLogin'"
                                                        [(ngModel)]="serviceplanImportBO.isHealthProceduresRequired" (change)="changefunction()" />No
                                                    &nbsp;
                                                </div>
                                            </div>
                                            <div class="row mt-2 " *ngIf="serviceplanImportBO.isHealthProceduresRequired">
                                                <label class="label "> CFSS workers only can perform some health-related
                                                    tasks. Your
                                                    consultation services provider can tell you if a task is
                                                    covered.</label>
                                            </div>
    
                                            <div class="row mt-2 " *ngIf="serviceplanImportBO.isHealthProceduresRequired">
                                                <div style="overflow-x: auto;">
                                                    <table class="table  table-hover">
    
                                                        <tr style="border: 1px gray;">
                                                            <th>
                                                                <b>Need</b>
                                                            </th>
                                                            <th>
                                                                <b>What will the worker do?</b>
                                                            </th>
                                                            <th>
                                                                <b> How will the worker do it?</b>
                                                            </th>
    
    
                                                        </tr>
    
                                                        <tr style="border: 1px gray;"
                                                            *ngFor="let service of healthProcedures;let Contact=index">
                                                            <td>
    
                                                                <textarea type="text" class="form-control" [disabled]="logintype =='onboardLogin'"
                                                                    [(ngModel)]="service.need" (change)="changefunction()"></textarea>
                                                            </td>
                                                            <td>
                                                                <textarea type="text" class="form-control" [disabled]="logintype =='onboardLogin'"
                                                                    [(ngModel)]="service.what_will_worker_do" (change)="changefunction()"></textarea>
                                                            </td>
                                                            <td>
    
    
                                                                <textarea type="text" class="form-control" [disabled]="logintype =='onboardLogin'"
                                                                    [(ngModel)]="service.how_will_worker_do" (change)="changefunction()"></textarea>
    
                                                            </td>
    
    
    
    
                                                            <td class="d-flex"><i class="fa fa-plus-circle text-primary" [disabled]="logintype =='onboardLogin'"
                                                                    *ngIf="Contact==0" style="font-size:30px"
                                                                    (click)="logintype !== 'onboardLogin' &&CreatehealthProcedures()"></i>
    
    
                                                                <i style="font-size:27px;" *ngIf="Contact != 0" [disabled]="logintype =='onboardLogin'"
                                                                    (click)="logintype !== 'onboardLogin' &&removehealthProcedures(Conact,service)"
                                                                    class="fa fa-trash text-danger"></i>
                                                            </td>
                                                        </tr>
    
                                                    </table>
    
                                                </div>
    
                                            </div>
    
                                            <div class="row mt-3 "  *ngIf="(serviceplanImportBO.modelTypename == 'BUDGET' && serviceplanImportBO.fmsBudget.is_Personal_Care_Workers == true) ||serviceplanImportBO.modelTypename == 'AGENCY'">
                                                <h4 class=" font-header" id="exampleModalLabel"><b>Self-administered
                                                        medications
                                                    </b></h4>
                                            </div>
    
                                            <div class="row mt-2 "  *ngIf="(serviceplanImportBO.modelTypename == 'BUDGET' && serviceplanImportBO.fmsBudget.is_Personal_Care_Workers == true) ||serviceplanImportBO.modelTypename == 'AGENCY'">
                                                <label class="label col-lg-4">Do you require support to take
                                                    self-administered
                                                    medications?</label>
                                                <div class="col-lg-3">
                                                    <input type="radio" class="ml-2" name="medications" [value]="true" [disabled]="logintype =='onboardLogin'"
                                                        [(ngModel)]="serviceplanImportBO.isMedicationsRequired" (change)="changefunction()" /> Yes
                                                    &nbsp;
                                                    <input type="radio" class="ml-2" name="medications" [value]="false" [disabled]="logintype =='onboardLogin'"
                                                        [(ngModel)]="serviceplanImportBO.isMedicationsRequired" (change)="changefunction()" />No &nbsp;
                                                </div>
                                            </div>
    
                                            <div class="row mt-3 " *ngIf="serviceplanImportBO.isMedicationsRequired">
                                                <h5 class=" font-header" id="exampleModalLabel"><b>Taking medication
                                                    </b></h5>
                                            </div>
    
                                            <div class="row mt-2 " *ngIf="serviceplanImportBO.isMedicationsRequired">
                                                <label class="label "> When I need support, I will direct the worker
                                                    to:</label>
                                            </div>
                                            <div class="row mt-2 " *ngIf="serviceplanImportBO.isMedicationsRequired">
                                                <div class="col-lg-3">
                                                    <input type="checkbox" [disabled]="logintype =='onboardLogin'"
                                                        [(ngModel)]="serviceplanImportBO.bringMedications" (change)="changefunction()"> &nbsp; <b>Bring
                                                        me my medications</b>
                                                </div>
    
                                                <div class="col-lg-4">
                                                    <input type="checkbox" [disabled]="logintype =='onboardLogin'"
                                                        [(ngModel)]="serviceplanImportBO.bringMedicationItems" (change)="changefunction()">
                                                    &nbsp;<b>Bring me items I need to take my
                                                        medications (water, food, etc)</b>
                                                </div>
                                                <div class="col-lg-4">
                                                    <input type="checkbox" [(ngModel)]="serviceplanImportBO.other" [disabled]="logintype =='onboardLogin'" (change)="changefunction()">
                                                    &nbsp;<b>other</b>

                                                    <textarea rows="7" class="form-control" cols="190" *ngIf="serviceplanImportBO.other" [disabled]="logintype =='onboardLogin'"
                                                    [(ngModel)]="serviceplanImportBO.otherDetails"></textarea>
    
                                                </div>
                                            </div>
    
                                            <div class="row mt-1 " *ngIf="serviceplanImportBO.isMedicationsRequired">
                                                <label class="label ">Describe your medication instructions (for example, "I
                                                    need to take with food," "set out my meds this way," etc.)</label>
                                                <textarea rows="7" class="form-control" cols="190" [disabled]="logintype =='onboardLogin'"
                                                    [(ngModel)]="serviceplanImportBO.medicationInstructionsDetails" (change)="changefunction()"></textarea>
    
                                            </div>
                                            <div class="row mt-1 " *ngIf="serviceplanImportBO.isMedicationsRequired">
                                                <label class="label ">What reminders about times do you need for
                                                    medications?</label>
                                                <textarea rows="7" class="form-control" cols="190" [disabled]="logintype =='onboardLogin'"
                                                    [(ngModel)]="serviceplanImportBO.medicationTimeReminders" (change)="changefunction()"></textarea>
    
                                            </div>
    
                                            <div class="row mt-3 " *ngIf="(serviceplanImportBO.modelTypename == 'BUDGET' && serviceplanImportBO.fmsBudget.is_Personal_Care_Workers == true) ||serviceplanImportBO.modelTypename == 'AGENCY'">
                                                <h4 class=" font-header" id="exampleModalLabel"><b>Skill maintenance and
                                                        enhancement
                                                    </b></h4>
                                            </div>
    
                                            <div class="row mt-2 " *ngIf="(serviceplanImportBO.modelTypename == 'BUDGET' && serviceplanImportBO.fmsBudget.is_Personal_Care_Workers == true) ||serviceplanImportBO.modelTypename == 'AGENCY'">
                                                <label class="label col-lg-4">Does your plan include skill maintenance and
                                                    enhancement?</label>
                                                <div class="col-lg-3">
                                                    <input type="radio" class="ml-2" name="maintenance" [value]="true" [disabled]="logintype =='onboardLogin'"
                                                        [(ngModel)]="serviceplanImportBO.isSkillEnhancement_Included" (change)="changefunction()" /> Yes
                                                    &nbsp;
                                                    <input type="radio" class="ml-2" name="maintenance" [value]="false" [disabled]="logintype =='onboardLogin'"
                                                        [(ngModel)]="serviceplanImportBO.isSkillEnhancement_Included" (change)="changefunction()" />No
                                                    &nbsp;
                                                </div>
                                                
                                            </div>
                                            <div class="row mt-1 " *ngIf="serviceplanImportBO.isSkillEnhancement_Included">
                                                <label class="label ">Describe your plan</label>
                                                <textarea rows="7" class="form-control" cols="190" [disabled]="logintype =='onboardLogin'"
                                                    [(ngModel)]="serviceplanImportBO.maintenancePlan" (change)="changefunction()"></textarea>
    
                                            </div>
                                            <div class="row mt-3 " *ngIf="(serviceplanImportBO.modelTypename == 'BUDGET' && serviceplanImportBO.fmsBudget.is_Personal_Care_Workers == true) ||serviceplanImportBO.modelTypename == 'AGENCY'">
                                                <h4 class=" font-header" id="exampleModalLabel"><b>Classes
                                                    </b></h4>
                                            </div>
                                            <div class="row mt-2 "  *ngIf="serviceplanImportBO.modelTypename == 'AGENCY'">
                                                <label class="label "> Leave this section blank. You and your agency complete this section together. <br/>
                                                    <strong>Note:</strong> The provider agency can choose to document this information in another location<br/>  </label>
                                            </div>
                                            <div class="row mt-2 "  *ngIf="(serviceplanImportBO.modelTypename == 'BUDGET' && serviceplanImportBO.fmsBudget.is_Personal_Care_Workers == true)">
                                                <label class="label "> This section is optional.<br/> 
                                                   </label>
                                            </div>
                                            <!-- <div class="row mt-2 "  *ngIf="(serviceplanImportBO.modelTypename == 'BUDGET' && serviceplanImportBO.fmsBudget.is_Personal_Care_Workers == true) ||serviceplanImportBO.modelTypename == 'AGENCY'">
                                                <p > <b>Notes: </b>The provider agency can choose to document this information in another location.</p>
                                            </div>
     -->
                                            <div class="row mt-2 " *ngIf="(serviceplanImportBO.modelTypename == 'BUDGET' && serviceplanImportBO.fmsBudget.is_Personal_Care_Workers == true) ||serviceplanImportBO.modelTypename == 'AGENCY'">
                                                <div style="overflow-x: auto;">
                                                    <table class="table table-hover">
    
                                                        <tr style="border: 1px gray;">
                                                            <th>
                                                                <b>Class name</b>
                                                            </th>
                                                            <th>
                                                                <b>Training provider</b>
                                                            </th>
                                                            <th>
                                                                <b>Cost</b>
                                                            </th>
    
    
                                                        </tr>
    
                                                        <tr style="border: 1px gray;"
                                                            *ngFor="let service of classes;let Contact=index">
                                                            <td>
    
                                                                <input type="text" class="form-control"[disabled]="logintype =='onboardLogin'"
                                                                    [(ngModel)]="service.className" (change)="changefunction()">
                                                            </td>
                                                            <td>
                                                                <input type="text" class="form-control"[disabled]="logintype =='onboardLogin'"
                                                                    [(ngModel)]="service.trainingProvider" (change)="changefunction()">
                                                            </td>
                                                            <td>
    
    
                                                                <input type="number" class="form-control" [disabled]="logintype =='onboardLogin'"
                                                                    [(ngModel)]="service.cost" (ngModelChange)="Calculateclasses()" (change)="changefunction()">
    
                                                            </td>
    
    
    
    
                                                            <td class="d-flex"><i class="fa fa-plus-circle text-primary"
                                                                    *ngIf="Contact==0" style="font-size:30px" [disabled]="logintype =='onboardLogin'"
                                                                    (click)="logintype !== 'onboardLogin' &&Createclasses()"></i>
    
    
                                                                <i style="font-size:27px;" *ngIf="Contact != 0" [disabled]="logintype =='onboardLogin'"
                                                                    (click)="logintype !== 'onboardLogin' &&removeclasses(Contact,service)"
                                                                    class="fa fa-trash text-danger"></i>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td colspan="2">
                                                                <b>Total</b>
                                                            </td>
                                                            <td>
    
    
                                                                <input type="text" class="form-control" [disabled]="logintype =='onboardLogin'"
                                                                    [(ngModel)]="classtotal" (change)="changefunction()">
    
                                                            </td>
    
                                                        </tr>
    
                                                    </table>
    
                                                </div>
    
                                            </div>
                                             <div class="row mt-3 ">
                                                <h4 class=" font-header" id="exampleModalLabel"><b>Shared care
                                                    </b></h4>
                                            </div>
    
                                            <div class="row mt-2 ">
                                                <label class="label col-lg-4">Are you interested in using shared care?</label>
                                                <div class="col-lg-3">
                                                    <input type="radio" class="ml-2" name="sharedcare" [(ngModel)]="serviceplanImportBO.isSharedCare" [value]="true" (change)="changefunction()" /> Yes
                                                    &nbsp;
                                                    <input type="radio" class="ml-2" name="sharedcare"  [(ngModel)]="serviceplanImportBO.isSharedCare" [value]="false"  (change)="changefunction()" />No
                                                    &nbsp;
                                                </div>
                                                
                                            </div>
                                            <div class="row mt-3 ">
                                                <h3 class=" font-header" id="exampleModalLabel"><b>Backup and emergency
                                                        plans
                                                    </b></h3>
                                            </div>
                                            <div class="row mt-3 " *ngIf="(serviceplanImportBO.modelTypename =='BUDGET'? serviceplanImportBO?.fmsBudget?.is_Personal_Care_Workers : false)||   serviceplanImportBO.modelTypename == 'AGENCY'">
                                                <h4 class=" font-header" id="exampleModalLabel"><b>Worker absences
                                                    </b></h4>
                                            </div>
                                            <div class="row mt-2 "*ngIf="(serviceplanImportBO.modelTypename =='BUDGET'? serviceplanImportBO?.fmsBudget?.is_Personal_Care_Workers : false)||   serviceplanImportBO.modelTypename == 'AGENCY'">
                                                <label class="label ">What will you do if your worker does not show up for
                                                    work?</label>
                                                <textarea rows="7" class="form-control" cols="190" [disabled]="logintype =='onboardLogin'"
                                                    [(ngModel)]="serviceplanImportBO.workerAbsencePlan" (change)="changefunction()"></textarea>
                                            </div>
    
                                            <div class="row mt-3 ">
                                                <h4 class=" font-header" id="exampleModalLabel"><b>Medical emergencies
                                                    </b></h4>
                                            </div>
                                            <div class="row mt-2 ">
                                                <label class="label ">The following are signs I am having a medical
                                                    emergency:</label>
                                                <textarea rows="7" class="form-control" cols="190" [disabled]="logintype =='onboardLogin'"
                                                    [(ngModel)]="serviceplanImportBO.medicalEmergencySigns" (change)="changefunction()"></textarea>
                                            </div>
                                            <div class="row mt-2 ">
                                                <label class="label ">What are some special considerations to know regarding
                                                    medical emergencies for me?</label>
                                                <textarea rows="7" class="form-control" cols="190" [disabled]="logintype =='onboardLogin'"
                                                    [(ngModel)]="serviceplanImportBO.medicalEmergencySpecialConsiderations" (change)="changefunction()"></textarea>
                                            </div>
    
                                            <div class="row mt-3 ">
                                                <h4 class=" font-header" id="exampleModalLabel"><b>Providers
                                                    </b>(optional)</h4>
                                            </div>
                                            <div class="row mt-2 ">
                                                <label class="label ">These are my medical providers (doctors, physicians,
                                                    nurse practitioner, etc.).</label>
    
                                            </div>
                                            <div class="row mt-2 ">
                                                <div style="overflow-x: auto;">
                                                    <table class="table  table-hover">
    
                                                        <tr style="border: 1px gray;">
                                                            <th>
                                                                <b>Name</b>
                                                            </th>
                                                            <th>
                                                                <b>Specialty</b>
                                                            </th>
                                                            <th>
                                                                <b>Phone number</b>
                                                            </th>
                                                            <th>
                                                                <b>Address</b>
                                                            </th>
    
    
                                                        </tr>
    
                                                        <tr style="border: 1px gray;"
                                                            *ngFor="let service of  serviceplanImportBO.providers;let Contact=index">
                                                            <td>
    
                                                                <textarea type="text" class="form-control" [disabled]="logintype =='onboardLogin'"
                                                                    [(ngModel)]="service.providerName" (change)="changefunction()"></textarea>
                                                            </td>
                                                            <td>
                                                                <textarea type="text" class="form-control" [disabled]="logintype =='onboardLogin'"
                                                                    [(ngModel)]="service.specialty" (change)="changefunction()"></textarea>
                                                            </td>
                                                            <td>
    
    
                                                                <input type="text" class="form-control"
                                                                    [(ngModel)]="service.phoneNumber"    [disabled]="logintype =='onboardLogin'"
                                                                    (ngModelChange)="DemographicPhoneFormatProvider(service,Contact);validchange_ProviderPhn(Contact,service)"
                                                                    (keypress)="keyPress($event)" maxlength="14" minlength="14" (change)="changefunction()"
                                                                   >
    
                                                            </td>
                                                            <td>
    
    
                                                                <textarea type="text" class="form-control" [disabled]="logintype =='onboardLogin'"
                                                                    [(ngModel)]="service.address" (change)="changefunction()"></textarea>
    
                                                            </td>
    
    
    
    
                                                            <td class="d-flex"><i class="fa fa-plus-circle text-primary"
                                                                    *ngIf="Contact==0" style="font-size:30px" [disabled]="logintype =='onboardLogin'"
                                                                    (click)="logintype !== 'onboardLogin' &&Createproviders()" (change)="changefunction()"></i>
    
    
                                                                <i style="font-size:27px;" *ngIf="Contact != 0" [disabled]="logintype =='onboardLogin'"
                                                                    (click)="logintype !== 'onboardLogin' &&removeproviders(Contact,service)"
                                                                    class="fa fa-trash text-danger" (change)="changefunction()"></i>
                                                            </td>
                                                        </tr>
    
                                                    </table>
    
                                                </div>
    
                                            </div>
                                            <div class="row mt-3 ">
                                                <h4 class=" font-header" id="exampleModalLabel"><b>How to respond to medical
                                                        emergencies
                                                    </b></h4>
                                            </div>
                                            <div class="row mt-2 ">
                                                <div style="overflow-x: auto;">
                                                    <table class="table  table-hover">
    
                                                        <tr style="border: 1px gray;">
                                                            <th>
                                                                <b>If this happens</b>
                                                            </th>
                                                            <th>
                                                                <b>Contact</b>
                                                            </th>
                                                            <th>
                                                                <b>Special instructions</b>
                                                            </th>
    
    
                                                        </tr>
    
                                                        <tr style="border: 1px gray;"
                                                            *ngFor="let service of  serviceplanImportBO.medicalEmergencies;let Contact=index">
                                                            <td>
    
                                                                <textarea type="text" class="form-control" [disabled]="logintype =='onboardLogin'"
                                                                    [(ngModel)]="service.if_this_happens" (change)="changefunction()"></textarea>
                                                            </td>
                                                            <td>
                                                                <textarea type="text" class="form-control" [disabled]="logintype =='onboardLogin'"
                                                                    [(ngModel)]="service.contact" (change)="changefunction()"></textarea>
                                                            </td>
                                                            <td>
    
    
                                                                <textarea type="text" class="form-control" [disabled]="logintype =='onboardLogin'"
                                                                    [(ngModel)]="service.specialInstructions" (change)="changefunction()"></textarea>
    
                                                            </td>
    
    
    
    
                                                            <td class="d-flex"><i class="fa fa-plus-circle text-primary"
                                                                    *ngIf="Contact==0" style="font-size:30px" [disabled]="logintype =='onboardLogin'"
                                                                    (click)="logintype !== 'onboardLogin' &&Createmedicalemergencies()" (change)="changefunction()"></i>
    
    
                                                                <i style="font-size:27px;" *ngIf="Contact != 0" [disabled]="logintype =='onboardLogin'"
                                                                    (click)="logintype !== 'onboardLogin' &&removemedicalemergencies(Contact,service)"
                                                                    class="fa fa-trash text-danger" (change)="changefunction()"></i>
                                                            </td>
                                                        </tr>
    
                                                    </table>
    
                                                </div>
    
                                            </div>
    
                                            <div class="row mt-3 ">
                                                <h4 class=" font-header" id="exampleModalLabel"><b>Non-medical emergencies
    
                                                    </b></h4>
                                            </div>
                                            <div class="row mt-3 ">
                                                <h5 class=" font-header" id="exampleModalLabel"><b>How to respond
    
                                                    </b></h5>
                                            </div>
                                            <div class="row mt-2 ">
                                                <div style="overflow-x: auto;">
                                                    <table class="table  table-hover">
    
                                                        <tr style="border: 1px gray;">
                                                            <th>
                                                                <b>Situation</b>
                                                            </th>
                                                            <th>
                                                                <b>Special instructions</b>
                                                            </th>
    
    
    
                                                        </tr>
    
                                                        <tr style="border: 1px gray;"
                                                            *ngFor="let service of  serviceplanImportBO.nonMedicalEmergencies;let Contact=index">
                                                            <td>
    
                                                                <textarea type="text" class="form-control"
                                                                    [disabled]="service.situation=='Fire' ||service.situation=='Tornado'||logintype =='onboardLogin'||
                                                        service.situation=='Extreme temperatures' || service.situation=='Power outage'||service.situation=='Flood'"
                                                                    [(ngModel)]="service.situation" (change)="changefunction()"></textarea>
                                                            </td>
                                                            <td>
                                                                <textarea type="text" class="form-control"[disabled]="logintype =='onboardLogin'"
                                                                    [(ngModel)]="service.special_Instructions" (change)="changefunction()"></textarea>
                                                            </td>
    
    
    
    
    
                                                            <td class="d-flex"><i class="fa fa-plus-circle text-primary" [disabled]="logintype =='onboardLogin'"
                                                                    *ngIf="Contact==0" style="font-size:30px"
                                                                    (click)="logintype !== 'onboardLogin' &&Createnonmedicalemergencies()" (change)="changefunction()"></i>
    
    
                                                                <i style="font-size:27px;" *ngIf="Contact != 0" [disabled]="logintype =='onboardLogin'"
                                                                    (click)="logintype !== 'onboardLogin' &&removenonmedicalemergencies(Contact,service)"
                                                                    [disabled]="serviceplanImportBO.nonMedicalEmergencies.length ==6"
                                                                    class="fa fa-trash text-danger" (change)="changefunction()"></i>
                                                            </td>
                                                        </tr>
    
                                                    </table>
    
                                                </div>
    
                                            </div>
                                            <div class="row mt-3 ">
                                                <h4 class=" font-header" id="exampleModalLabel"><b>Individual abuse
                                                        prevention plan 
    
                                                    </b><span>(leave this section blank if agency model)</span></h4>
                                            </div>
                                            <div class="row mt -2" *ngIf="serviceplanImportBO.modelTypename == 'AGENCY'">
                                                <label class="label">
                                                    Complete this section with your provider agency.
                                                </label>
                                            </div>
                                            <div class="row mt-1" *ngIf="serviceplanImportBO.modelTypename == 'AGENCY'">
                                                <p><b>Notes: </b> The provider agency can choose to document these answers in another location.</p>

                                            </div>
    
                                            <div class="row mt-2"  *ngIf="serviceplanImportBO.modelTypename == 'BUDGET'">
                                                <input type="checkbox" class="col-lg-1" [(ngModel)]="serviceplanImportBO.fmsBudget.is_Prevention_Explained" [disabled]="logintype =='onboardLogin'" (change)="changefunction()"> &nbsp; My consultation services provider explained
                                                what abuse and neglect are and discussed my options for
                                                seeking help
                                            </div>
                                           
                                            <!-- <div class="row mt-2 " *ngIf="serviceplanImportBO.modelTypename == 'AGENCY'">
                                                <label class="label "> (Complete this question with your provider agency)</label>
                                                    </div> -->
                                            <div class="row mt-2 ">
                                                <label class="label ">Are there any ways you are vulnerable to abuse by
                                                    others?</label>
                                                <textarea rows="7" class="form-control" cols="190" [disabled]="logintype =='onboardLogin'"
                                                    [(ngModel)]="serviceplanImportBO.vulnerabilitiesToAbuse" (change)="changefunction()"></textarea>
                                            </div>
    
                                            <div class="row mt-2 ">
                                                <label class="label ">Are you at risk of abusing others?</label>
                                                <textarea rows="7" class="form-control" cols="190" [disabled]="logintype =='onboardLogin'"
                                                    [(ngModel)]="serviceplanImportBO.riskOfAbusingOthers" (change)="changefunction()"></textarea>
                                            </div>
    
                                            <div class="row mt-2 ">
                                                <label class="label ">What are some ways you and others can keep you safe
                                                    from abuse?</label>
                                                <textarea rows="7" class="form-control" cols="190" [disabled]="logintype =='onboardLogin'"
                                                    [(ngModel)]="serviceplanImportBO.safetyStrategies" (change)="changefunction()"></textarea>
                                            </div>
    
    
                                            <div class="row mt-2 ">
                                                <label class="label ">What will you do if you experience abuse?</label>
                                                <textarea rows="7" class="form-control" cols="190" [disabled]="logintype =='onboardLogin'"
                                                    [(ngModel)]="serviceplanImportBO.actionPlanIfAbused" (change)="changefunction()"></textarea>
                                            </div>
                                            <div class="row mt-3 ">
                                                <h4 class=" font-header" id="exampleModalLabel"><b>Additional notes
                                                    </b></h4>
                                            </div>
                                            <div class="row mt-2">
                                                <label class="label">COMMENTS/NOTES</label>
                                                 <textarea rows="7" class="form-control" cols="190" [disabled]="logintype =='onboardLogin'"
                                                    [(ngModel)]="serviceplanImportBO.additionalNotes" (change)="changefunction()"></textarea>

                                            </div>
    
                                            <div class="row mt-3 ">
                                                <h4 class=" font-header" id="exampleModalLabel"><b>Signatures
    
                                                    </b></h4>
                                            </div>

                                            <!-- <div class="row mt-2 ">
                                                <label class="label ">I understand the start date of my CFSS service delivery plan is the date the lead agency approves my CFSS service
                                                    delivery plan. I understand the lead agency might need to adjust my units/dollars based on the approval date. The
                                                    lead agency will adjust the personal care line, if needed.</label>
                                           </div> -->
      
                                            <div class="row">
                                                <div class="col-lg-6">
                                                    <div class="row">
    
    
                                                        <div class="col-lg-4">
                                                            <button type="button" class="btn blue-btn btn-sm mr-1"
                                                                data-bs-target="#personwhoaccess_signModal" 
                                                                data-bs-toggle="modal">
                                                                PERSON WHO ACCESSES SERVICES</button>
    
                                                        </div>
                                                        <div class="col-lg-3">
                                                            <!-- <input *ngIf="pantsign1!=''&& pantsign1!=null " type="image"  src="{{pantsign1}}" class="form-control"
                                                            style="width: 255px;height:120px;" alt="nurse" width="48" height="48"> -->
                                                            <!-- <img  *ngIf="personwhoaccess_sign!='' && personwhoaccess_sign!= null "  
                                                            src="{{personwhoaccess_sign}}" > -->
                                                            <input *ngIf="personwhoaccess_sign!='' && personwhoaccess_sign!= null " type="image"
                                                              src="{{personwhoaccess_sign}}" class="form-control"
                                                                style="height:80px;" [disabled]="logintype =='onboardLogin'"
                                                                alt="PERSON WHO ACCESSES SERVICES" width="48" height="48">
    
                                                        </div>
                                                        <div class="col-lg-2">
                                                            <label>Date</label>
                                                        </div>
                                                        <div class="col-lg-3" >
                                                            <my-date-picker class="w-100" 
                                                                placeholder="mm/dd/yyyy" [options]="myDatePickerOptions" 
                                                                (inputFieldChanged)="newdates($event,'inputchage','personwhoaccess_signDate')"
                                                                [selDate]="personwhoaccess_signDate"
                                                                (dateChanged)="newdates($event,'datechagned','personwhoaccess_signDate')">
                                                            </my-date-picker>
                                           
                                                        </div>
                                                    </div>
                                                </div>
    
                                                <div class="col-lg-6">
                                                    <div class="row">
    
    
                                                        <div class="col-lg-4">
                                                            <button type="button" class="btn blue-btn btn-sm mr-1" 
                                                                data-bs-target="#parent_signModal" data-bs-toggle="modal">
                                                                PARENT/PARTICIPANT'S REPRESENTATIVE/MANAGING PARTY</button>
    
                                                        </div>
                                                        <div class="col-lg-3">
    
                                                            <input *ngIf="parent_sign!='' && parent_sign != null" type="image"
                                                                src="{{parent_sign}}" class="form-control"
                                                                [(ngModel)]="parent_sign" style="height:80px;"
                                                                alt="PERSON WHO ACCESSES SERVICES" width="48" height="48">
    
                                                        </div>
                                                        <div class="col-lg-2">
                                                            <label>Date</label>
                                                        </div>
                                                        <div class="col-lg-3" >
                                                            <my-date-picker class="w-100" 
                                                                placeholder="mm/dd/yyyy" [options]="myDatePickerOptions" 
                                                                (inputFieldChanged)="newdates($event,'inputchage','parent_signDate')"
                                                                [selDate]="parent_signDate"
                                                                (dateChanged)="newdates($event,'datechagned','parent_signDate')">
                                                            </my-date-picker>
                                                          
                                                        </div>
                                                    </div>
                                                </div>
    
    
                                            </div>
    
    
                                            <div class="row mt-2">
                                                <div class="col-lg-6">
                                                    <div class="row">
    
    
                                                        <div class="col-lg-4">
                                                            <button type="button" class="btn blue-btn btn-sm mr-1" 
                                                                data-bs-target="#provider_signModal" data-bs-toggle="modal">
                                                                CONSULTATION SERVICES PROVIDER</button>
    
                                                        </div>
                                                        <div class="col-lg-3">
    
                                                            <input *ngIf="provider_sign!='' && provider_sign !=null" type="image"
                                                                src="{{provider_sign}}" class="form-control"
                                                                [(ngModel)]="provider_sign" style="height:80px;" 
                                                                alt="CONSULTATION SERVICES PROVIDER" width="48" height="48">
    
                                                        </div>
                                                        <div class="col-lg-2">
                                                            <label>Date</label>
                                                        </div>
                                                        <div class="col-lg-3">
                                                            <my-date-picker class="w-100"
                                                                placeholder="mm/dd/yyyy" [options]="myDatePickerOptions"
                                                                (inputFieldChanged)="newdates($event,'inputchage','provider_signDate')"
                                                                [selDate]="provider_signDate" 
                                                                (dateChanged)="newdates($event,'datechagned','provider_signDate')">
                                                            </my-date-picker>
                                                            <!-- <span class="req" *ngIf="validform1.controls['anualsdate1'].invalid && budgetImportBO.selfDirectionSupportActivities.annualBudgetBO.monitor.healthandSafetyPlanBO.receipientSignDate!=null && budgetImportBO.selfDirectionSupportActivities.annualBudgetBO.monitor.healthandSafetyPlanBO.receipientSignDate!=undefined && budgetImportBO.selfDirectionSupportActivities.annualBudgetBO.monitor.healthandSafetyPlanBO.receipientSignDate!=''">
        
                                                Please enter valid date and time
                               
                                            </span> -->
                                                        </div>
                                                    </div>
                                                </div>
    
                                                <!-- <div class="col-lg-6">
                                                    <div class="row">
    
    
                                                        <div class="col-lg-4">
                                                            <button type="button" class="btn blue-btn btn-sm mr-1"
                                                                data-bs-target="#agencystaff_signModal" 
                                                                data-bs-toggle="modal">
                                                                LEAD AGENCY STAFF MEMBER</button>
    
                                                        </div>
                                                        <div class="col-lg-3">
    
                                                            <input *ngIf="agencystaff_sign!='' && agencystaff_sign != null" type="image"
                                                                src="{{agencystaff_sign}}" class="form-control" 
                                                                [(ngModel)]="agencystaff_sign" style="height:80px;"
                                                                alt="LEAD AGENCY STAFF MEMBER" width="48" height="48">
    
                                                        </div>
                                                        <div class="col-lg-2">
                                                            <label>Date</label>
                                                        </div>
                                                        <div class="col-lg-3">
                                                            <my-date-picker class="w-100" 
                                                                placeholder="mm/dd/yyyy" [options]="myDatePickerOptions" 
                                                                (inputFieldChanged)="newdates($event,'inputchage','agencystaff_signDate')"
                                                                [selDate]="agencystaff_signDate"
                                                                (dateChanged)="newdates($event,'datechagned','agencystaff_signDate')">
                                                            </my-date-picker>
                                           
                                                        </div>
                                                    </div>
                                                </div> -->
    
    
                                            </div>
    
    
                                            <div class="row mt-2">
                                                <h3 class=" font-header" id="exampleModalLabel"><b>Summary of CFSS
                                                        individual service delivery plan</b></h3>
                                            </div>
    
    
    
                                            <div class="card mt-3">
                                                <div class="card-body">
    
                                                    <div class="row">
                                                        <div class="col-lg-4">
                                                            <label class="label">PERSON'S LAST NAME</label>
                                                            <input class="form-control" type="text"  [disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                                [(ngModel)]="serviceplanImportBO.personLastName">
                                                        </div>
                                                        <div class="col-lg-3">
                                                            <label class="label">PMI</label>
                                                            <input class="form-control" type="text"  [disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                                [(ngModel)]="serviceplanImportBO.personPmi">
                                                        </div>
                                                        <div class="col-lg-4">
                                                            <label class="label">DATE OF BIRTH</label>
                                                            <my-date-picker [options]="myDatePickerOptions"
                                                        [selDate]="clientdob" placeholder="mm/dd/yyyy"
                                                        (inputFieldChanged)="newdates($event,'inputchage','personDob')" [disabled]="logintype =='onboardLogin'" (change)="changefunction()"
                                                        (dateChanged)="newdates($event,'datechagned','personDob')">
    
                                                    </my-date-picker>
                                                        </div>
    
    
    
                                                    </div>
                                                    <div class="row mt-3 " *ngIf="serviceplanImportBO.modelTypename == 'BUDGET'">
                                                        <h4 class=" font-header" id="exampleModalLabel"><b>Budget model</b>
                                                        </h4>
                                                    </div>
                                                   
                                                    <div class="row mt-2 " *ngIf="serviceplanImportBO.modelTypename == 'BUDGET'">
                                                        <div style="overflow-x: auto;">
                                                            <table class="table  table-hover colr">
    
                                                                <tr style="border: 1px gray;">
                                                                    <th>
                                                                        <b>Item</b>
                                                                    </th>
                                                                    <th>
                                                                        <b>Amount</b>
                                                                    </th>
    
                                                                </tr>
    
                                                                <tr style="border: 1px gray;">
                                                                    <td>Personal care (T1019 UB)
                                                                    </td>
                                                                    <td>
                                                                        <label class="label" *ngIf="Workergrandtotal !=0 && Workergrandtotal!= null"> $ {{Workergrandtotal}}</label>
                                                                    </td>
    
    
    
    
    
                                                                </tr>
                                                                <tr style="border: 1px gray;">
                                                                    <td>Goods and services (T5999 UB)
                                                                    </td>
                                                                    <td>
                                                                        <label class="label" *ngIf="Goodsgrandtotal !=0 && Goodsgrandtotal!= null"> $ {{Goodsgrandtotal}}</label>
                                                                    </td>
    
                                                                </tr>
                                                                <tr style="border: 1px gray;">
                                                                    <td>PERS equipment (S5162 UB)
                                                                    </td>
                                                                    <td>
                                                                        <label class="label" *ngIf="serviceplanImportBO.mhcpCost.equipment_Cost !=0 && serviceplanImportBO.mhcpCost.equipment_Cost!= null">$ {{serviceplanImportBO.mhcpCost.equipment_Cost}}</label>
                                                                    </td>
    
                                                                </tr>
                                                                <tr style="border: 1px gray;">
                                                                    <td>PERS installation (S5160 UB)
                                                                    </td>
                                                                    <td>
                                                                        <label class="label" *ngIf="serviceplanImportBO.mhcpCost.installation_Cost !=0 && serviceplanImportBO.mhcpCost.installation_Cost!= null">$ {{serviceplanImportBO.mhcpCost.installation_Cost}}</label>
                                                                    </td>
    
                                                                </tr>
                                                                <tr style="border: 1px gray;">
                                                                    <td>PERS monthly subscription (S5161 UB)
                                                                    </td>
                                                                    <td>
                                                                        <label class="label" *ngIf="serviceplanImportBO.mhcpCost.subscription_Cost !=0 && serviceplanImportBO.mhcpCost.subscription_Cost!= null">$ {{serviceplanImportBO.mhcpCost.subscription_Cost}}</label>
                                                                  
                                                                    </td>
    
                                                                </tr>
    
                                                                <tr style="border: 1px gray;">
                                                                    <td>FMS (T2040 UB UA)
                                                                    </td>
                                                                    <td>
                                                                        <label class="label" *ngIf="Fmsfee !=0 && Fmsfee!= null">$ {{Fmsfee}}</label>
                                                                    </td>
    
                                                                </tr>
    
                                                                <tr style="border: 1px gray;">
                                                                    <td><b>Total <p class="error" *ngIf="AnnualTotal > serviceplanImportBO.fmsBudget.budgetAmount" > (Over Budget)</b>
                                                                    </td>
                                                                    <td>
                                                                        <label class="label" *ngIf="AnnualTotal !=0 && AnnualTotal!= null">$ {{AnnualTotal}}</label>
                                                                    </td>
    
                                                                </tr>

                                                                <tr style="border: 1px gray;">
                                                                    <td>Consultation services (T1023)</td>
                                                                    <td>
                                                                        <label class="label" > (six sessions) </label>
                                                                    </td>
    
                                                                </tr>

                                                                <tr style="border: 1px gray;">
                                                                    <td>Worker training and development (S5116)</td>
                                                                    <td>
                                                                        <label class="label" >$ 1330.37</label>
                                                                    </td>
    
                                                                </tr>
    
                                                            </table>
    
                                                        </div>
    
                                                    </div>
    
                                                    <div class="row mt-3 " *ngIf="serviceplanImportBO.modelTypename == 'AGENCY'">
                                                        <h4 class=" font-header" id="exampleModalLabel"><b>Agency model</b>
                                                        </h4>
                                                    </div>
    
                                                    <div class="row mt-2 " *ngIf="serviceplanImportBO.modelTypename == 'AGENCY'">
                                                        <div style="overflow-x: auto;">
                                                            <table class="table  table-hover colr">
    
                                                                <tr style="border: 1px gray;">
                                                                    <th>
                                                                        <b>Item</b>
                                                                    </th>
                                                                    <th>
                                                                        <b>Amount</b>
                                                                    </th>
    
                                                                </tr>
    
                                                                <tr style="border: 1px gray;">
                                                                    <td>Personal care (T1019 U9)
                                                                    </td>
                                                                    <td>
                                                                        <label class="label" *ngIf="serviceplanImportBO.totalCFSSUnitsEligible !=0 && serviceplanImportBO.totalCFSSUnitsEligible != null">  {{serviceplanImportBO.totalCFSSUnitsEligible}}</label>
                                                               
                                                                    </td>
    
    
    
    
    
                                                                </tr>
                                                                <tr style="border: 1px gray;">
                                                                    <td>Goods and services (T5999 U9)
                                                                    </td>
                                                                    <td>
                                                                        <label class="label" *ngIf="Goodsgrandtotal !=0 && Goodsgrandtotal!= null"> $ {{Goodsgrandtotal}}</label>
                                                               
                                                                    </td>
    
                                                                </tr>
                                                                <tr style="border: 1px gray;">
                                                                    <td>PERS equipment (S5162 U9)
                                                                    </td>
                                                                    <td>
                                                                        <label class="label" *ngIf="serviceplanImportBO.mhcpCost.equipment_Cost !=0 && serviceplanImportBO.mhcpCost.equipment_Cost!= null">$ {{serviceplanImportBO.mhcpCost.equipment_Cost}}</label>
                                                                    </td>
    
                                                                </tr>
                                                                <tr style="border: 1px gray;">
                                                                    <td>PERS installation (S5160 U9)
                                                                    </td>
                                                                    <td>
                                                                        <label class="label" *ngIf="serviceplanImportBO.mhcpCost.installation_Cost !=0 && serviceplanImportBO.mhcpCost.installation_Cost!= null">$ {{serviceplanImportBO.mhcpCost.installation_Cost}}</label>
                                                                    </td>
    
                                                                </tr>
                                                                <tr style="border: 1px gray;">
                                                                    <td>PERS monthly subscription (S5161 U9)
                                                                    </td>
                                                                    <td>
                                                                        <label class="label" *ngIf="serviceplanImportBO.mhcpCost.subscription_Cost !=0 && serviceplanImportBO.mhcpCost.subscription_Cost!= null">$ {{serviceplanImportBO.mhcpCost.subscription_Cost}}</label>
                                                                    </td>
    
                                                                </tr>
    
                                                                <!-- <tr style="border: 1px gray;">
                                                                    <td>FMS (T2040 UB UA)
                                                                    </td>
                                                                    <td>
                                                                        <input type="text" class="form-control">
                                                                    </td>
    
                                                                </tr>
    
                                                                <tr style="border: 1px gray;">
                                                                    <td><b>Total</b>
                                                                    </td>
                                                                    <td>
                                                                        <input type="text" class="form-control">
                                                                    </td>
    
                                                                </tr> -->
    

                                                                <tr style="border: 1px gray;">
                                                                    <td>Consultation services (T1023)</td>
                                                                    <td>
                                                                        <label class="label" > (six sessions) </label>
                                                                    </td>
    
                                                                </tr>

                                                                <tr style="border: 1px gray;">
                                                                    <td>Worker training and development (S5116)</td>
                                                                    <td>
                                                                        <label class="label" >$ 1328.64</label>
                                                                    </td>
    
                                                                </tr>
    

                                                            </table>
    
                                                        </div>
    
                                                    </div>



                                                    <div class="row mt-3 " *ngIf="serviceplanImportBO.modelTypename == 'BUDGET' || serviceplanImportBO.modelTypename == 'AGENCY'">
                                                        <div class="card mt-3">
                                                            <div class="card-body">

                                                                <label>LEAD AGENCY COMMENTS
                                                                </label>
                                                                <textarea  [(ngModel)]="serviceplanImportBO.leadAgencyComments" style="width: 100%; height:230px" (change)="changefunction()" ></textarea>
                   
                                                                </div>
                                                            </div>

                                                        </div>
                                                    <div class="row mt-3 " *ngIf="serviceplanImportBO.modelTypename == 'BUDGET' || serviceplanImportBO.modelTypename == 'AGENCY'">
                                                        <label><b>NOTES: </b></label>
                                                         <label >1.The service agreement must include T1023 (consultation services) and S5116 (worker training and
                                                            development) if the person is using T1019 (personal care).</label>
                                                         <label >2.The person's service agreement may require additional MMIS modifiers based on their circumstances.</label>
                                                    </div>
                                                </div>
    
    
                                            </div>
    
    
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
            


            </div>
        </div>
    </div>


                <span id="openandclosepersonwhoaccess_signModal" data-bs-toggle="modal"
                    data-bs-target="#personwhoaccess_signModal"></span>
                <div class="modal fade" id="personwhoaccess_signModal" data-bs-backdrop="static">
                    <div class="modal-dialog modal-md" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title font-header">Sign</h5>
                                <button type="button" class="btn-close" (click)="close()"> </button>
                            </div>
                            <div class="modal-body">

                                <div class="row">
                                    <div class="col-lg-12">
                                        <h4> Sign here</h4>

                                        <signature-pad #personaccesssignaturePad [options]="signaturePadOptions"
                                            (onBeginEvent)="drawStartsign('recipient')"
                                            (onEndEvent)="drawComplete('recipient')" (click)="changefunction()"></signature-pad>

                                    </div>

                                </div>

                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn blue-btn btn-sm" (click)="clearsign()">Clear</button>
                                <button type="button" class="btn blue-btn btn-sm" id="closedeletemodal"
                                    (click)="close()">Close</button>
                            </div>
                        </div>
                    </div>
                </div>

                <span id="openandcloseparent_signModal" data-bs-toggle="modal"
                    data-bs-target="#parent_signModal"></span>
                <div class="modal fade" id="parent_signModal" data-bs-backdrop="static">
                    <div class="modal-dialog modal-md" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title font-header">Sign</h5>
                                <button type="button" class="btn-close" (click)="closeparentsign()"> </button>
                            </div>
                            <div class="modal-body">

                                <div class="row">
                                    <div class="col-lg-12">
                                        <h4> Sign here</h4>

                                        <signature-pad #parentsignaturePad1 [options]="signaturePadOptions"
                                            (onBeginEvent)="drawStartsign('parent')"
                                            (onEndEvent)="drawComplete('parent')" (click)="changefunction()"></signature-pad>

                                    </div>

                                </div>

                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn blue-btn btn-sm"
                                    (click)="clearparentsign()">Clear</button>
                                <button type="button" class="btn blue-btn btn-sm" id="closedeletemodal"
                                    (click)="closeparentsign()">Close</button>
                            </div>
                        </div>
                    </div>
                </div>


                <span id="openandcloseprovider_signModal" data-bs-toggle="modal"
                    data-bs-target="#provider_signModal"></span>
                <div class="modal fade" id="provider_signModal" data-bs-backdrop="static">
                    <div class="modal-dialog modal-md" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title font-header">Sign</h5>
                                <button type="button" class="btn-close" (click)="closeprovidersign()"> </button>
                            </div>
                            <div class="modal-body">

                                <div class="row">
                                    <div class="col-lg-12">
                                        <h4> Sign here</h4>

                                        <signature-pad #providersignaturePad [options]="signaturePadOptions"
                                            (onBeginEvent)="drawStartsign('provider')"
                                            (onEndEvent)="drawComplete('provider')" (click)="changefunction()"></signature-pad>

                                    </div>

                                </div>

                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn blue-btn btn-sm"
                                    (click)="clearprovidersign()">Clear</button>
                                <button type="button" class="btn blue-btn btn-sm" id="closedeletemodal"
                                    (click)="closeprovidersign()">Close</button>
                            </div>
                        </div>
                    </div>
                </div>

                <span id="openandcloseagencystaff_signModal" data-bs-toggle="modal"
                    data-bs-target="#agencystaff_signModal"></span>
                <div class="modal fade" id="agencystaff_signModal" data-bs-backdrop="static">
                    <div class="modal-dialog modal-md" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title font-header">Sign</h5>
                                <button type="button" class="btn-close" (click)="closeAgencysign()"> </button>
                            </div>
                            <div class="modal-body">

                                <div class="row">
                                    <div class="col-lg-12">
                                        <h4> Sign here</h4>

                                        <signature-pad #AgencysignaturePad [options]="signaturePadOptions"
                                            (onBeginEvent)="drawStartsign('agency')"
                                            (onEndEvent)="drawComplete('agency')" change="changefunction()"></signature-pad>

                                    </div>

                                </div>

                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn blue-btn btn-sm"
                                    (click)="clearAgencysign()">Clear</button>
                                <button type="button" class="btn blue-btn btn-sm" id="closedeletemodal"
                                    (click)="closeAgencysign()">Close</button>
                            </div>
                        </div>
                    </div>
                </div>

<!-- Trigger -->
<span id="createeventTrigger" data-bs-toggle="modal" data-bs-target="#createevent"></span>

<!-- Modal -->
<div class="modal fade" id="createevent" data-bs-backdrop="static">
    <div class="modal-dialog mw-100" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header">Create Event</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="row mt-2">
                            <div class="table-responsive" style="max-height: 500px; overflow-y: auto;  min-height: 274px;">
                                <table class="table table-hover">
                                    <thead>
                                        <tr style="border: 1px gray;">
                                            <th style="min-width: 200px;"><b>Client Name</b></th>
                                            <th style="min-width: 200px;"><b>Employee Name <span class="text-danger">*</span></b></th>
                                            <th style="min-width: 200px;"><b>Start Date <span class="text-danger">*</span></b></th>
                                            <th style="min-width: 200px;"><b>End Date <span class="text-danger">*</span></b></th>
                                            <th style="min-width: 300px;"><b>Event Title <span class="text-danger">*</span></b></th>
                                            <th style="min-width: 300px;"><b>Event Description</b></th>
                                            <th style="min-width: 200px;"><b>Event Status <span class="text-danger">*</span></b></th>
                                            <th style="min-width: 200px;"><b>Plan Model</b></th>
                                            <th style="min-width: 300px;"><b>Languages</b></th>
                                            <th style="min-width: 300px;"><b>Type of Contact</b></th>
                                            <th style="min-width: 300px;"><b>Type of session</b></th>
                                            <th style="min-width: 300px;"><b>Event Alert</b></th>
                                            <th style="min-width: 150px;"><b>Reminder</b></th>
                                            <th style="min-width: 100px;"><b>Actions</b></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr style="border: 1px gray;" *ngFor="let event of GridDataEvent; let i = index">
                                            <td><input type="text" class="form-control" [(ngModel)]="event.clientName" [disabled]="true"></td>
                                            <td>
                                                <ng-select [(ngModel)]="event.consultantId" [searchable]="true" 
                                                    [clearable]="true" [items]="UserDropDownList" bindLabel="Value" bindValue="Key"
                                                    >
                                                </ng-select>
                                            </td>
                                            <td>
                                                <input type="datetime-local" class="form-control" [(ngModel)]="event.startTime" (change)="validateEventTimes();OutBoundCall(event, event.startTime, event.endTime)">
                            
                                            </td>
                                            <td>
                                                <input type="datetime-local" class="form-control" [(ngModel)]="event.endTime" (change)="validateEventTimes()">
                                                <div *ngIf="event.isOverlapping" class="text-danger">Event times cannot overlap</div>
                                                <div *ngIf="event.isInvalid" class="text-danger">End time must be after start time</div>
                                            </td>
                                            
                                            <td>
                                                   <textarea rows="7" [(ngModel)]="event.eventTitle"
                                                   class="form-control" cols="190"></textarea>
                                            </td>
                                            <td>
                                                <textarea rows="7" [(ngModel)]="event.eventDescription"
                                                    class="form-control" cols="190"></textarea>
                                            </td>
                                            <td>
                                                <ng-select [(ngModel)]="event.statusLid" [searchable]="true" 
                                                    [clearable]="true" [items]="StatusList" bindLabel="lovName" bindValue="id"
                                                    [ngClass]="{'is-invalid': submitted && !event.statusLid}">
                                                </ng-select>
                                            </td>
                                            <td>
                                                <ng-select [(ngModel)]="event.cfssModel" [searchable]="true"
                                                    [clearable]="true" [items]="cfssModel" [disabled]="true">
                                                </ng-select>
                                            </td>
                                            <td>
                                                <ng-select [(ngModel)]="event.languageListIds" [searchable]="true"
                                                    [clearable]="true" [multiple]="true" [items]="languageList" bindLabel="languageName"
                                                    bindValue="id" name="languageIds">
                                                </ng-select>
                                            </td>
                                            <td>
                                                <ng-select [(ngModel)]="event.typeofContactId"
                                                [searchable]="true" class="w-100" [clearable]="true"
                                                [items]="ContactList" bindLabel="lovName" bindValue="id">
                                            </ng-select>
                                            </td>
                                            <td>
                                                <ng-select [searchable]="true" class="w-100" [clearable]="true" [items]="ServiceList"
                                                    [(ngModel)]="event.typeofServiceId" bindLabel="serviceCode" bindValue="id">
                                                </ng-select>
                                            </td>
                                            <td>
                                                <ng-select [(ngModel)]="event.eventAlterList" [items]="EventList" bindLabel="eventAlterName" bindValue="eventAlertId"
                                                [multiple]="true" class="w-100" [compareWith]="compareEventAlerts"
                                                (change)="updateSelectedEventAlerts(event)">
                                            </ng-select>

                                            </td>
                                            <td>
                                               <input type="checkbox" 
                                                      [(ngModel)]="event.getConfirmation" 
                                                      [disabled]="event.isCheckboxDisabled"
                                                      class="w-100">
                                               <div *ngIf="event.noCallMessage" class="text-danger small">
                                                   {{event.noCallMessage}}
                                                 </div>
                                             </td>
                                            <td class="d-flex">
                                                <i style="font-size: 27px;" *ngIf="GridDataEvent.length > 1" (click)="removeEvent(i)"
                                                    class="fa fa-trash text-danger me-2"></i>
                                                <i class="fa fa-plus-circle text-primary" *ngIf="i == GridDataEvent.length - 1"
                                                    style="font-size: 30px" (click)="addEvent()"></i>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                
                            </div>
                        </div>
            
            
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn blue-btn btn-sm" (click)="saveEvent();">Save</button>
                <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>


<span id="manageeventTrigger" data-bs-toggle="modal" data-bs-target="#manageevent"></span>

<!-- Modal -->
<div class="modal fade" id="manageevent" data-bs-backdrop="static">
    <div class="modal-dialog mw-100" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header"> Events</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <app-events *ngIf="viewevent" >

                    </app-events>
                    </div>
            </div>
            <div class="modal-footer">
                <!-- <button type="button" class="btn blue-btn btn-sm" (click)="saveEvent();">Save</button> -->
                <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>




<div style="position: absolute; ">
    <kendo-pdf-export #pdfServicePlan paperSize="A4" forcePageBreak=".page-break" >
        <ng-template kendoPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">
            <div class="pageNum">
                &nbsp; Page {{ pageNum }} of {{ totalPages }}
            </div>
        </ng-template>
        <body>  <div class="row pdf-content" >
            <div class="container"  *ngIf="pdfenable" >
                <header>
                    <div class="logoImage">
                        <img src="./assets/img/SDP2025Sep.png" alt>
                    </div>
                </header>
                <div class="row" style="margin-top: 16px;">
                    <p class="f">People using community first services and supports (CFSS) must
                        write a service plan and can use this template to
                        ensure they include all required elements.
                        <br> <br>
                        You can ask your consultation services provider for help if you want.
                        When you complete this plan, submit it to your
                        consultation services provider for approval. Your consultation services
                        provider will instruct you on how their
                        business receives plans.
                    </p>
                </div>
     
               <!-- plan date -->
           <div class="Plan-datedate">
            <table class="tablepdf">
                <tr>
                  <th class="theadtd" style="width: 150px;">PLAN DATE</th>
                  <th class="theadtd" style="width: 170px;">
                    <b>VERSION:</b> Is this version a new plan or a revised plan?
                  </th>
                  <th class="theadtd" style="width: 250px;">This plan covers the time period from:</th>
                </tr>
                <tr>
                  <td class="theadtd" >
                    <input type="text" class="inputtext" [(ngModel)]="serviceplanImportBO.plandate" />
                  </td>
                  <td class="theadtd" >
                    <span>
                      <input type="radio" class="inputradio" [value]="'New'" [(ngModel)]="serviceplanImportBO.version" />
                      <label>New</label>
                    </span>
                    <span class="ms-2">
                      <input type="radio" class="inputradio" [value]="'Revised'" [(ngModel)]="serviceplanImportBO.version" />
                      <label>Revised</label>
                    </span>
                  </td>
                  <td class="theadtd" >
                    <span>
                      <input type="text" class="inputtext" [(ngModel)]="serviceplanImportBO.startdate" />
                      <label for="to">to:</label>
                      <input type="text" class="inputtext" [(ngModel)]="serviceplanImportBO.enddate" />
                    </span>
                  </td>
                </tr>
              </table>
              
          </div>
     
                <!-- Your Information -->
                <div class="section-title-info">Your Information</div>
                <div class="section-title">Contact information</div>
                <!-- FIRST NAME,MI,LAST NAME -->
            <table class="tablepdf">
                    <tr>
                        <th class="theadtd">FIRST NAME</th>
                        <th class="theadtd" width="100px">MI</th>
                        <th class="theadtd">LAST NAME</th>
                    </tr>
                    <tr>
                        <td class="theadtd" ><input type="text" class="inputtext"  [(ngModel)]="serviceplanImportBO.clientInfoFirstName" (change)="changefunction()"></td>
                        <td class="theadtd" ><input type="text" class="inputtext"  [(ngModel)]="serviceplanImportBO.clientInfoMiName" (change)="changefunction()"></td>
                        <td class="theadtd" ><input type="text" class="inputtext"  [(ngModel)]="serviceplanImportBO.clientInfoLastName" (change)="changefunction()"></td>
                       
                    </tr>
                </table>
                <!-- PMI  & DATE OF BIRTH & AGE(years)-->
                <table class="tablepdf" >
                    <tr>
                        <th class="theadtd" >PMI</th>
                        <th class="theadtd" >DATE OF BIRTH</th>
                        <th class="theadtd" width="100px">AGE(years)</th>
                       
                    </tr>
                    <tr>
                        <td  class="theadtd" ><input type="text" class="inputtext"   [(ngModel)]="serviceplanImportBO.clientInfoPmi" (change)="changefunction()"></td>
                        <td  class="theadtd"><input type="text" class="inputtext" [(ngModel)]="serviceplanImportBO.clientInfoDob" (change)="changefunction()"></td>
                        <td  class="theadtd"><input type="text" class="inputtext" [(ngModel)]="serviceplanImportBO.clientInfoAge" (change)="changefunction()"></td>
                    </tr>
                </table>
                <!-- STREET ADDRESS ,CITY,STATE-->
                <table class="tablepdf" >
                    <tr>
                        <th class="theadtd">STREET ADDRESS</th>
                        <th class="theadtd" width="300px">CITY</th>
                        
                    </tr>
                    <tr>
                        <td  class="theadtd" ><textarea type="text" class="inputtext"  [(ngModel)]="serviceplanImportBO.clientInfoStreet" (change)="changefunction()"></textarea></td>
                        <td  class="theadtd"><input type="text" class="inputtext"  [(ngModel)]="serviceplanImportBO.clientInfoCity" (change)="changefunction()"></td>
                       
                    </tr>
                </table>
                <table class="tablepdf" >
                    <tr>
                        <th class="theadtd" width="100px">STATE</th>
                        <th class="theadtd"width="200px">ZIP CODE</th>
                        <th class="theadtd"width="300px">COUNTY OF RESIDENCE</th>
                    </tr>
                    <tr>
                        <td class="theadtd" ><input type="text" class="inputtext"   [(ngModel)]="serviceplanImportBO.clientInfoState" (change)="changefunction()"></td>
                      
                        <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="serviceplanImportBO.clientInfoZip" (change)="changefunction()"></td>
                        <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="serviceplanImportBO.clientInfoCounty" (change)="changefunction()"></td>
                    </tr>
                </table>
                <table class="tablepdf" >
                    <tr>
                        <th class="theadtd"width="200px">EMAIL ADDRESS</th>
                        <th class="theadtd"width="100px">PREFERRED PHONE NUMBER</th>
                    </tr>
                    <tr>
                        <td class="theadtd" ><input type="text" class="inputtext"  [(ngModel)]="serviceplanImportBO.clientInfoEmail"[disabled]="logintype =='onboardLogin'" (change)="changefunction()"></td>
                        <td class="theadtd" ><input type="text" class="inputtext"  [(ngModel)]="serviceplanImportBO.clientInfoPhone"[disabled]="logintype =='onboardLogin'" (change)="changefunction()"></td>
            
                    </tr>
                </table>
                <!-- Participant's representative -->
                <div class="section-title-info"> Participant's representative</div>
                <div class="row" style="margin-top: 16px;">
                    <p class="f">Some people cannot direct their own care. They made need another person to direct their
                        care.
                        During your
                        assessment, your assessor determined if you can direct your own care. Answer according to that (if
                        you
                        are unsure,
                        ask your consultation services provider).
                    </p>
                </div>
                <!-- Can client direct own care -->
                <div class="row" style="margin-top: 16px;">
                    <div>
                        <label class="label-bold">Do you direct your own care?&nbsp;
                        </label>
                        <!--  Yes -->
                        <span>
                            <input type="radio" class="inputradio" [value]="true"
                            [(ngModel)]="serviceplanImportBO.directOwnCare" >&nbsp;
                            <label class="label">
                                Yes</label>
                        </span>&nbsp;
                        <!-- No  -->
                        <span>
                            <input type="radio" class="inputradio" [value]="false"
                            [(ngModel)]="serviceplanImportBO.directOwnCare">&nbsp;
                            <label class="label">No
                            </label>
                        </span>&nbsp;
                    </div>
                </div>
                <!-- FIRST NAME ,LAST NAME,EMAIL ADDRESSS-->
            <div class="do-you-direct-your"  *ngIf="serviceplanImportBO.directOwnCare == false">
                <div id="goalaccordion" *ngFor="let item of serviceplanImportBO.participantRepresentative;let goal1=index">
                <table class="tablepdf" >
                    <tr>
                        <th class="theadtd"width="300px">FIRST NAME</th>
                        <th class="theadtd" width="300px">LAST NAME</th>
                        
                        <th class="theadtd" width="200px">PREFERRED PHONE NUMBER</th>
            
                    </tr>
                    <tr>
                        <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="item.firstName"></td>
                        <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="item.lastName"></td>
                        
                        <td class="theadtd" ><input type="text" class="inputtext"  [(ngModel)]="item.phoneNumber"></td>
                    </tr>
                </table>
                <table class="tablepdf" >
                    <tr>
                        <th class="theadtd" >STREET ADDRESS</th>
                        <th class="theadtd" width="300px">CITY</th>
                       
                    </tr>
                    <tr>
                        <td class="theadtd" ><textarea type="text" class="inputtext"  [(ngModel)]="item.address"></textarea></td>
                        <td class="theadtd" ><input type="text" class="inputtext"  [(ngModel)]="item.city"></td>
                    </tr>
                </table>
                <table class="tablepdf" >
                    <tr>
                        <th class="theadtd" width="100px">STATE</th>
                     
                        <th class="theadtd" width="100px">ZIP CODE</th>
                        
                        <th class="theadtd" >EMAIL ADDRESSS</th>
                    </tr>
                    <tr>
                     
                        <td class="theadtd" ><input type="text" class="inputtext"  [(ngModel)]="item.state"></td>
                        <td class="theadtd" ><input type="text" class="inputtext"   [(ngModel)]="item.zipCode"></td>
                        
                        <td class="theadtd" ><input type="text" class="inputtext"  [(ngModel)]="item.email"></td>
                    </tr>
                </table>
            </div>
            </div>
                <!-- Interpreter -->
                <div class="section-title">Interpreter</div>
                <div >
                    <div >
                        <div >
                            <label style="
                            width: 100%;
                        ">What is your preferred language(s)?:</label>
                            <textarea type="text" class="inputtext"  [(ngModel)]="serviceplanImportBO.preferrdLanguages" style="border-bottom: 1px solid #000; padding: 0;"></textarea>
                        </div>
                    </div>
                </div>
                <div class="row" style="margin-top: 16px;">
                    <!-- Do you need/use an interpreter? -->
                    <div>
                        <label class="label-bold"> Do you need/use an interpreter?&nbsp;
                        </label>
                        <!--  Yes -->
                        <span>
                            <input type="radio" class="inputradio"  [value]="true"
                            [(ngModel)]="serviceplanImportBO.needsInterpreter">&nbsp;
                            <label class="label">
                                Yes</label>
                        </span>&nbsp;
                        <!-- No  -->
                        <span>
                            <input type="radio" class="inputradio"  [value]="false"
                            [(ngModel)]="serviceplanImportBO.needsInterpreter">&nbsp;
                            <label class="label">No
                            </label>
                        </span>&nbsp;
                    </div>
                    <!-- Whom do you usually use to interpret for you? -->
                    <div   *ngIf="serviceplanImportBO.needsInterpreter ==true">
                        <label class="label-bold"> Whom do you usually use to interpret for you?&nbsp;
                        </label>
                    </div>
                </div>
                <div *ngIf="serviceplanImportBO.needsInterpreter ==true">
                    <div   *ngFor="let item of serviceplanImportBO.interpreters;let goal1=index">
                <table class="tablepdf" >
                    <tr>
                        <th class="theadtd" >NAME</th>
                        <th class="theadtd" width="200px">RELATIONSHIP TO YOU</th>
                        <th class="theadtd" width="200px">PREFERRED PHONE NUMBER</th>
                    </tr>
                    <tr>
                        <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="item.name"></td>
                        <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="item.relationShip"></td>
                        <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="item.phonenumer"></td>
                    </tr>
                </table>
                </div>
            </div>
                <!-- About you -->
                <div class="section-title-info"> About you</div>
                <p class="f">Your assessment results might already have answers to these question. You can use those answers
                    if
                    you'd like.
                    <br>
                    What are your strengths and preferences?
                </p>
                <div class="row">
                    <div class="col-lg-12">
                        <textarea  [(ngModel)]="serviceplanImportBO.aboutyou" style="width: 100%; height:230px" (change)="changefunction()" ></textarea>
                    </div>
                </div>
                <!-- What are your goals and preferred outcomes? -->
                <p class="f">What are your goals and preferred outcomes?
                </p>
                <div class="row">
                    <div class="col-lg-12">
                        <textarea [(ngModel)]="serviceplanImportBO.prefferd_Outcomes" style="width: 100%;  height:230px" (change)="changefunction()"></textarea>
                    </div>
                </div>
                <!-- Is there anything you'd like your providers and/or workers to know about you? -->
                <p class="f">Is there anything you'd like your providers and/or workers to know about you?
                </p>
                <div class="row">
                    <div class="col-lg-12">
                        <textarea    [(ngModel)]="serviceplanImportBO.additionalInformation" style="width: 100%;  height:230px" (change)="changefunction()"></textarea>
                    </div>
                </div>
                <!-- Your plan -->
                <div class="section-title-info"> Your plan</div>
                <div class="row" style="margin-top: 16px;">
                    <div>
                        <label>Is your service plan for a full year?&nbsp;
                        </label>
                        <!--  Yes -->
                        <span>
                            <input type="radio" class="inputradio" [value]="true"
                            [(ngModel)]="serviceplanImportBO.isFullYearPlan" (change)="changefunction()">&nbsp;
                            <label class="label" >
                                Yes</label>
                        </span>&nbsp;
                        <!-- No  -->
                        <span>
                            <input type="radio" class="inputradio" [value]="false"
                            [(ngModel)]="serviceplanImportBO.isFullYearPlan" (change)="changefunction()">&nbsp;
                            <label class="label">No
                            </label>
                        </span>&nbsp;
                    </div>
                </div>
                <div >
                    <div class="row" style="margin-top: 16px;" >
                        <div >
                            <label >How many total estimated CFSS units are you eligible for in this service plan?</label> &nbsp;
                            <textarea type="text" class="inputtext" [(ngModel)]="serviceplanImportBO.totalCFSSUnitsEligible" (change)="changefunction()"  ></textarea>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <p><b>Note: </b>Your lead agency might need to adjust this amount based on the dates of your final service agreement.</p>
                    </div>
                </div>
                <!-- Enhanced rate -->
                <div class="section-title-info"> Enhanced rate</div>
                <div class="row" style="margin-top: 16px;">
                    <div>
                        <label>Are you eligible for an enhanced rate?&nbsp;
                        </label>
                        <!--  Yes -->
                        <span>
                            <input type="radio" class="inputradio" [value]="true"
                            [(ngModel)]="serviceplanImportBO.isEnhancedrate">&nbsp;
                            <label class="label">
                                Yes</label>
                        </span>&nbsp;
                        <!-- No  -->
                        <span>
                            <input type="radio" class="inputradio" [value]="false"
                            [(ngModel)]="serviceplanImportBO.isEnhancedrate">&nbsp;
                            <label class="label">No
                            </label>
                        </span>&nbsp;
                    </div>
                </div>
                <div class="row" style="margin-top: 16px;">
                    <p class="f">Note:Your assessment results states if you are eligible for the enhanced rate. If you are
                        unsure, your consultation services provider can help you
                        find this information.
                    </p>
                </div>
                <div class="section-title-info">Consultation services provider</div>
                <div class="section-title-info">Contact Information</div>
                
                <table class="tablepdf" >
                    <tr>
                        <th class="theadtd" >NAME</th>
                        <th class="theadtd" width="200px">NPI</th>
                        <th class="theadtd" width="200px">PHONE NUMBER</th>
                    </tr>
                    <tr>
                        <td class="theadtd" ><input type="text" class="inputtext"  [(ngModel)]="serviceplanImportBO.consultantInfoName"></td>
                        <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="serviceplanImportBO.consultantInfoPmi"></td>
                        <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="serviceplanImportBO.consultantInfoPhone"></td>
                    </tr>
                </table>
                <table class="tablepdf" >
                    <tr>
                        <th class="theadtd" >STREET ADDRESS</th>
                        <th class="theadtd" width="200px">CITY</th>
                    </tr>
                    <tr>
                        <td class="theadtd" ><textarea type="text" class="inputtext"   [(ngModel)]="serviceplanImportBO.consultantInfoStreet"></textarea></td>
                        <td class="theadtd" ><input type="text" class="inputtext"  [(ngModel)]="serviceplanImportBO.consultantInfoCity"></td>
                    </tr>
                  
                </table>
                <table class="tablepdf" >
                    <tr>
                       
                        <th class="theadtd" width="100px">STATE</th>
                        <th class="theadtd" width="100px">ZIP CODE</th>
                        <th class="theadtd">CONTACT NAME</th>
                    </tr>

                    <tr>
                      <td class="theadtd" ><input type="text" class="inputtext"   [(ngModel)]="serviceplanImportBO.consultantInfoState"></td>
                        <td class="theadtd" ><input type="text" class="inputtext"    [(ngModel)]="serviceplanImportBO.consultantInfoZip"></td>
                        <td class="theadtd" ><input type="text" class="inputtext"   [(ngModel)]="serviceplanImportBO.consultantInfoContactName"></td>
                        
                    </tr>
                </table>
                <table class="tablepdf" >
                    <tr>
                       
                        <th class="theadtd" >EMAIL ADDRESS</th>
                        <th class="theadtd" width="200px">FAX NUMBER</th>
                    </tr>
                    <tr>
                        <td class="theadtd" ><input type="text" class="inputtext"  [(ngModel)]="serviceplanImportBO.consultantInfoEmail"></td>
                        <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="serviceplanImportBO.consultantInfoFax"></td>
                    </tr>
                </table>
    
            <div class="section-title-info">Program information</div>
            <div class="row" style="margin-top: 16px;">
                <div>
                    <label>Are you 65 years old or older?&nbsp;
                    </label>
                    <!--  Yes -->
                    <span>
                        <input type="radio" class="inputradio" [(ngModel)]="serviceplanImportBO.is65OrOlder"  [value]="true">&nbsp;
                        <label class="label">
                            Yes</label>
                    </span>&nbsp;
                    <!-- No  -->
                    <span>
                        <input type="radio" class="inputradio" [(ngModel)]="serviceplanImportBO.is65OrOlder"  [value]="false">&nbsp;
                        <label class="label">No
                        </label>
                    </span>&nbsp;
                </div>
            </div>
            <div class="row" style="margin-top: 16px;">
                <div>
                    <label>Do you use one of the following waivers or programs?&nbsp;
                    </label>
                    <!--  Yes -->
                    <span>
                        <input type="radio" class="inputradio" [value]="true" [(ngModel)]="serviceplanImportBO.usesWaiverOrProgram">&nbsp;
                        <label class="label">
                            Yes</label>
                    </span>&nbsp;
                    <!-- No  -->
                    <span>
                        <input type="radio" class="inputradio" [value]="false" [(ngModel)]="serviceplanImportBO.usesWaiverOrProgram">&nbsp;
                        <label class="label">No
                        </label>
                    </span>&nbsp;
                </div>
            </div>
            <div class="row" style="margin-top: 16px;">
                <div>
                    <ul>
                        <li>Alternative Care (AC) program</li>
                        <li>Brain Injury (BI) Waiver</li>
                        <li>Community Alternative Care (CAC) Waiver</li>
                        <li>Community Access for Disability Inclusion (CADI) Waiver</li>
                        <li>Developmental Disabilities (DD) Waiver</li>
                        <li>Elderly Waiver (EW)</li>
                    </ul>
                    
                </div>
            </div>
            <div  *ngIf=" serviceplanImportBO.usesWaiverOrProgram ==true">
                <label class="label mt-1">Which waiver/program?</label>
                <div class="row mt-1">
                    <div class="col-lg-6 mt-1 ">
                        <input type="radio" class="inputradio me-1" name="typeOfWaiverOrProgrampdf" value="AC"
                            [(ngModel)]="serviceplanImportBO.typeOfWaiverOrProgram" [disabled]="logintype =='onboardLogin'" /> AC
                        &nbsp;
                        <input type="radio" class="inputradio me-1" name="typeOfWaiverOrProgrampdf" value="BI"
                            [(ngModel)]="serviceplanImportBO.typeOfWaiverOrProgram" [disabled]="logintype =='onboardLogin'" />BI
                        &nbsp;
                        <input type="radio" class="inputradio me-1" name="typeOfWaiverOrProgrampdf" value="CAC"
                            [(ngModel)]="serviceplanImportBO.typeOfWaiverOrProgram" [disabled]="logintype =='onboardLogin'" />CAC
                        &nbsp;
                        <input type="radio" class="inputradio me-1 " name="typeOfWaiverOrProgrampdf" value="CADI"
                            [(ngModel)]="serviceplanImportBO.typeOfWaiverOrProgram" [disabled]="logintype =='onboardLogin'" />CADI
                        &nbsp;
                        <input type="radio"class="inputradio me-1" name="typeOfWaiverOrProgrampdf" value="DD"
                            [(ngModel)]="serviceplanImportBO.typeOfWaiverOrProgram" [disabled]="logintype =='onboardLogin'" />DD
                        &nbsp;
                        <input type="radio" class="inputradio me-1" name="typeOfWaiverOrProgrampdf" value="EW"
                            [(ngModel)]="serviceplanImportBO.typeOfWaiverOrProgram" [disabled]="logintype =='onboardLogin'" />EW
                        &nbsp;
                    </div>
                </div>
            </div>
            <div *ngIf="serviceplanImportBO.is65OrOlder == true || serviceplanImportBO.usesWaiverOrProgram ==true">
                 <div class="section-title">Case Manager/Care Coordinator</div>
                <div *ngFor="let item of serviceplanImportBO.careCoordinator; let goal1=index">

                    <table class="tablepdf" >
                        <tr>
                            <th  class="theadtd" >NAME</th>
                            <th class="theadtd" width="200px">PHONE NUMBER</th>
                            
                            <th class="theadtd" width="200px">FAX NUMBER</th>
                        </tr>
                        <tr>
                            <td class="theadtd" ><input type="text" class="inputtext"  [(ngModel)]="item.coordinator_Name"></td>
                            <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="item.phoneNumber"></td>
                            
                            <td class="theadtd" ><input type="text" class="inputtext"  [(ngModel)]="item.fax"></td>
                           
                        </tr>
                    </table>
                    <table class="tablepdf" >
                        <tr>
                            <th class="theadtd" >STREET ADDRESS</th>
                            <th class="theadtd" width="200px">CITY</th>
                        </tr>
                        <tr>
                            <td class="theadtd" ><textarea type="text" class="inputtext" [(ngModel)]="item.street"></textarea></td>
                            <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="item.city"></td>
                        </tr>
                    </table>
                    <table class="tablepdf" >
                        <tr>
                           
                            <th class="theadtd" width="100px">STATE</th>
                            <th class="theadtd" width="100px">ZIP CODE</th>
                            <th class="theadtd" >EMAIL ADDRESS</th>
                        </tr>
                        <tr>
                           
                            <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="item.state" bindLabel="name" bindValue="abbreviation"></td>
                            <td class="theadtd" ><input type="text" class="inputtext"  [(ngModel)]="item.zipCode"></td>
                            <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="item.email"></td>
                        </tr>
                    </table>
                  
                </div>
            </div>
            <div class="section-title-info"> CFSS Model</div>
            <div class="row" style="margin-top: 16px;">
                <div>
                    <label>Which model are you using?
                        &nbsp;
                    </label>
                </div>
            </div>
            <div class="row" style="margin-top: 16px;">
                <p class="f">Note:Your consultation services provider can help you understand the differences between
                    the models. If you are on the Minnesota
                    Restricted Recipient Program (MRRP), you must use the agency model.
                </p>
            </div>
            <div class="row" style="margin-top: 16px;">
                <div>
                    <!--  BUDGET -->
                    <span>
                        <input type="radio" class="inputradio" [value]="'BUDGET'"
                        [(ngModel)]="serviceplanImportBO.modelTypename">&nbsp;
                        <label class="label">
                            Budget</label>
                    </span>&nbsp;
                    <!-- Agency  -->
                    <span>
                        <input type="radio" class="inputradio" [value]="'AGENCY'"
                        [(ngModel)]="serviceplanImportBO.modelTypename">&nbsp;
                        <label class="label">Agency
                        </label>
                    </span>&nbsp;
                </div>
            </div>
            
            <div class="section-title-info" *ngIf="serviceplanImportBO.modelTypename == 'BUDGET'">Budget </div>
            <div class="row" style="margin-top: 16px;" *ngIf="serviceplanImportBO.modelTypename == 'BUDGET'">
                <div >
                    <label>Your budget will be :&nbsp;
                    </label>
                    <!--  budget -->
                    <span>
                        <input type="text" class="inputtext" [(ngModel)]="serviceplanImportBO.fmsBudget.budgetAmount">
                    </span>&nbsp;
            
                </div>
            </div>

            <div *ngIf="serviceplanImportBO.modelTypename == 'BUDGET'">

                <div class="section-title-info"> Financial management service (FMS) provider</div>
                <table class="tablepdf" >
                 <tr>
                     <th class="theadtd" >NAME</th>
                     <th class="theadtd" width="200px">NPI</th>
                     <th class="theadtd" width="200px">PHONE NUMBER</th>
                 </tr>
                 <tr>
                     <td class="theadtd" >  <ng-select [items]="FmsAgencyList"  class="w-100 "
                        [searchable]="true" 
                        [(ngModel)]="FMSProvider.fmsAgencyId" [clearable]="true"  (change)="onAgencySelected($event)" 
                        bindLabel="Value" bindValue="Key">
                    </ng-select></td>
                     <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="FMSProvider.npi"></td>
                     <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="FMSProvider.phoneNumber"></td>
                 </tr>
             </table>
             <table class="tablepdf" >
                 <tr>
                     <th class="theadtd" >STREET ADDRESS</th>
                     <th class="theadtd" width="300px">CITY</th>
                 </tr>
                 <tr>
                     <td class="theadtd" ><textarea type="text" class="inputtext" [(ngModel)]="FMSProvider.address"></textarea></td>
                     <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="FMSProvider.city"></td>
                     </tr>
             </table>
         
             <table class="tablepdf" >
                 <tr>
                    
                     <th class="theadtd" width="100px">STATE</th>
                     <th class="theadtd" width="100px">ZIP CODE</th>
                     <th class="theadtd">CONTACT NAME</th>
                    
                 </tr>
                 <tr>
                     <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="FMSProvider.state" bindLabel="name" bindValue="abbreviation"></td>
                     <td class="theadtd" ><input type="text" class="inputtext"  [(ngModel)]="FMSProvider.zipCode"></td>
                     <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="FMSProvider.contactName"></td>
                   
                 </tr>
             </table>
             <table class="tablepdf" >
                 <tr>
                     <th class="theadtd" >EMAIL ADDRESS</th>
                     <th class="theadtd" width="200px">FAX NUMBER</th>
                 </tr>
                 <tr>
                     <td class="theadtd" ><input type="text" class="inputtext"  [(ngModel)]="FMSProvider.email"></td>
                     <td class="theadtd" ><input type="text" class="inputtext"  [(ngModel)]="FMSProvider.fax"></td>
                 </tr>
             </table>
                
               </div>

               <div class="section-title-info" *ngIf="serviceplanImportBO?.modelTypename == 'BUDGET'"> FMS fee</div>

               <label  *ngIf="serviceplanImportBO?.modelTypename == 'BUDGET'" class="label">Estimated annual FMS fee (Go to the <a
                href="https://mn.gov/dhs/people-we-serve/people-with-disabilities/services/home-community/programs-and-services/fms.jsp">FMS Provier page </a>for a list of fees or ask
            your FMS provider.)</label>
               <input *ngIf="serviceplanImportBO?.modelTypename == 'BUDGET'" type="text" class="inputtext" [(ngModel)]="serviceplanImportBO.fmsBudget.fmsFee" (change)="changefunction()">
               <!-- <label *ngIf="serviceplanImportBO?.modelTypename == 'BUDGET'">
                   How many months is your plan?
               </label>
               <input *ngIf="serviceplanImportBO?.modelTypename == 'BUDGET'" type="text"  class="inputtext"    [(ngModel)]="serviceplanImportBO.fmsBudget.planMonths"> -->
           
            <!-- <div class="section-title-info">Personal emergency response system (PERS)</div>
            <div class="section-title-info">Financial management service(FMS) provider agency information</div>
             -->

            <div class="section-title-info" *ngIf="serviceplanImportBO.modelTypename == 'AGENCY'">Provider agency</div>
            <div *ngIf="serviceplanImportBO.modelTypename == 'AGENCY'">
               <div *ngFor="let item of serviceplanImportBO.agencyModels.agencyDetails; " id="goalaccordion">

                   <table class="tablepdf" >
                       <tr>
                           <th class="theadtd" >AGENCY NAME</th>
                           <th class="theadtd" width="200px">NPI</th>
                           <th class="theadtd" width="200px">PHONE NUMBER</th>
                       </tr>
                       <tr>
                           <td class="theadtd" ><input type="text" class="inputtext"  [(ngModel)]="item.agencyName"></td>
                           <td class="theadtd" ><input type="text" class="inputtext"  [(ngModel)]="item.npi"></td>
                           <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="item.phoneNumber"></td>
                       </tr>
                   </table>
                   <table class="tablepdf" >
                       <tr>
                           <th class="theadtd" >STREET ADDRESS</th>
                           <th class="theadtd" width="200px">CITY</th>
                       </tr>
                       <tr>
                           <td class="theadtd" ><textarea type="text" class="inputtext" [(ngModel)]="item.street"></textarea></td>
                           <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="item.city"></td>
                       </tr>
                   </table>

                   <table class="tablepdf" >
                    <tr>
                       
                        <th class="theadtd" width="100px">STATE</th>
                        <th class="theadtd" width="100px">ZIP CODE</th>
                        <th class="theadtd">CONTACT NAME</th>
                    </tr>
                    <tr>
                        <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="item.state" bindLabel="name" bindValue="abbreviation"></td>
                        <td class="theadtd" ><input type="text" class="inputtext"  [(ngModel)]="item.zipCode"></td>
                        
                        <td class="theadtd" ><input type="text" class="inputtext"[(ngModel)]="item.contactName"></td>
                    </tr>
                </table>
                   <table class="tablepdf" >
                       <tr>
                         
                           <th class="theadtd" >EMAIL ADDRESS</th>
                           <th class="theadtd" width="200px">FAX NUMBER</th>
                       </tr>
                       <tr>
                           <td class="theadtd" ><input type="text" class="inputtext"[(ngModel)]="item.emailAddress"></td>
                           <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="item.faxNumber"></td>
                       </tr>
                   </table>
               </div>
            </div>



              <div class="section-title-info">PERS, goods and services</div>
                <div class="section-title">Personal emergency response system (PERS)</div>                
            <p class="f"> As a part of your requirement to have a backup plan, will you use an emergency response system provided by a
                Minnesota Health Care Programs (MHCP) vendor?</p>
                <div>
                    <span>
                        <input type="radio" class="inputradio" [value]="true"
                        [(ngModel)]="serviceplanImportBO.willUsePERS" (change)="changefunction()">&nbsp;
                        <label class="label">
                            Yes</label>
                    </span>&nbsp;
                    
                    <span>
                        <input type="radio" class="inputradio" [value]="false"
                        [(ngModel)]="serviceplanImportBO.willUsePERS" (change)="changefunction()">&nbsp;
                        <label class="label">No
                        </label>
                    </span>&nbsp;
                </div>
                <div class="section-title-info" *ngIf="serviceplanImportBO.willUsePERS == true">
                    MHCP PERS costs     
                </div>
                <p class="f"  *ngIf="serviceplanImportBO.willUsePERS == true">Enter PERS costs per year.</p>
                <div *ngIf="serviceplanImportBO.willUsePERS == true">

                    <table class="tablepdf" >
                        <tr >
                            <th class="theadtd" width="200px"><b>Type of cost</b></th>
                            <th class="theadtd" ><b>Name of MHCP provider</b></th>
                            <th class="theadtd" width="100px"><b>Cost</b></th>
                        </tr>
                        <tr >
                            <td class="theadtd"  width="200px">  <label class="label">Equipment</label></td>
                            <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="serviceplanImportBO.mhcpCost.equipment_ProviderName" (change)="changefunction()"></td>
                            <td class="theadtd"  width="100px"><input type="text" class="inputtext" [(ngModel)]="serviceplanImportBO.mhcpCost.equipment_Cost" (change)="changefunction()" ></td>
                        </tr>
                        <tr >
                            <td class="theadtd"  width="200px"><label class="label">Installation</label></td>
                            <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="serviceplanImportBO.mhcpCost.installation_ProviderName" (change)="changefunction()"></td>
                            <td class="theadtd"  width="100px"><input type="text" class="inputtext" [(ngModel)]="serviceplanImportBO.mhcpCost.installation_Cost" (change)="changefunction()"></td>
                        </tr>
                        <tr >
                            <td class="theadtd"  width="200px"><label class="label">Monthly subscription</label></td>
                            <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="serviceplanImportBO.mhcpCost.subscription_ProviderName" (change)="changefunction()"></td>
                            <td class="theadtd"  width="100px"><input type="text" class="inputtext"  [(ngModel)]="serviceplanImportBO.mhcpCost.subscription_Cost" (change)="changefunction()"></td>
                        </tr>
                        <tr >
                            <td class="theadtd"  colspan="2" style="text-align: right;">Total</td>
                            <td class="theadtd" ><label class="label">${{mhcptotal}}</label></td>
                        </tr>
                    </table>
                </div>


           <div class="section-title-info" *ngIf="serviceplanImportBO.modelTypename == 'AGENCY'"> Goods and services</div>
           <div class="row" style="margin-top: 16px;">
            <div *ngIf="serviceplanImportBO.modelTypename == 'AGENCY'">
                <label>Do you plan to purchase goods and services?&nbsp;
                </label>
                <!--  Yes -->
                <span>
                    <input type="radio" class="inputradio"  [value]="true"
                    [(ngModel)]="serviceplanImportBO.is_Goods_And_Service" (change)="changefunction()">&nbsp;
                    <label class="label">
                        Yes</label>
                </span>&nbsp;
                <!-- No  -->
                <span>
                    <input type="radio" class="inputradio" [value]="false"
                    [(ngModel)]="serviceplanImportBO.is_Goods_And_Service" (change)="changefunction()">&nbsp;
                    <label class="label">No
                    </label>
                </span>&nbsp;
            </div>
        </div>

      
      
      <div *ngIf="serviceplanImportBO.is_Goods_And_Service && serviceplanImportBO.modelTypename == 'AGENCY'">

       <div class="section-title-info"> Financial management service (FMS) provider</div>
       <table class="tablepdf" >
        <tr>
            <th class="theadtd" >NAME</th>
            <th class="theadtd" width="200px">NPI</th>
            <th class="theadtd" width="200px">PHONE NUMBER</th>
        </tr>
        <tr>
            <td class="theadtd" >  <ng-select [items]="FmsAgencyList"  class="w-100 "
                [searchable]="true" 
                [(ngModel)]="FMSProvider.fmsAgencyId" [clearable]="true"
                bindLabel="Value" bindValue="Key" (change)="changefunction()">
            </ng-select></td>
            <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="FMSProvider.npi" (change)="changefunction()"></td>
            <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="FMSProvider.phoneNumber" (change)="changefunction()"></td>
        </tr>
    </table>
    <table class="tablepdf" >
        <tr>
            <th class="theadtd" >STREET ADDRESS</th>
            <th class="theadtd" width="300px">CITY</th>
        </tr>
        <tr>
            <td class="theadtd" ><textarea type="text" class="inputtext" [(ngModel)]="FMSProvider.address" (change)="changefunction()"></textarea></td>
            <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="FMSProvider.city" (change)="changefunction()"></td>
            </tr>
    </table>

    <table class="tablepdf" >
        <tr>
           
            <th class="theadtd" width="100px">STATE</th>
            <th class="theadtd" width="100px">ZIP CODE</th>
            <th class="theadtd">CONTACT NAME</th>
           
        </tr>
        <tr>
            <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="FMSProvider.state" bindLabel="name" bindValue="abbreviation" (change)="changefunction()"></td>
            <td class="theadtd" ><input type="text" class="inputtext"  [(ngModel)]="FMSProvider.zipCode" (change)="changefunction()"></td>
            <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="FMSProvider.contactName" (change)="changefunction()"></td>
          
        </tr>
    </table>
    <table class="tablepdf" >
        <tr>
            <th class="theadtd" >EMAIL ADDRESS</th>
            <th class="theadtd" width="200px">FAX NUMBER</th>
        </tr>
        <tr>
            <td class="theadtd" ><input type="text" class="inputtext"  [(ngModel)]="FMSProvider.email" (change)="changefunction()"></td>
            <td class="theadtd" ><input type="text" class="inputtext"  [(ngModel)]="FMSProvider.fax" (change)="changefunction()"></td>
        </tr>
    </table>
       
      </div>

      
         


        <div class="section-title-info" *ngIf="serviceplanImportBO?.modelTypename == 'BUDGET' ||serviceplanImportBO.is_Goods_And_Service "> Goods and services</div>
        <div class="row" style="margin-top: 16px;">
         <div *ngIf="serviceplanImportBO.modelTypename == 'BUDGET'">
             <label>Do you plan to purchase goods and services?&nbsp;
             </label>
             <!--  Yes -->
             <span>
                 <input type="radio" class="inputradio"  [value]="true"
                 [(ngModel)]="serviceplanImportBO.is_Goods_And_Service">&nbsp;
                 <label class="label" (change)="changefunction()">
                     Yes</label>
             </span>&nbsp;
             <!-- No  -->
             <span>
                 <input type="radio" class="inputradio" [value]="false"
                 [(ngModel)]="serviceplanImportBO.is_Goods_And_Service">&nbsp;
                 <label class="label" (change)="changefunction()">No
                 </label>
             </span>&nbsp;
         </div>
     </div>
     <div  *ngIf="((serviceplanImportBO.modelTypename == 'AGENCY' && serviceplanImportBO.is_Goods_And_Service) || serviceplanImportBO.is_Goods_And_Service) ">
        <p> What goods and services do you intend to
            purchase?</p>

    </div>
     
        <!-- <div class="row" style="margin-top: 16px;" *ngIf="serviceplanImportBO.modelTypename == 'BUDGET' && serviceplanImportBO.is_Goods_And_Service">
            <p class="f"> <b>Note:</b>Percentage fees also are listed on the FMS service provider page. If your FMS does not charge a percentage fee for each good,
                enter a zero (0) in the FMS fee (percentage) field.
            </p>
        </div> -->
        <div *ngIf="serviceplanImportBO.is_Goods_And_Service">

            <table class="tablepdf"  style="font-size: 14px; width: 100%; border-collapse: collapse;">
                <tr>
                    <th class="theadtd" ><b>Good/Service</b></th>
                    <th class="theadtd" ><b>Assessed need it relates to</b></th>
                    <th class="theadtd" ><b>Human support it replaces</b></th>
                    <th class="theadtd" width="80px"><b>Cost</b></th>
                    <!-- <th class="theadtd"  width="80px" *ngIf="serviceplanImportBO.modelTypename == 'BUDGET'"><b>FMS fee (percentage)</b></th> -->
                </tr>
            
                <tr *ngFor="let service of goodsAndServices;">
                    <td class="theadtd" >
                        <input type="text" class="inputtext" [(ngModel)]="service.goods_Or_Service" (change)="changefunction()">
                    </td>
                    <td class="theadtd" >
                        <textarea type="text" class="inputtext" [(ngModel)]="service.assessed_Need" (change)="changefunction()"></textarea>
                    </td>
                    <td class="theadtd" >
                        <textarea type="text" class="inputtext" [(ngModel)]="service.human_Support_It_Replaces" (change)="changefunction()"></textarea>
                    </td>
                    <td class="theadtd" >
                        <input type="text" class="inputtext" [(ngModel)]="service.cost" (change)="changefunction()">
                    </td>
                    <!-- <td class="theadtd"  *ngIf="serviceplanImportBO.modelTypename == 'BUDGET'">
                        <input type="text" class="inputtext" [(ngModel)]="service.fms_Fee_Percentage">
                    </td> -->
                </tr>
            
                <!-- <tr *ngIf="serviceplanImportBO.modelTypename == 'BUDGET'">
                    <td class="theadtd"  colspan="3">Sub Total</td>
                    <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="Goodssubtotalcost"></td>
                    <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="Goodssubtotalfee"></td>
                </tr> -->
            
                <tr *ngIf="serviceplanImportBO.modelTypename == 'BUDGET'">
                    <td class="theadtd"  colspan="4">Grand Total</td>
                    <td class="theadtd" ><input type="text" class="inputtext"  [(ngModel)]="Goodsgrandtotal"></td>
                </tr>

                <tr *ngIf="serviceplanImportBO.modelTypename == 'AGENCY'">
                    <td class="theadtd"  colspan="3"> Total</td>
                    <td class="theadtd" ><input type="text" class="inputtext"  [(ngModel)]="Goodsgrandtotal"></td>
                </tr>

            
            </table>
            
        </div>

        <!-- <div class="row mt-2" *ngIf="serviceplanImportBO.modelTypename == 'AGENCY' && serviceplanImportBO.is_Goods_And_Service">
            <p><b>* NOTE: </b>You can locate your FMS’s fees at <a
                    href="https://mn.gov/dhs/people-we-serve/people-with-disabilities/services/home-community/programs-and-services/fms.jsp">DHS
                    -- financial management service provider information</a> or by
                asking your FMS.</p>
        </div> -->

        <div *ngIf="serviceplanImportBO.modelTypename == 'AGENCY' &&  serviceplanImportBO.is_Goods_And_Service">
            <p><b>* NOTE:</b> You can locate your FMS’s fees at <a href="https://mn.gov/dhs/people-we-serve/people-with-disabilities/services/home-community/programs-and-services/fms.jsp">DHS -- financial management service provider information</a> or by asking your FMS.</p>
            <h4><b>General schedule</b></h4>
            <label>You can use your units flexibly throughout the year. You need to have a plan for how you will use your units, but remember that you can adapt to changes in your life as needed.</label>
            <p><b>NOTE:</b> If you are on the Minnesota Restricted Recipient Program (MRRP) you must use the same number of units each month, so answer "Yes."</p>
        
            </div>
            <div *ngIf="serviceplanImportBO.modelTypename == 'AGENCY' &&  serviceplanImportBO.is_Goods_And_Service == false">
                  <h4 class=" font-header" id="exampleModalLabel"><b>Planned monthly use of units
                        </b></h4>
              <label class="label">You can use your units flexibly throughout the year. You need to have a plan for how you will use your units, but
                        remember that you can adapt to changes in your life as needed.</label>
               

                </div>

                
                <div class="row mt-3" *ngIf="(serviceplanImportBO.modelTypename == 'AGENCY') && (serviceplanImportBO.is_Goods_And_Service ==true || serviceplanImportBO.is_Goods_And_Service== false)  && serviceplanImportBO.isFullYearPlan!= false ">
                    <label class="label col-lg-5">Do you plan to use approximately the same
                        amount of units each month?</label>

                    <div class="col-lg-3">
                        <input type="radio" class="ml-2" name="agentmonthplanpdf" [value]="true"
                            [(ngModel)]="serviceplanImportBO.agencyModels.planSameUnitsEachMonth" (ngModelChange)="CalculateAgentmonthlyAmt()" />
                        Yes &nbsp;
                        <input type="radio" class="ml-2" name="agentmonthplanpdf" [value]="false"
                            [(ngModel)]="serviceplanImportBO.agencyModels.planSameUnitsEachMonth" />No
                        &nbsp;
                    </div>
                </div>

                <p *ngIf="serviceplanImportBO.modelTypename == 'AGENCY' && serviceplanImportBO.agencyModels.planSameUnitsEachMonth==true && serviceplanImportBO.isFullYearPlan== true"><b>Monthly units</b></p>
                <div *ngIf="serviceplanImportBO.modelTypename == 'AGENCY' && serviceplanImportBO.agencyModels.planSameUnitsEachMonth==true && serviceplanImportBO.isFullYearPlan== true">
                    <label>Planned monthly use of units:</label>
                    <input type="text" class="inputtext" [(ngModel)]="serviceplanImportBO.agencyModels.plannedUnits" >
                </div>

                <div class="row mt-3" *ngIf="serviceplanImportBO.modelTypename == 'AGENCY'&& (serviceplanImportBO.isFullYearPlan==false && serviceplanImportBO.agencyModels.planSameUnitsEachMonth==false)" >
                    <h5 class=" font-header" id="exampleModalLabel"><b>General schedule
                        </b></h5>
                </div>

                <div class="row mt-3" *ngIf="serviceplanImportBO.modelTypename == 'AGENCY'&& (serviceplanImportBO.isFullYearPlan==false && serviceplanImportBO.agencyModels.planSameUnitsEachMonth==false)" >
                   <label>What would you like your general worker schedule to be? This is just a general plan. You can vary from day to day as
                    needed.</label>
                </div>
                 
            <h5 *ngIf="serviceplanImportBO.modelTypename == 'AGENCY'&& (serviceplanImportBO.isFullYearPlan==false || serviceplanImportBO.agencyModels.planSameUnitsEachMonth==false)" ><b>Month-by-month general plan</b></h5>
            <label *ngIf="serviceplanImportBO.modelTypename == 'AGENCY'&& (serviceplanImportBO.isFullYearPlan==false|| serviceplanImportBO.agencyModels.planSameUnitsEachMonth==false)" >Since you won't use the same amount of units each month, use this table to estimate how many units you expect to use each day, depending on the month.</label>
            <div  *ngIf="serviceplanImportBO.modelTypename == 'AGENCY'&& (serviceplanImportBO.isFullYearPlan==false || serviceplanImportBO.agencyModels.planSameUnitsEachMonth==false)" >
                <h5 class=" font-header" id="exampleModalLabel"><b>Units per month
                    </b></h5>
            </div>
            <div  *ngIf="serviceplanImportBO.modelTypename == 'AGENCY'&& (serviceplanImportBO.isFullYearPlan==false || serviceplanImportBO.agencyModels.planSameUnitsEachMonth==false)" >
                <label class="label ">Enter the estimated units you will use per month
                </label>
                <p>(enter numbers; total should not exceed the amount of units your are
                    eligible for):</p>
            </div>
            <table class="tablepdf"  *ngIf="serviceplanImportBO.modelTypename == 'AGENCY'&& (serviceplanImportBO.isFullYearPlan==false || serviceplanImportBO.agencyModels.planSameUnitsEachMonth==false)" >
                <tr>
                    <th class="theadtd">JAN</th>
                    <th class="theadtd">FEB</th>
                    <th class="theadtd">MAR</th>
                    <th class="theadtd">APR</th>
                    <th class="theadtd">MAY</th>
                    <th class="theadtd">JUN</th>
                    <th class="theadtd">JUL</th>
                    <th class="theadtd">AUG</th>
                    <th class="theadtd">SEP</th>
                    <th class="theadtd">OCT</th>
                    <th class="theadtd">NOV</th>
                    <th class="theadtd">DEC</th>
                </tr>
                <tr>
                    <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="serviceplanImportBO.agencyModels.monthlyUnitUsage.unitsJan" ></td>
                    <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="serviceplanImportBO.agencyModels.monthlyUnitUsage.unitsFeb" ></td>
                    <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="serviceplanImportBO.agencyModels.monthlyUnitUsage.unitsMar" ></td>
                    <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="serviceplanImportBO.agencyModels.monthlyUnitUsage.unitsApr" ></td>
                    <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="serviceplanImportBO.agencyModels.monthlyUnitUsage.unitsMay" ></td>
                    <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="serviceplanImportBO.agencyModels.monthlyUnitUsage.unitsJun" ></td>
                    <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="serviceplanImportBO.agencyModels.monthlyUnitUsage.unitsJul" ></td>
                    <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="serviceplanImportBO.agencyModels.monthlyUnitUsage.unitsAug" ></td>
                    <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="serviceplanImportBO.agencyModels.monthlyUnitUsage.unitsSep" ></td>
                    <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="serviceplanImportBO.agencyModels.monthlyUnitUsage.unitsOct" ></td>
                    <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="serviceplanImportBO.agencyModels.monthlyUnitUsage.unitsNov" ></td>
                    <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="serviceplanImportBO.agencyModels.monthlyUnitUsage.unitsDec" ></td>
                </tr>
                <tr>
                    <td class="theadtd"  colspan="10" ><b>Units eligible for:</b> <p *ngIf="serviceplanImportBO.totalCFSSUnitsEligible!= null && serviceplanImportBO.totalCFSSUnitsEligible!= 0">{{serviceplanImportBO.totalCFSSUnitsEligible}}</p></td>
                    <td class="theadtd" ><span style="font-size: 9px;  ">12-MONTH TOTAL</span></td>
                    <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="serviceplanImportBO.agencyModels.monthlyUnitUsage.totalUnitsUsed"></td>
                </tr>
            </table>

            <div  class="section-title-info" *ngIf="serviceplanImportBO.modelTypename == 'AGENCY' || serviceplanImportBO.modelTypename == 'BUDGET'"><b>Workers</b></div>
            <label *ngIf="serviceplanImportBO.modelTypename == 'AGENCY'">Tell your agency what preferences you have about your worker:</label>
            <div class="row" *ngIf="serviceplanImportBO.modelTypename == 'AGENCY'">
                <div class="col-lg-12">
                    <textarea  [(ngModel)]="serviceplanImportBO.agencyModels.workerPreferencesDetails"style="width: 100%; height:230px" ></textarea>
                </div>
            </div>
            <label *ngIf="serviceplanImportBO.modelTypename == 'AGENCY'">What is your worker training development plan? (Leave this section blank.You
                                                    and your agency should complete this together.<br/>
                                                    <strong>NOTE:</strong> The provider agency can choose to document these answers in another location.)</label>
            <div class="row" *ngIf="serviceplanImportBO.modelTypename == 'AGENCY'">
                <div class="col-lg-12">
                    <textarea  [(ngModel)]="serviceplanImportBO.agencyModels.trainingDevelopmentPlan"style="width: 100%; height:230px" ></textarea>
                </div>
            </div>
        
            <div *ngIf="serviceplanImportBO.modelTypename == 'BUDGET'">
                <label>Do you plan to use personal care workers?</label>
                <input type="radio" class="inputradio" name="workers1" [value]="true" [(ngModel)]="serviceplanImportBO.fmsBudget.is_Personal_Care_Workers" (change)="changefunction()"> Yes
                <input type="radio" class="inputradio" name="workers1" [value]="false" [(ngModel)]="serviceplanImportBO.fmsBudget.is_Personal_Care_Workers" (change)="changefunction()"> No
            </div>
<!-- 
                <div *ngIf="serviceplanImportBO.modelTypename == 'AGENCY' &&  serviceplanImportBO.is_Goods_And_Service">
            <p><b>* NOTE:</b> You can locate your FMS’s fees at <a href="https://mn.gov/dhs/people-we-serve/people-with-disabilities/services/home-community/programs-and-services/fms.jsp">DHS -- financial management service provider information</a> or by asking your FMS.</p>
            <h4><b>General schedule</b></h4>
            <label>You can use your units flexibly throughout the year. You need to have a plan for how you will use your units, but remember that you can adapt to changes in your life as needed.</label>
            <p><b>NOTE:</b> If you are on the Minnesota Restricted Recipient Program (MRRP) you must use the same number of units each month, so answer "Yes."</p>
        
            
                <div *ngIf="(serviceplanImportBO.modelTypename == 'AGENCY') && (serviceplanImportBO.isFullYearPlan==true) ">

                    <label>Do you plan to use approximately the same amount of units each month?</label> &nbsp;
                    <input type="radio" class="inputradio"  [value]="true" [(ngModel)]="serviceplanImportBO.agencyModels.planSameUnitsEachMonth" > Yes
                    <input type="radio" class="inputradio"  [value]="false" [(ngModel)]="serviceplanImportBO.agencyModels.planSameUnitsEachMonth"> No
                </div>
            
        
         
        
            <h5 *ngIf="serviceplanImportBO.modelTypename == 'AGENCY' && (serviceplanImportBO.isFullYearPlan==false || serviceplanImportBO.agencyModels.planSameUnitsEachMonth==false)"><b>Month-by-month general plan</b></h5>
            <label *ngIf="serviceplanImportBO.modelTypename == 'AGENCY' && (serviceplanImportBO.isFullYearPlan==false || serviceplanImportBO.agencyModels.planSameUnitsEachMonth==false)">Since you won't use the same amount of units each month, use this table to estimate how many units you expect to use each day, depending on the month.</label>
            <div  *ngIf="serviceplanImportBO.modelTypename == 'AGENCY'&& (serviceplanImportBO.isFullYearPlan==false || serviceplanImportBO.agencyModels.planSameUnitsEachMonth==false)">
                <h5 class=" font-header" id="exampleModalLabel"><b>Units per month
                    </b></h5>
            </div>
            <div  *ngIf="serviceplanImportBO.modelTypename == 'AGENCY'&& (serviceplanImportBO.isFullYearPlan==false || serviceplanImportBO.agencyModels.planSameUnitsEachMonth==false)">
                <label class="label ">Enter the estimated units you will use per month
                </label>
                <p>(enter numbers; total should not exceed the amount of units your are
                    eligible for):</p>
            </div>
            <table class="tablepdf"  *ngIf="serviceplanImportBO.modelTypename == 'AGENCY'&& (serviceplanImportBO.isFullYearPlan==false || serviceplanImportBO.agencyModels.planSameUnitsEachMonth==false)">
                <tr>
                    <th class="theadtd">JAN</th>
                    <th class="theadtd">FEB</th>
                    <th class="theadtd">MAR</th>
                    <th class="theadtd">APR</th>
                    <th class="theadtd">MAY</th>
                    <th class="theadtd">JUN</th>
                    <th class="theadtd">JUL</th>
                    <th class="theadtd">AUG</th>
                    <th class="theadtd">SEP</th>
                    <th class="theadtd">OCT</th>
                    <th class="theadtd">NOV</th>
                    <th class="theadtd">DEC</th>
                </tr>
                <tr>
                    <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="serviceplanImportBO.agencyModels.monthlyUnitUsage.unitsJan" ></td>
                    <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="serviceplanImportBO.agencyModels.monthlyUnitUsage.unitsFeb" ></td>
                    <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="serviceplanImportBO.agencyModels.monthlyUnitUsage.unitsMar" ></td>
                    <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="serviceplanImportBO.agencyModels.monthlyUnitUsage.unitsApr" ></td>
                    <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="serviceplanImportBO.agencyModels.monthlyUnitUsage.unitsMay" ></td>
                    <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="serviceplanImportBO.agencyModels.monthlyUnitUsage.unitsJun" ></td>
                    <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="serviceplanImportBO.agencyModels.monthlyUnitUsage.unitsJul" ></td>
                    <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="serviceplanImportBO.agencyModels.monthlyUnitUsage.unitsAug" ></td>
                    <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="serviceplanImportBO.agencyModels.monthlyUnitUsage.unitsSep" ></td>
                    <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="serviceplanImportBO.agencyModels.monthlyUnitUsage.unitsOct" ></td>
                    <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="serviceplanImportBO.agencyModels.monthlyUnitUsage.unitsNov" ></td>
                    <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="serviceplanImportBO.agencyModels.monthlyUnitUsage.unitsDec" ></td>
                </tr>
                <tr>
                    <td class="theadtd"  colspan="10" ><b>Units eligible for:</b> <p *ngIf="serviceplanImportBO.totalCFSSUnitsEligible!= null && serviceplanImportBO.totalCFSSUnitsEligible!= 0">${{serviceplanImportBO.totalCFSSUnitsEligible}}</p></td>
                    <td class="theadtd" ><span style="font-size: 9px;  ">12-MONTH TOTAL</span></td>
                    <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="serviceplanImportBO.agencyModels.monthlyUnitUsage.totalUnitsUsed"></td>
                </tr>
            </table>
        
           
        </div> -->

     <div class="section-title-info" *ngIf="serviceplanImportBO.modelTypename == 'BUDGET' && serviceplanImportBO.fmsBudget.is_Personal_Care_Workers" >Worker budget</div>
     <div class="row" style="margin-top: 16px;" *ngIf="serviceplanImportBO.modelTypename == 'BUDGET' && serviceplanImportBO.fmsBudget.is_Personal_Care_Workers">
                <div >
                    <label>Your budget for CFSS workers will be:&nbsp;
                    </label>
                    <!--  budget -->
                    <span>
                        <input type="text" class="inputtext" [(ngModel)]="serviceplanImportBO.cfssWorkerBudget">
                    </span>&nbsp;
            
                </div>
            </div>
     
        <div *ngIf="serviceplanImportBO.modelTypename == 'BUDGET' && serviceplanImportBO.fmsBudget.is_Personal_Care_Workers">
            <p><b>Job description</b></p>
        </div>
        <div *ngIf="serviceplanImportBO.modelTypename == 'BUDGET' && serviceplanImportBO.fmsBudget.is_Personal_Care_Workers">
            <label>Describe the worker(s) job duties (i.e., the tasks you want your worker[s] to do)</label>
            <div class="row">
                <div class="col-lg-12">
                    <textarea  [(ngModel)]="serviceplanImportBO.fmsBudget.jobDescription" style="width: 100%; height:230px" ></textarea>
                </div>
            </div>
        </div>
        
        <div *ngIf="serviceplanImportBO.modelTypename == 'BUDGET' && serviceplanImportBO.fmsBudget.is_Personal_Care_Workers">
            <p><b>Job description</b></p>
        </div>
        <div class="row mt-1" *ngIf="serviceplanImportBO.modelTypename == 'BUDGET' 
        &&serviceplanImportBO.fmsBudget.is_Personal_Care_Workers">
            <!-- <p><b>Reminder: </b>If the worker is your spouse or your parent (if you are
                a minor), there are limits to the number of hours they can work and they
                cannot
                earn more than the current CFSS rate. If you have questions, your
                consultation services provider and FMS can assist you.</p> -->
                <p>This section is to help you think about how you might spend your worker budget. Keep in mind:</p>
        </div>

        <div class="row mt-1" *ngIf="serviceplanImportBO.modelTypename == 'BUDGET' 
        &&serviceplanImportBO.fmsBudget.is_Personal_Care_Workers">
        <ul style="margin-left:30px" >
            <li>Costs will change based on your decisions about wages and hours and the FMS’ determination of required taxes and
                worker’s compensation.
            </li>
            <li>
                You must pay your workers at least $20.00 an hour to comply with the Service Employees International Union (SEIU)
                Healthcare Minnesota and Iowa collective bargaining agreement.
            </li>
            </ul>
        
        </div>
        
        
        <div *ngIf="serviceplanImportBO.modelTypename == 'BUDGET' 
                                    &&serviceplanImportBO.fmsBudget.is_Personal_Care_Workers">

            <table class="tablepdf"  style="font-size: small; font-weight: bold;">
                <tr >
                    <th class="theadtd" width="300px">Worker (e.g., worker's name, "Worker 1," "Worker 2," "paid spouse," etc.)</th>
                    <th class="theadtd" width="80px">Hourly wage</th>
                    <th class="theadtd" width="80px">Number of hours per week</th>
                    <th class="theadtd" width="80px">Number of weeks</th>
                    <th class="theadtd" >*Do payroll taxes apply?</th>
                    <th class="theadtd" >*Does PTO apply?</th>
                    <th class="theadtd" >*Does workers' comp apply?</th>
                    <th class="theadtd" width="100px">Total</th>
                </tr>
            
                <tr *ngFor="let service of  serviceplanImportBO.fmsBudget.workerBudgets;">
                    <td class="theadtd" >
    
                        <input type="text" class="inputtext" [(ngModel)]="service.worker_Name">
                    </td>
                    <td class="theadtd" >
                        <input type="text" class="inputtext"  [(ngModel)]="service.hourly_Wage">
                    </td>
                    <td class="theadtd" >
                        <input type="text" class="inputtext"  [(ngModel)]="service.no_Of_Hours_Per_Week">
                    </td>
                    <td class="theadtd" >
                        <input type="text" class="inputtext"  [(ngModel)]="service.no_Of_Weeks">
                    </td>
                    <td class="theadtd" >
                        <input type="radio" class="inputradio"  [value]="true"
                        [(ngModel)]="service.is_Payroll_Applied"> Yes
                        <input type="radio" class="inputradio" [value]="false"
                        [(ngModel)]="service.is_Payroll_Applied "> No
                    </td>
                    <td class="theadtd" >
                        <input type="radio" class="inputradio"   [value]="true"
                        [(ngModel)]="service.is_PTO_Applied"> Yes
                        <input type="radio" class="inputradio" [value]="false"
                        [(ngModel)]="service.is_PTO_Applied"> No
                    </td>
                   
                    <td class="theadtd" >
                        <input type="radio" class="inputradio" value="true" [value]="true"
                        [(ngModel)]="service.is_Worker_Comp_Applied"/> Yes
                        <input type="radio" class="inputradio" value="false" [value]="false"
                        [(ngModel)]="service.is_Worker_Comp_Applied"> No
                        <!-- <input type="text" class="inputtext" *ngIf="service.is_Worker_Comp_Applied == true"
                        [(ngModel)]="service.percentageRate"> -->
                    </td>
                    <td class="theadtd"  ><label > {{service.totalCost!=null||service.totalCost!=undefined
                                        ||service.totalCost!=0 ? service.totalCost?.toFixed(2):service.totalCost}}</label></td>
                   
                </tr>
            
                <tr>
                    <td class="theadtd" style="text-align: right;">
                        Payroll Taxes
                    </td>

                    <td class="theadtd" colspan="3" >  PERCENTAGE OF PAYROLL TAXES &nbsp;
                         <input type="text" class="form-control"  [disabled]="logintype =='onboardLogin'"
                            [(ngModel)]="payrolltaxpercent" (ngModelChange)="calculateWorkercompAmt()">
                    </td>

                    <td class="theadtd" colspan="3" >PAYROLL WAGES &nbsp;
                        <input type="text" class="form-control"  disabled
                           [(ngModel)]="payrolltotal">
                   </td>
                   <td  class="theadtd" >
                    <input  type="text" class="form-control"  disabled
                       [(ngModel)]="payrollgrandtotal">
               </td>

                </tr>

                <tr>
                    <td class="theadtd" style="text-align: right;">
                        Paid time off (PTO)
                    </td>

                    <td class="theadtd" colspan="3" > PERCENTAGE OF PTO &nbsp;
                         <input type="text" class="form-control"  [disabled]="logintype =='onboardLogin'"
                            [(ngModel)]="ptotaxpercent" (ngModelChange)="calculateWorkercompAmt()">
                    </td>

                    <td class="theadtd" colspan="3" > PTO WAGES &nbsp;
                        <input type="text" class="form-control"  disabled
                           [(ngModel)]="ptototal">
                   </td>
                   <td   class="theadtd">
                    <input  type="text" class="form-control"  disabled
                       [(ngModel)]="ptograndtotal">
               </td>

                </tr>

                <tr>
                    <td class="theadtd" style="text-align: right;">
                       Workers' Compensation
                    </td>

                    <td class="theadtd" colspan="3" >PERCENTAGE OF WORKERS COMP&nbsp;
                         <input type="text" class="form-control"  [disabled]="logintype =='onboardLogin'"
                            [(ngModel)]="workertaxpercent"   (ngModelChange)="calculateWorkercompAmt()">
                    </td>

                    <td  class="theadtd" colspan="3" > WORKERS' COMP WAGES&nbsp;
                        <input type="text" class="form-control"  disabled
                           [(ngModel)]="Workercomptotal">
                   </td>
                   <td  class="theadtd" >
                    <input type="text" class="form-control"  disabled
                       [(ngModel)]="Workercompgrandtotal">
               </td>

                </tr>
                <tr>
                    <td class="theadtd"  colspan="7" style="text-align: right;">Grand Total</td>
                    <td class="theadtd" ><label  >

                        {{Workergrandtotal!=null||Workergrandtotal!=undefined
                                        ||Workergrandtotal!=0 ? Workergrandtotal?.toFixed(2):Workergrandtotal}}
                    </label></td>
                </tr>
                <tr *ngIf="Budgetwarning">
                    <td class="theadtd"  colspan="7" style="text-align: right;">
                        <span style="color: red;">WARNING: </span> You are over your worker budget by:
                    </td>
                       <td class="theadtd" ><label  >
                            {{warningAmount}}                        
                    </label></td>             
                
                </tr>
            </table>
            
        </div>
        <div class="section-title-info" *ngIf="serviceplanImportBO.modelTypename == 'BUDGET'
                                    &&serviceplanImportBO.fmsBudget.is_Personal_Care_Workers">Worker training and development</div>
        <div *ngIf="serviceplanImportBO.modelTypename == 'BUDGET'
                                    &&serviceplanImportBO.fmsBudget.is_Personal_Care_Workers">

<p class="f" *ngIf="serviceplanImportBO.modelTypename == 'BUDGET'
&&serviceplanImportBO.fmsBudget.is_Personal_Care_Workers"> As the employer of your workers, you are responsible to:</p>
            <ul>
                <li>Ensureyour workers are competent </li>
                <li>Train your workers</li>
                <li>Supervise and evaluate your workers.</li>
            </ul>
            <p class="f">Your consultation services provider will help you through these tasks as you carry out your plan.</p>
            <p class="f">List the tasks your workers will do and the qualifications or skills they need to be able to do each one . </p>
            
        </div>
            
        <div *ngIf="serviceplanImportBO.modelTypename == 'BUDGET' && serviceplanImportBO.fmsBudget.is_Personal_Care_Workers">
            <div>
                <table class="tablepdf" >
                    <tr>
                        <th class="theadtd"><b>Worker task</b></th>
                        <th class="theadtd" width="400px"><b>Qualification/skills</b></th>
                    </tr>
                    <tr *ngFor="let service of serviceplanImportBO.fmsBudget.workerTasks; let Contact = index">
                        <td class="theadtd" >
                            <textarea type="text" class="inputtext" [(ngModel)]="service.task" (change)="changefunction()"></textarea>
                        </td>
                        <td class="theadtd" >
                            <textarea type="text" class="inputtext" [(ngModel)]="service.qualifications" (change)="changefunction()"></textarea>
                        </td>
                       
                    </tr>
                </table>
            </div>
        </div>



        <div class="section-title-info" *ngIf="serviceplanImportBO.modelTypename == 'BUDGET'">
            Annual budget
            
        </div>
        
        <div *ngIf="serviceplanImportBO.modelTypename == 'BUDGET'">
            <table class="tablepdf" >
                <tr>
                    <td class="theadtd" >Goods and services (if applicable)</td>
                    <td class="theadtd" >
                        <label *ngIf="Goodsgrandtotal != 0 && Goodsgrandtotal != null">
                            $ {{ Goodsgrandtotal }}
                        </label>
                    </td>
                </tr>
                <tr>
                    <td class="theadtd" >Personal care  workers (if applicable)</td>
                    <td class="theadtd" >
                        <label *ngIf="Workergrandtotal != 0 && Workergrandtotal != null">
                            $ {{ Workergrandtotal }}
                        </label>
                    </td>
                </tr>
                <tr>
                    <td class="theadtd" >Estimated annual FMS fee</td>
                    <td class="theadtd" >
                        <label *ngIf="Fmsfee != 0 && Fmsfee != null">
                            $ {{ Fmsfee }}
                        </label>
                    </td>
                </tr>
                <tr>
                    <td class="theadtd" >PERS costs (if applicable)</td>
                    <td class="theadtd" >
                        <label *ngIf="mhcptotal != 0 && mhcptotal != null">
                            $ {{ mhcptotal }}
                        </label>
                    </td>
                </tr>
                <tr>
                    <td class="theadtd"  colspan="1">Grand Total</td>
                    <td class="theadtd" >
                        <label *ngIf="AnnualTotal != 0 && AnnualTotal != null">
                            $ {{ AnnualTotal }}
                        </label>
                    </td>
                </tr>
                <!-- <tr>
                    <td class="theadtd"  colspan="1" >Unused budget amount</td>
                    <td class="theadtd" >
                        <label *ngIf="Unusedbudget != 0 && Unusedbudget != null">
                            $ {{ Unusedbudget }}
                        </label>
                    </td>
                </tr> -->
            </table>
        </div>
        
        
        <p class="f"  *ngIf="serviceplanImportBO.modelTypename == 'BUDGET'"><b>Note:</b> The lead agency will add all unused budget dollars to support workers in your service agreement.</p>
         
        <div class="section-title-info" *ngIf="(serviceplanImportBO.modelTypename == 'BUDGET' && serviceplanImportBO.fmsBudget.is_Personal_Care_Workers == true) ||serviceplanImportBO.modelTypename == 'AGENCY'">Personal care Services</div>
        <div class="section-title" *ngIf="(serviceplanImportBO.modelTypename == 'BUDGET' && serviceplanImportBO.fmsBudget.is_Personal_Care_Workers == true) ||serviceplanImportBO.modelTypename == 'AGENCY'">Activities of daily living (ADLs)</div>

        <div class="row mt-1"
            *ngIf="(serviceplanImportBO.modelTypename == 'BUDGET' && serviceplanImportBO.fmsBudget.is_Personal_Care_Workers == true) || serviceplanImportBO.modelTypename == 'AGENCY'">
            <p>Enter a row:</p>
            <ul style="margin-left: 22px;">
                <li>All ADLs identified in your assessment results, even if you won't get help from a paid worker for that ADL.
                </li>
                <li>All other ADLs a paid worker will perform.</li>
            </ul>
        </div>
       
            <table class="tablepdf"  *ngIf="(serviceplanImportBO.modelTypename == 'BUDGET' && serviceplanImportBO.fmsBudget.is_Personal_Care_Workers == true) ||serviceplanImportBO.modelTypename == 'AGENCY'">
                <tr>
                    <th class="theadtd" >Assessed need</th>
                    <th class="theadtd">From whom?</th>
                    <th class="theadtd">What will the caregiver do?</th>
                    <th class="theadtd">How will the caregiver do it</th>
                </tr>
                <tr *ngFor="let service of aDls;let Contact=index">
                    <td class="theadtd" > <textarea style="width: 100%;height: 150px"  class="form-control"  [(ngModel)]="service.assesedNeed" (change)="changefunction()"></textarea></td>
                    <td class="theadtd" > <textarea style="width: 100%;height: 150px"  class="form-control"  [(ngModel)]="service.fromWhom" (change)="changefunction()"></textarea></td>
                    <td class="theadtd" > <textarea style="width: 100%;height: 150px"  class="form-control"  [(ngModel)]="service.what_will_Caregiver_do" (change)="changefunction()"></textarea></td>
                    <td class="theadtd" > <textarea style="width: 100%;height: 150px"  class="form-control"  [(ngModel)]="service.how_will_Caregiver_do" (change)="changefunction()"></textarea></td>
              
                    <!-- <td class="theadtd" >
                        <input type="text" class="inputtext" bindLabel="Key"
                        bindValue="Key" [(ngModel)]="service.assesedNeed">
                    </td>
                    <td class="theadtd" >
                        <input type="text" class="inputtext" bindLabel="Key"
                        bindValue="Key" [(ngModel)]="service.fromWhom">
                    </td>
                    <td class="theadtd" >
                        <input type="text" class="inputtext" [(ngModel)]="service.what_will_Caregiver_do">
                    </td>
                    <td class="theadtd" >
                        <input type="text" class="inputtext"  [(ngModel)]="service.how_will_Caregiver_do">
                    </td> -->
                </tr>
            </table>
          
            <div class="section-title-info" *ngIf="(serviceplanImportBO.modelTypename == 'BUDGET' && serviceplanImportBO.fmsBudget.is_Personal_Care_Workers == true) ||serviceplanImportBO.modelTypename == 'AGENCY'">Instrumental activities of daily living (IADLs)</div>
            <p>Enter a row for each IADL a paid worker will perform. You also can choose to include rows for IADLs an informal caregiver will perform.</p>
            <p class="f" *ngIf="(serviceplanImportBO.modelTypename == 'BUDGET' && serviceplanImportBO.fmsBudget.is_Personal_Care_Workers == true) ||serviceplanImportBO.modelTypename == 'AGENCY'">Examples of IADLs include meal planning and preparation, shopping for essential items, laundry, paying bills,
                communicating, assisting with community participation, driving.</p>
           <p *ngIf="(serviceplanImportBO.modelTypename == 'BUDGET' && serviceplanImportBO.fmsBudget.is_Personal_Care_Workers == true) ||serviceplanImportBO.modelTypename == 'AGENCY'"><b>Note:</b> IADLs are not covered for people under 18, with some exceptions. Ask your consultation services provider if you're not sure</p>

           <table class="tablepdf"  *ngIf="(serviceplanImportBO.modelTypename == 'BUDGET' && serviceplanImportBO.fmsBudget.is_Personal_Care_Workers == true) ||serviceplanImportBO.modelTypename == 'AGENCY'">
            <tr>
                <th class="theadtd">Need</th>
                <th class="theadtd">From whom?</th>
                <th class="theadtd">What will the caregiver do?</th>
                <th class="theadtd">How will the caregiver do it</th>
                
            </tr>
            <tr *ngFor="let service of instrumentalActivities;let Contact=index">
                <td class="theadtd" > <textarea style="width: 100%;height: 150px"  class="form-control"  [(ngModel)]="service.assesedNeed" (ngModelChange)="service.assesedNeed = $event; changefunction()"></textarea></td>
                 <td class="theadtd" > <textarea style="width: 100%;height: 150px"  class="form-control"  [(ngModel)]="service.fromwhom" (ngModelChange)="changefunction()"></textarea></td>
                <td class="theadtd" > <textarea style="width: 100%;height: 150px"  class="form-control"  [(ngModel)]="service.what_will_Caregiver_do" (ngModelChange)="changefunction()"></textarea></td>
                <td class="theadtd" > <textarea style="width: 100%;height: 150px"  class="form-control"  [(ngModel)]="service.how_will_Caregiver_do" (ngModelChange)="changefunction()"></textarea></td>
             
                <!-- <td class="theadtd" >
                    <input type="text" class="inputtext"  [(ngModel)]="service.assesedNeed">
                </td>
                <td class="theadtd" >
                    <input type="text" class="inputtext"  [(ngModel)]="service.what_will_Caregiver_do">
                </td>
                <td class="theadtd" >
                    <input type="text" class="inputtext"  [(ngModel)]="service.how_will_Caregiver_do">
                </td> -->
                
            </tr>
        </table>

        <div class="section-title-info" *ngIf="(serviceplanImportBO.modelTypename == 'BUDGET' && serviceplanImportBO.fmsBudget.is_Personal_Care_Workers == true) ||serviceplanImportBO.modelTypename == 'AGENCY'">Observation and redirection of behaviors</div>
        <div class="row" style="margin-top: 16px;" *ngIf="(serviceplanImportBO.modelTypename == 'BUDGET' && serviceplanImportBO.fmsBudget.is_Personal_Care_Workers == true) ||serviceplanImportBO.modelTypename == 'AGENCY'">
            <div>
                <label>Do you require observation and redirection?&nbsp;
                </label>
                <!--  Yes -->
                <span>
                    <input type="radio" class="inputradio" [value]="true"
                    [(ngModel)]="serviceplanImportBO.isRedirectionRequired" (change)="changefunction()">&nbsp;
                    <label class="label">
                        Yes</label>
                </span>&nbsp;
                <!-- No  -->
                <span>
                    <input type="radio" class="inputradio" [value]="false"
                    [(ngModel)]="serviceplanImportBO.isRedirectionRequired" (change)="changefunction()">&nbsp;
                    <label class="label">No
                    </label>
                </span>&nbsp;
            </div>
        </div>

        <div class="section-title-info" *ngIf="serviceplanImportBO.isRedirectionRequired">Redirection</div>
        <p *ngIf="serviceplanImportBO.isRedirectionRequired">Complete the following to document how you want your worker(s) to observe/redirect behaviors.</p>
         <table class="tablepdf"  *ngIf="serviceplanImportBO.isRedirectionRequired">
            <tr >

                <th class="theadtd">When I do:</th>
                <th class="theadtd">It means:</th>
                <th class="theadtd">
                    the worker can help by:
                </th>
            </tr>

            <tr *ngFor="let service of behaviours;let Contact=index">
                <td class="theadtd" > <textarea style="width: 100%;height: 150px"  class="form-control"  [(ngModel)]="service.when_I_do" (change)="changefunction()"></textarea></td>
                <td class="theadtd" > <textarea style="width: 100%;height: 150px"  class="form-control"  [(ngModel)]="service.it_means" (change)="changefunction()"></textarea></td>
                <td class="theadtd" > <textarea style="width: 100%;height: 150px"  class="form-control"  [(ngModel)]="service.worker_can_help_by" (change)="changefunction()"></textarea></td>
               
                <!-- <td class="theadtd" >
                    <input type="text" class="inputtext" [(ngModel)]="service.when_I_do">
                </td>
                <td class="theadtd" >
                    <input type="text" class="inputtext"  [(ngModel)]="service.it_means">
                </td>
                <td class="theadtd" >
                    <input type="text" class="inputtext" [(ngModel)]="service.worker_can_help_by">
                </td> -->
            </tr>

         </table>

         <div class="section-title-info" *ngIf="(serviceplanImportBO.modelTypename == 'BUDGET' && serviceplanImportBO.fmsBudget.is_Personal_Care_Workers == true) ||serviceplanImportBO.modelTypename == 'AGENCY'">Health-related procedures and tasks</div>
        <div class="row" style="margin-top: 16px;" *ngIf="(serviceplanImportBO.modelTypename == 'BUDGET' && serviceplanImportBO.fmsBudget.is_Personal_Care_Workers == true) ||serviceplanImportBO.modelTypename == 'AGENCY'">
            <div>
                <label>Do you require support with health-related procedures and tasks?&nbsp;
                </label>
                <!--  Yes -->
                <span>
                    <input type="radio" class="inputradio"  [value]="true"
                    [(ngModel)]="serviceplanImportBO.isHealthProceduresRequired" (change)="changefunction()">&nbsp;
                    <label class="label">
                        Yes</label>
                </span>&nbsp;
                <!-- No  -->
                <span>
                    <input type="radio" class="inputradio" [value]="false"
                    [(ngModel)]="serviceplanImportBO.isHealthProceduresRequired" (change)="changefunction()">&nbsp;
                    <label class="label">No
                    </label>
                </span>&nbsp;
            </div>
        </div>

        <p *ngIf="serviceplanImportBO.isHealthProceduresRequired">CFSS workers only can perform some health-related tasks. Your consultation services provider can tell you if a task is
            covered.</p>
         <table class="tablepdf"  *ngIf="serviceplanImportBO.isHealthProceduresRequired">
            <tr>

                <th class="theadtd">Need</th>
                <th class="theadtd">What will the worker do?</th>
                <th class="theadtd">
                    How will the worker do it?
                </th>
            </tr>

            <tr *ngFor="let service of healthProcedures;let Contact=index">
                <td class="theadtd" > <textarea style="width: 100%;height: 150px"  class="form-control"  [(ngModel)]="service.need" (change)="changefunction()"></textarea></td>
                <td class="theadtd" > <textarea style="width: 100%;height: 150px"  class="form-control"  [(ngModel)]="service.what_will_worker_do" (change)="changefunction()"></textarea></td>
                <td class="theadtd" > <textarea style="width: 100%;height: 150px"  class="form-control"  [(ngModel)]="service.how_will_worker_do" (change)="changefunction()"></textarea></td>
             
                <!-- <td class="theadtd" >
                    <input type="text" class="inputtext"  [(ngModel)]="service.need">
                </td>
                <td class="theadtd" >
                    <input type="text" class="inputtext"  [(ngModel)]="service.what_will_worker_do">
                </td>
                <td class="theadtd" >
                    <input type="text" class="inputtext"    [(ngModel)]="service.how_will_worker_do">
                </td> -->
            </tr>

         </table>

         <div class="section-title-info"  *ngIf="(serviceplanImportBO.modelTypename == 'BUDGET' && serviceplanImportBO.fmsBudget.is_Personal_Care_Workers == true) ||serviceplanImportBO.modelTypename == 'AGENCY'">Self-administered medications</div>

         <div class="row" style="margin-top: 16px;"  *ngIf="(serviceplanImportBO.modelTypename == 'BUDGET' && serviceplanImportBO.fmsBudget.is_Personal_Care_Workers == true) ||serviceplanImportBO.modelTypename == 'AGENCY'">
            <div>
                <label>Do you require support to take self-administered medications?&nbsp;
                </label>
                <!--  Yes -->
                <span>
                    <input type="radio" class="inputradio" [value]="true"
                    [(ngModel)]="serviceplanImportBO.isMedicationsRequired" (change)="changefunction()">&nbsp;
                    <label class="label">
                        Yes</label>
                </span>&nbsp;
                <!-- No  -->
                <span>
                    <input type="radio" class="inputradio" [value]="false"
                    [(ngModel)]="serviceplanImportBO.isMedicationsRequired" (change)="changefunction()">&nbsp;
                    <label class="label">No
                    </label>
                </span>&nbsp;
            </div>
        </div>
         
         <div class="section-title-info" *ngIf="serviceplanImportBO.isMedicationsRequired">Taking medication</div>
         
         <p *ngIf="serviceplanImportBO.isMedicationsRequired">When I need support, I will direct the worker to:</p>
         <div *ngIf="serviceplanImportBO.isMedicationsRequired">
             <input type="checkbox" id="check1"  [(ngModel)]="serviceplanImportBO.bringMedications" (change)="changefunction()" /> &nbsp; <b>Bring me my medications</b> <br>
             <input type="checkbox" id="check2" [(ngModel)]="serviceplanImportBO.bringMedicationItems" (change)="changefunction()" /> &nbsp;<b>Bring me items I need to take my medications (water, food, etc)</b> <br>
             <input type="checkbox" id="check3" [(ngModel)]="serviceplanImportBO.other" (change)="changefunction()" /> &nbsp;<b>Other</b>

             <textarea  style="width: 100%; height:230px"  *ngIf="serviceplanImportBO.other"  [disabled]="logintype =='onboardLogin'"
             [(ngModel)]="serviceplanImportBO.otherDetails"></textarea>

         </div>
         
         <p *ngIf="serviceplanImportBO.isMedicationsRequired">Describe your medication instructions (for example, "I need to take with food," "set out my meds this way," etc.)</p>
         <div class="row" *ngIf="serviceplanImportBO.isMedicationsRequired">
            <div class="col-lg-12">
                <textarea style="width: 100%; height:230px"   [(ngModel)]="serviceplanImportBO.medicationInstructionsDetails" (change)="changefunction()"></textarea>
            </div>
        </div>
         
         <p *ngIf="serviceplanImportBO.isMedicationsRequired" >What reminders about times do you need for medications?</p>
         <div class="row" *ngIf="serviceplanImportBO.isMedicationsRequired">
            <div class="col-lg-12">
                <textarea style="width: 100%; height:230px"   [(ngModel)]="serviceplanImportBO.medicationTimeReminders" (change)="changefunction()"></textarea>
            </div>
        </div>
         
         <h4 class="section-title-info" *ngIf="(serviceplanImportBO.modelTypename == 'BUDGET' && serviceplanImportBO.fmsBudget.is_Personal_Care_Workers == true) ||serviceplanImportBO.modelTypename == 'AGENCY'"><b>Skill maintenance and enhancement</b></h4>
         
         <div class="row" style="margin-top: 16px;" *ngIf="(serviceplanImportBO.modelTypename == 'BUDGET' && serviceplanImportBO.fmsBudget.is_Personal_Care_Workers == true) ||serviceplanImportBO.modelTypename == 'AGENCY'">
            <div>
                <label>Does your plan include skill maintenance and enhancement?&nbsp;
                </label>
                <!--  Yes -->
                <span>
                    <input type="radio" name="skillmaintain" class="inputradio" [value]="true"
                    [(ngModel)]="serviceplanImportBO.isSkillEnhancement_Included" (change)="changefunction()">&nbsp;
                    <label class="label">
                        Yes</label>
                </span>&nbsp;
                <!-- No  -->
                <span>
                    <input type="radio" name="skillmaintain" class="inputradio" [value]="false"
                    [(ngModel)]="serviceplanImportBO.isSkillEnhancement_Included" (change)="changefunction()">&nbsp;
                    <label class="label">No
                    </label>
                </span>&nbsp;
            </div>
        </div>
         
         <p  *ngIf="serviceplanImportBO.isSkillEnhancement_Included">Describe your plan</p>
         <div class="row"  *ngIf="serviceplanImportBO.isSkillEnhancement_Included">
            <div class="col-lg-12">
                <textarea style="width: 100%; height:230px"  [(ngModel)]="serviceplanImportBO.maintenancePlan" (change)="changefunction()"></textarea>
            </div>
        </div>
         
         <div class="section-title-info" *ngIf="(serviceplanImportBO.modelTypename == 'BUDGET' && serviceplanImportBO.fmsBudget.is_Personal_Care_Workers == true) ||serviceplanImportBO.modelTypename == 'AGENCY'">Classes</div>
        <div class="row mt-2 "
            *ngIf="(serviceplanImportBO.modelTypename == 'BUDGET' && serviceplanImportBO.fmsBudget.is_Personal_Care_Workers == true) ||serviceplanImportBO.modelTypename == 'AGENCY'">
            <label class="label ">This Section is Optional.</label>
        </div>
        <!-- <div class="row mt-2 "
            *ngIf="(serviceplanImportBO.modelTypename == 'BUDGET' && serviceplanImportBO.fmsBudget.is_Personal_Care_Workers == true) ||serviceplanImportBO.modelTypename == 'AGENCY'">
            <p> <b>Notes: </b>The provider agency can choose to document this information in another location.</p>
        </div> -->
         
         
         <div *ngIf="(serviceplanImportBO.modelTypename == 'BUDGET' && serviceplanImportBO.fmsBudget.is_Personal_Care_Workers == true) ||serviceplanImportBO.modelTypename == 'AGENCY'">
             <table class="tablepdf" >
                 <tr>
                     <th class="theadtd" ><b>Class name</b></th>
                     <th class="theadtd" ><b>Training provider</b></th>
                     <th class="theadtd" width="100px"><b>Cost</b></th>
                 </tr>
         
                 <tr *ngFor="let service of classes;let Contact=index">
                     <td class="theadtd" >
                         <input type="text" class="inputtext"  [(ngModel)]="service.className" (change)="changefunction()" />
                     </td>
                     <td class="theadtd" >
                         <input type="text" class="inputtext"  [(ngModel)]="service.trainingProvider" (change)="changefunction()" />
                     </td>
                     <td class="theadtd" >
                         <label > {{service.cost!=null||service.cost!=undefined
                                        ||service.costt!=0 ? service.cost?.toFixed(2):service.cost}}</label>
                     </td>
                 </tr>
         
                 <tr>
                     <td class="theadtd"  colspan="2"><b>Total</b></td>
                     <td class="theadtd" >
                         <input type="text" class="inputtext"   [(ngModel)]="classtotal" (change)="changefunction()" />
                     </td>
                 </tr>
             </table>
         </div>
          


         <div class="section-title-info"> Backup and emergency plans</div>
         <div class="section-title-info" *ngIf="(serviceplanImportBO.modelTypename =='BUDGET'? serviceplanImportBO?.fmsBudget?.is_Personal_Care_Workers : false)||   serviceplanImportBO.modelTypename == 'AGENCY'">Worker absences</div>
         <p class="f" *ngIf="(serviceplanImportBO.modelTypename =='BUDGET'? serviceplanImportBO?.fmsBudget?.is_Personal_Care_Workers : false)||   serviceplanImportBO.modelTypename == 'AGENCY'">What will you do if your worker does not show up for work?</p>
         <div class="row" *ngIf="(serviceplanImportBO.modelTypename =='BUDGET'? serviceplanImportBO?.fmsBudget?.is_Personal_Care_Workers : false)||   serviceplanImportBO.modelTypename == 'AGENCY'">
             <div class="col-lg-12">
                 <textarea style="width: 100%;height: 230px;"  [(ngModel)]="serviceplanImportBO.workerAbsencePlan"></textarea>
             </div>
         </div>
         <div class="section-title-info"> Medical emergencies</div>
         <p class="f">The following are signs I am having a medical emergency:
         </p>
         <div class="row">
             <div class="col-lg-12">
                 <textarea  [(ngModel)]="serviceplanImportBO.medicalEmergencySigns" style="width: 100%;height: 230px"></textarea>
             </div>
         </div>
         <p class="f">What are some special considerations to know regarding medical emergencies for me?
         </p>
         <div class="row">
             <div class="col-lg-12">
                 <textarea [(ngModel)]="serviceplanImportBO.medicalEmergencySpecialConsiderations" style="width: 100%;height: 230px"></textarea>
             </div>
         </div>
         
     <div class="section-title-info">Providers (optional)</div>
     <p class="f">These are my medical providers (doctors, physicians, nurse practitioner, etc.)</p>
         <table class="tablepdf" >
             <tr>
               <th class="theadtd" >NAME</th>
               <th class="theadtd" width="400px">SPECIALITY</th>
               
             </tr>
             <ng-container *ngFor="let service of serviceplanImportBO.providers; let Contact = index">

                <tr >
                    <td class="theadtd" ><textarea type="text" class="inputtext" [(ngModel)]="service.providerName"></textarea></td>
                    <td class="theadtd" ><textarea type="text" class="inputtext" [(ngModel)]="service.specialty"> </textarea></td>
                  
                  </tr>
                
             </ng-container>
             </table>
             <table class="tablepdf" >
             <tr>
                <th class="theadtd" width="200px">PHONE NUMBER</th>
               <th class="theadtd" >ADDRESS</th>
             </tr>
             <ng-container *ngFor="let service of serviceplanImportBO.providers; let Contact = index">

               
                  <tr>
                    <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="service.phoneNumber" /></td>
                    <td class="theadtd" ><textarea type="text" class="inputtext" [(ngModel)]="service.address"></textarea></td>
                  </tr>
             </ng-container>
             
           </table>
           
     
         <div class="section-title-info">How to respond to medical emergencies</div>
     
         <table class="tablepdf" >
             <tr>
                 <th class="theadtd" width="200px">If this happens</th>
                 <th class="theadtd" width="200px">Contact</th>
                 <th class="theadtd" width="200px">Special instruction</th>
             </tr>
             <tr *ngFor="let service of  serviceplanImportBO.medicalEmergencies;let Contact=index">
               <td class="theadtd" > <textarea style="width: 100%;height: 150px"  class="form-control"  [(ngModel)]="service.if_this_happens"></textarea></td>
               <td class="theadtd" > <textarea style="width: 100%;height: 150px"  class="form-control"  [(ngModel)]="service.contact"></textarea></td>
               <td class="theadtd" > <textarea style="width: 100%;height: 150px"  class="form-control"  [(ngModel)]="service.specialInstructions"></textarea></td>
                
                 <!-- <td class="theadtd" ><input type="text" class="inputtext"  [(ngModel)]="service.if_this_happens"></td>
                 <td class="theadtd" ><input type="text" class="inputtext"  [(ngModel)]="service.contact"></td>
                 <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="service.specialInstructions"></td> -->
     
             </tr>
         </table>
            <div class="section-title-info">Non-medical emergencies</div>
            <div class="section-title-info">How to respond</div>
            <table class="tablepdf" >
                <tr>
                    <th class="theadtd" width="200px">Situation</th>
                    <th class="theadtd" >Special instructions</th>
                </tr>
                <tr style="border: 1px gray;"
                *ngFor="let service of  serviceplanImportBO?.nonMedicalEmergencies;let Contact=index">
                <td class="theadtd"  width="200px">
                    <textarea style="height: 150px"  class="form-control"  [(ngModel)]="service.situation"></textarea>
                
                    <!-- <input type="text" class="inputtext" class="form-control"                        
                        [(ngModel)]="service.situation"> -->
                </td>
                <td class="theadtd" >
                    <textarea style="width: 100%;height: 150px"  class="form-control"  [(ngModel)]="service.special_Instructions"></textarea>
                
                 
                </td>
            </tr>
            </table>
            <div class="section-title-info">Individual abuse prevention plan <span>(leave this section blank if agency model)</span></div>
            <div class="row mt -2">
                <label class="label">
                    Complete this section with your provider agency.
                </label>
            </div>
            <div class="row mt-1">
                <p><b>Notes: </b> The provider agency can choose to document these answers in another location.</p>
            
            </div>
            <!-- Are there any ways you are vulnerable to abuse by others? -->
            <div  *ngIf="serviceplanImportBO.modelTypename == 'BUDGET'">
                <span><input type="checkbox"  [(ngModel)]="serviceplanImportBO.fmsBudget.is_Prevention_Explained"></span> &nbsp; <span> <p>My consultation services provider explained
                    what abuse and neglect are and discussed my options for
                    seeking help</p></span> 
            </div>
            <!-- <div  *ngIf="serviceplanImportBO.modelTypename == 'AGENCY'">
                <label class="label "> (Complete this question with your provider agency)</label>
                    </div> -->


            <p class="f">Are there any ways you are vulnerable to abuse by others?
            </p>
            
            <div class="row">
                <div class="col-lg-12">
                    <textarea style="width: 100%;height: 230px" [(ngModel)]="serviceplanImportBO.vulnerabilitiesToAbuse"></textarea>
                </div>
            </div>
            <!-- Are you at risk of abusing others? -->
            <p class="f">Are you at risk of abusing others?
            </p>
         
           
            <div class="row">
                <div class="col-lg-12">
                    <textarea style="width: 100%;height: 230px"
                    [(ngModel)]="serviceplanImportBO.riskOfAbusingOthers"></textarea>
                </div>
            </div>
            <!-- What are some ways you and others can keep you safe from abuse? -->
            <p class="f">What are some ways you and others can keep you safe from abuse?
            </p>
            
            <div class="row">
                <div class="col-lg-12">
                    <textarea style="width: 100%;height: 230px" [(ngModel)]="serviceplanImportBO.safetyStrategies"></textarea>
                </div>
            </div>
            <!-- What will you do if you experience abuse? -->

            <p class="f">What will you do if you experience abuse?
            </p>
    
            <div class="row">
                <div class="col-lg-12">
                    <textarea style="width: 100%;height: 230px"  [(ngModel)]="serviceplanImportBO.actionPlanIfAbused"></textarea>
                </div>
            </div>
                <div class="row mt-3 ">
                    <h4 class=" font-header" id="exampleModalLabel"><b>Additional notes
                        </b></h4>
                </div>
                <div class="row mt-2">
                    <label class="label">COMMENTS/NOTES</label>
                    <textarea style="width: 100%;height: 230px" class="form-control" cols="190" [disabled]="logintype =='onboardLogin'"
                        [(ngModel)]="serviceplanImportBO.additionalNotes"></textarea>
                
                </div>
            <!-- Signatures -->
             
            <div class="section-title-info">Signatures</div>
            <!-- <div class="row mt-2 ">
                <label class="label ">I understand the start date of my CFSS service delivery plan is the date the lead agency approves my CFSS service
                    delivery plan. I understand the lead agency might need to adjust my units/dollars based on the approval date. The
                    lead agency will adjust the personal care line, if needed.</label>
           </div> -->
            <div class="row">
                <div class="col-lg-12">
        
                    <table class="tablepdf" >
                        <tr>
                            <th class="theadtd" width="200px">PERSON WHO ACCESSES SERVICES</th>
                            <th class="theadtd" width="200px">DATE</th>
        
                        </tr>
                        <tr>
                            <td class="theadtd" >
                                <!-- <img [src]="personwhoaccess_sign"   style="height:80px;"/> -->
                                
                                <img *ngIf="personwhoaccess_sign!='' && personwhoaccess_sign!= null " type="image"
                                src="{{personwhoaccess_sign}}" class="form-control mt-3 "
                                style="width: 179px;height:80px;" alt="pca" width="48"
                                height="48" />
                            </td>
                            <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="personwhoaccess_signDate"></td>
                            
                        </tr>
                    </table>
                </div>
                <div class="col-lg-12">
        
                    <table class="tablepdf" >
                        <tr>
                            <th class="theadtd" width="200px">PARENT/PARTICIPANT'S REPRESENTATIVE/MANAGING PARTY</th>
                            <th class="theadtd" width="200px">DATE</th>
        
                        </tr>
                        <tr>

                            <td class="theadtd" >
                                <img *ngIf="parent_sign!='' && parent_sign != null" type="image"
                                src="{{parent_sign}}" class="form-control mt-3 "
                                style="width: 179px;height:80px;" alt="pca" width="48"
                                height="48" />
                                  <!-- <img src="{{parent_sign}}"   style="height:80px;"/> -->
                               </td>
                           
                            <td class="theadtd">
                                <input type="text" class="inputstylebg" [(ngModel)]="parent_signDate" (change)="changefunction()">
                            </td>
        
                        </tr>
                    </table>
        
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
        
                    <table class="tablepdf" >
                        <tr>
                            <th class="theadtd" width="200px">CONSULTATION SERVICES PROVIDER</th>
                            <th class="theadtd" width="200px">DATE</th>
        
                        </tr>
                        <tr>
                          
                            
                                <td class="theadtd" >
                                    <img *ngIf="provider_sign!='' && provider_sign !=null" type="image"
                                src="{{provider_sign}}" class="form-control mt-3 "
                                style="width: 179px;height:80px;" alt="pca" width="48"
                                height="48" />
                                

                                      <!-- <img [src]="provider_sign"   style="height:80px;"/> -->
                                  </td>
                            <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="provider_signDate" (change)="changefunction()"></td>
        
                        </tr>
                    </table>
        
                </div>
                <!-- <div class="col-lg-12">
        
                    <table class="tablepdf" >
                        <tr>
                            <th class="theadtd" width="200px">LEAD AGENCY STAFF MEMBER</th>
                            <th class="theadtd" width="200px">DATE</th>
        
                        </tr>
                        <tr>
                            <td class="theadtd" >
                                <img *ngIf="agencystaff_sign!='' && agencystaff_sign != null" type="image"
                                src="{{agencystaff_sign}}" class="form-control mt-3 "
                                style="width: 179px;height:80px;" alt="pca" width="48"
                                height="48" />

                            
                            </td>
                            <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="agencystaff_signDate"></td>
        
                        </tr>
                    </table>
        
                </div> -->
            </div>
            <div class="section-title-info">Summary of CFSS individual service delivery plan</div>
            <div class="row">
                <div class="col-lg-12">
                    <table class="tablepdf" >
                        <tr>
                            <th class="theadtd" width="200px">PERSON'S LAST NAME</th>
                            <th class="theadtd" width="200px">PMI</th>
                            <th class="theadtd" width="200px">DATE OF BIRTH</th>
                        </tr>
                        <tr>
                            <td class="theadtd" ><input type="text" class="inputtext"[(ngModel)]="serviceplanImportBO.personLastName"></td>
                            <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="serviceplanImportBO.personPmi"></td>
                            <td class="theadtd" ><input type="text" class="inputtext" [(ngModel)]="clientdob"></td>
                        </tr>
                    </table>
                </div>
            </div>

            <div *ngIf="serviceplanImportBO.modelTypename == 'BUDGET'">
                <div class="section-title-info">Budget model</div>

                <table class="tablepdf" >
                    <tr>
                        <th>
                            <b>ITEM</b>
                        </th>
                        <th>
                            <b>Amount</b>
                        </th>
                    </tr>

                    <tr>
                    <td class="theadtd" >Personal care (T1019 UB)</td>
                    <td class="theadtd" > <label *ngIf="Workergrandtotal !=0 && Workergrandtotal!= null"> $ {{Workergrandtotal}}</label></td>
                    </tr>

                    <tr>
                        <td class="theadtd" >Goods and services (T5999 UB)</td>
                        <td class="theadtd" >
                            <label class="label" *ngIf="Goodsgrandtotal !=0 && Goodsgrandtotal!= null"> $ {{Goodsgrandtotal}}</label>
                        </td>
                    </tr>
                    <tr >
                        <td class="theadtd" >PERS equipment (S5162 UB)
                        </td>
                        <td class="theadtd" >
                            <label class="label" *ngIf="serviceplanImportBO.mhcpCost.equipment_Cost !=0 && serviceplanImportBO.mhcpCost.equipment_Cost!= null">$ {{serviceplanImportBO.mhcpCost.equipment_Cost}}</label>
                        </td>

                    </tr>
                    <tr >
                        <td class="theadtd" >PERS installation (S5160 UB)
                        </td>
                        <td class="theadtd" >
                            <label class="label" *ngIf="serviceplanImportBO.mhcpCost.installation_Cost !=0 && serviceplanImportBO.mhcpCost.installation_Cost!= null">$ {{serviceplanImportBO.mhcpCost.installation_Cost}}</label>
                        </td>

                    </tr>
                    <tr >
                        <td class="theadtd" >PERS monthly subscription (S5161 UB)
                        </td>
                        <td class="theadtd" >
                            <label class="label" *ngIf="serviceplanImportBO.mhcpCost.subscription_Cost !=0 && serviceplanImportBO.mhcpCost.subscription_Cost!= null">$ {{serviceplanImportBO.mhcpCost.subscription_Cost}}</label>
                      
                        </td>

                    </tr>

                    <tr >
                        <td class="theadtd" >FMS (T2040 UB UA)
                        </td>
                        <td class="theadtd" >
                            <label class="label" *ngIf="Fmsfee !=0 && Fmsfee!= null">$ {{Fmsfee}}</label>
                        </td>

                    </tr>

                    <tr >
                        <td class="theadtd" ><b>Total <p class="error" *ngIf="AnnualTotal > serviceplanImportBO.fmsBudget.budgetAmount" > (Over Budget)</b>
                        </td>
                        <td class="theadtd" >
                            <label class="label" *ngIf="AnnualTotal !=0 && AnnualTotal!= null">$ {{AnnualTotal}}</label>
                        </td>

                    </tr>

                    <tr style="border: 1px gray;">
                        <td class="theadtd">Consultation services (T1023)</td>
                        <td class="theadtd">
                            <label class="label" > (six sessions) </label>
                        </td>

                    </tr>

                    <tr style="border: 1px gray;">
                        <td class="theadtd">Worker training and development (S5116)</td>
                        <td class="theadtd">
                            <label class="label" >$ 1328.64</label>
                        </td>

                    </tr>



                </table>

            </div>
            <div class="section-title-info" *ngIf="serviceplanImportBO.modelTypename == 'AGENCY'">Agency model</div>
            <div   *ngIf="serviceplanImportBO.modelTypename == 'AGENCY'">
                
                    <table class="tablepdf"  >

                        <tr >
                            <th>
                                <b>Item</b>
                            </th>
                            <th>
                                <b>Amount</b>
                            </th>

                        </tr>

                        <tr >
                            <td class="theadtd" >Personal care (T1019 U9)
                            </td>
                            <td class="theadtd" >
                                <label class="label" *ngIf="serviceplanImportBO.totalCFSSUnitsEligible !=0 && serviceplanImportBO.totalCFSSUnitsEligible != null">  {{serviceplanImportBO.totalCFSSUnitsEligible}}</label>
                       
                            </td>





                        </tr>
                        <tr >
                            <td class="theadtd" >Goods and services (T5999 U9)
                            </td>
                            <td class="theadtd" >
                                <label class="label" *ngIf="Goodsgrandtotal !=0 && Goodsgrandtotal!= null"> $ {{Goodsgrandtotal}}</label>
                       
                            </td>

                        </tr>
                        <tr >
                            <td class="theadtd" >PERS equipment (S5162 U9)
                            </td>
                            <td class="theadtd" >
                                <label class="label" *ngIf="serviceplanImportBO.mhcpCost.equipment_Cost !=0 && serviceplanImportBO.mhcpCost.equipment_Cost!= null">$ {{serviceplanImportBO.mhcpCost.equipment_Cost}}</label>
                            </td>

                        </tr>
                        <tr >
                            <td class="theadtd" >PERS installation (S5160 U9)
                            </td>
                            <td class="theadtd" >
                                <label class="label" *ngIf="serviceplanImportBO.mhcpCost.installation_Cost !=0 && serviceplanImportBO.mhcpCost.installation_Cost!= null">$ {{serviceplanImportBO.mhcpCost.installation_Cost}}</label>
                            </td>

                        </tr>
                        <tr >
                            <td class="theadtd" >PERS monthly subscription (S5161 U9)
                            </td>
                            <td class="theadtd" >
                                <label class="label" *ngIf="serviceplanImportBO.mhcpCost.subscription_Cost !=0 && serviceplanImportBO.mhcpCost.subscription_Cost!= null">$ {{serviceplanImportBO.mhcpCost.subscription_Cost}}</label>
                            </td>

                        </tr>

                        <!-- <tr style="border: 1px gray;">
                            <td class="theadtd" >FMS (T2040 UB UA)
                            </td>
                            <td class="theadtd" >
                                <input type="text" class="inputtext" class="form-control">
                            </td>

                        </tr>

                        <tr style="border: 1px gray;">
                            <td class="theadtd" ><b>Total</b>
                            </td>
                            <td class="theadtd" >
                                <input type="text" class="inputtext" class="form-control">
                            </td>

                        </tr> -->

                        <tr style="border: 1px gray;">
                            <td class="theadtd">Consultation services (T1023)</td>
                            <td class="theadtd">
                                <label class="label" > (six sessions) </label>
                            </td>
    
                        </tr>
    
                        <tr style="border: 1px gray;">
                            <td class="theadtd">Worker training and development (S5116)</td>
                            <td class="theadtd">
                                <label class="label" >$ 1328.64</label>
                            </td>
    
                        </tr>
    

                    </table>
                </div>

                <div class="row mt-3 " *ngIf="serviceplanImportBO.modelTypename == 'BUDGET' || serviceplanImportBO.modelTypename == 'AGENCY'">
                    <div class="card mt-3">
                        <div class="card-body">

                            <label>LEAD AGENCY COMMENTS
                            </label>
                            <textarea  [(ngModel)]="serviceplanImportBO.leadAgencyComments" style="width: 100%; height:230px" ></textarea>

                            </div>
                        </div>

                    </div>
                <div class="row mt-3 "
                    *ngIf="serviceplanImportBO.modelTypename == 'BUDGET' || serviceplanImportBO.modelTypename == 'AGENCY'">
                    <label><b>NOTES: </b></label>
                    <label>1.The service agreement must include T1023 (consultation services) and S5116 (worker training and
                        development) if the person is using T1019 (personal care).</label>
                    <label>2.The person's service agreement may require additional MMIS modifiers based on their circumstances.</label>
                </div>
<!---------------------------------------close Aleart-------------------------------------------------------------------->
 

        </div>
        </div>
        </body>
    </kendo-pdf-export>
</div>
 <span id="cancelsdpmodal" data-bs-toggle="modal" data-bs-target="#CloseModal"></span>
  <div class="modal fade" id="CloseModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog create-update-zip " role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font-header" id="exampleModalLabel">Close</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>
        <div class="modal-body">
          You want to close without save?
        </div>
        <div class="modal-footer">
          <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal"
            (click)="closeFun()"
            >Yes</button>
          <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">No</button>
        </div>
      </div>
    </div>
  </div>
